window.insertVariantMap = {

    "Courtyard motif 3": {
        
          "iPhone 12-Base": "47432559132908",
        
          "iPhone 12-Pro": "47432559165676",
        
          "iPhone 12-Pro Max": "47432559198444",
        
          "iPhone 12-Mini": "47432559231212",
        
          "iPhone 13-Base": "47432559263980",
        
          "iPhone 13-Pro": "47432559296748",
        
          "iPhone 13-Pro Max": "47432559329516",
        
          "iPhone 13-Mini": "47432559362284",
        
          "iPhone 14-Base": "47432559395052",
        
          "iPhone 14-Pro": "47432559427820",
        
          "iPhone 14-Pro Max": "47432559460588",
        
          "iPhone 14-Plus": "47432559493356",
        
          "iPhone 15-Base": "47432559526124",
        
          "iPhone 15-Pro": "47432559558892",
        
          "iPhone 15-Pro Max": "47432559591660",
        
          "iPhone 15-Plus": "47432559624428",
        
          "iPhone 16-Base": "47432559657196",
        
          "iPhone 16-Pro": "47432559689964",
        
          "iPhone 16-Pro Max": "47432559722732",
        
          "iPhone 16-Plus": "47432559755500",
        
          "iPhone 16-E": "47432559788268",
        
          "iPhone 17-Base": "47432559821036",
        
          "iPhone 17-Pro": "47432559853804",
        
          "iPhone 17-Pro Max": "47432559886572",
        
          "iPhone 17-Air": "47432559919340"
        
      },
    
      "Courtyard motif 2": {
        
          "iPhone 12-Base": "47432563294444",
        
          "iPhone 12-Pro": "47432563327212",
        
          "iPhone 12-Pro Max": "47432563359980",
        
          "iPhone 12-Mini": "47432563392748",
        
          "iPhone 13-Base": "47432563425516",
        
          "iPhone 13-Pro": "47432563458284",
        
          "iPhone 13-Pro Max": "47432563491052",
        
          "iPhone 13-Mini": "47432563523820",
        
          "iPhone 14-Base": "47432563556588",
        
          "iPhone 14-Pro": "47432563589356",
        
          "iPhone 14-Pro Max": "47432563622124",
        
          "iPhone 14-Plus": "47432563654892",
        
          "iPhone 15-Base": "47432563687660",
        
          "iPhone 15-Pro": "47432563720428",
        
          "iPhone 15-Pro Max": "47432563753196",
        
          "iPhone 15-Plus": "47432563785964",
        
          "iPhone 16-Base": "47432563818732",
        
          "iPhone 16-Pro": "47432563851500",
        
          "iPhone 16-Pro Max": "47432563884268",
        
          "iPhone 16-Plus": "47432563917036",
        
          "iPhone 16-E": "47432563949804",
        
          "iPhone 17-Base": "47432563982572",
        
          "iPhone 17-Pro": "47432564015340",
        
          "iPhone 17-Pro Max": "47432564048108",
        
          "iPhone 17-Air": "47432564080876"
        
      },
    
      "Courtyard motif 1": {
        
          "iPhone 12-Base": "47432566341868",
        
          "iPhone 12-Pro": "47432566374636",
        
          "iPhone 12-Pro Max": "47432566407404",
        
          "iPhone 12-Mini": "47432566440172",
        
          "iPhone 13-Base": "47432566472940",
        
          "iPhone 13-Pro": "47432566505708",
        
          "iPhone 13-Pro Max": "47432566538476",
        
          "iPhone 13-Mini": "47432566571244",
        
          "iPhone 14-Base": "47432566604012",
        
          "iPhone 14-Pro": "47432566636780",
        
          "iPhone 14-Pro Max": "47432566669548",
        
          "iPhone 14-Plus": "47432566702316",
        
          "iPhone 15-Base": "47432566735084",
        
          "iPhone 15-Pro": "47432566767852",
        
          "iPhone 15-Pro Max": "47432566800620",
        
          "iPhone 15-Plus": "47432566833388",
        
          "iPhone 16-Base": "47432566866156",
        
          "iPhone 16-Pro": "47432566898924",
        
          "iPhone 16-Pro Max": "47432566931692",
        
          "iPhone 16-Plus": "47432566964460",
        
          "iPhone 16-E": "47432566997228",
        
          "iPhone 17-Base": "47432567029996",
        
          "iPhone 17-Pro": "47432567062764",
        
          "iPhone 17-Pro Max": "47432567095532",
        
          "iPhone 17-Air": "47432567128300"
        
      },
    
      "Safavid garden tile 1": {
        
          "iPhone 12-Base": "47432568799468",
        
          "iPhone 12-Pro": "47432568832236",
        
          "iPhone 12-Pro Max": "47432568865004",
        
          "iPhone 12-Mini": "47432568897772",
        
          "iPhone 13-Base": "47432568930540",
        
          "iPhone 13-Pro": "47432568963308",
        
          "iPhone 13-Pro Max": "47432568996076",
        
          "iPhone 13-Mini": "47432569028844",
        
          "iPhone 14-Base": "47432569061612",
        
          "iPhone 14-Pro": "47432569094380",
        
          "iPhone 14-Pro Max": "47432569127148",
        
          "iPhone 14-Plus": "47432569159916",
        
          "iPhone 15-Base": "47432569192684",
        
          "iPhone 15-Pro": "47432569225452",
        
          "iPhone 15-Pro Max": "47432569258220",
        
          "iPhone 15-Plus": "47432569290988",
        
          "iPhone 16-Base": "47432569323756",
        
          "iPhone 16-Pro": "47432569356524",
        
          "iPhone 16-Pro Max": "47432569389292",
        
          "iPhone 16-Plus": "47432569422060",
        
          "iPhone 16-E": "47432569454828",
        
          "iPhone 17-Base": "47432569487596",
        
          "iPhone 17-Pro": "47432569520364",
        
          "iPhone 17-Pro Max": "47432569553132",
        
          "iPhone 17-Air": "47432569585900"
        
      },
    
      "Safavid garden tile 2": {
        
          "iPhone 12-Base": "47432572436716",
        
          "iPhone 12-Pro": "47432572469484",
        
          "iPhone 12-Pro Max": "47432572502252",
        
          "iPhone 12-Mini": "47432572535020",
        
          "iPhone 13-Base": "47432572567788",
        
          "iPhone 13-Pro": "47432572600556",
        
          "iPhone 13-Pro Max": "47432572633324",
        
          "iPhone 13-Mini": "47432572666092",
        
          "iPhone 14-Base": "47432572698860",
        
          "iPhone 14-Pro": "47432572731628",
        
          "iPhone 14-Pro Max": "47432572764396",
        
          "iPhone 14-Plus": "47432572797164",
        
          "iPhone 15-Base": "47432572829932",
        
          "iPhone 15-Pro": "47432572862700",
        
          "iPhone 15-Pro Max": "47432572895468",
        
          "iPhone 15-Plus": "47432572928236",
        
          "iPhone 16-Base": "47432572961004",
        
          "iPhone 16-Pro": "47432572993772",
        
          "iPhone 16-Pro Max": "47432573026540",
        
          "iPhone 16-Plus": "47432573059308",
        
          "iPhone 16-E": "47432573092076",
        
          "iPhone 17-Base": "47432573124844",
        
          "iPhone 17-Pro": "47432573157612",
        
          "iPhone 17-Pro Max": "47432573190380",
        
          "iPhone 17-Air": "47432573223148"
        
      },
    
      "Safavid garden tile 3": {
        
          "iPhone 12-Base": "47432574238956",
        
          "iPhone 12-Pro": "47432574271724",
        
          "iPhone 12-Pro Max": "47432574304492",
        
          "iPhone 12-Mini": "47432574337260",
        
          "iPhone 13-Base": "47432574370028",
        
          "iPhone 13-Pro": "47432574402796",
        
          "iPhone 13-Pro Max": "47432574435564",
        
          "iPhone 13-Mini": "47432574468332",
        
          "iPhone 14-Base": "47432574501100",
        
          "iPhone 14-Pro": "47432574533868",
        
          "iPhone 14-Pro Max": "47432574566636",
        
          "iPhone 14-Plus": "47432574599404",
        
          "iPhone 15-Base": "47432574632172",
        
          "iPhone 15-Pro": "47432574664940",
        
          "iPhone 15-Pro Max": "47432574697708",
        
          "iPhone 15-Plus": "47432574730476",
        
          "iPhone 16-Base": "47432574763244",
        
          "iPhone 16-Pro": "47432574796012",
        
          "iPhone 16-Pro Max": "47432574828780",
        
          "iPhone 16-Plus": "47432574861548",
        
          "iPhone 16-E": "47432574894316",
        
          "iPhone 17-Base": "47432574927084",
        
          "iPhone 17-Pro": "47432574959852",
        
          "iPhone 17-Pro Max": "47432574992620",
        
          "iPhone 17-Air": "47432575025388"
        
      },
    
      "Safavid garden tile 4": {
        
          "iPhone 12-Base": "47432577810668",
        
          "iPhone 12-Pro": "47432577843436",
        
          "iPhone 12-Pro Max": "47432577876204",
        
          "iPhone 12-Mini": "47432577908972",
        
          "iPhone 13-Base": "47432577941740",
        
          "iPhone 13-Pro": "47432577974508",
        
          "iPhone 13-Pro Max": "47432578007276",
        
          "iPhone 13-Mini": "47432578040044",
        
          "iPhone 14-Base": "47432578072812",
        
          "iPhone 14-Pro": "47432578105580",
        
          "iPhone 14-Pro Max": "47432578138348",
        
          "iPhone 14-Plus": "47432578171116",
        
          "iPhone 15-Base": "47432578203884",
        
          "iPhone 15-Pro": "47432578236652",
        
          "iPhone 15-Pro Max": "47432578269420",
        
          "iPhone 15-Plus": "47432578302188",
        
          "iPhone 16-Base": "47432578334956",
        
          "iPhone 16-Pro": "47432578367724",
        
          "iPhone 16-Pro Max": "47432578400492",
        
          "iPhone 16-Plus": "47432578433260",
        
          "iPhone 16-E": "47432578466028",
        
          "iPhone 17-Base": "47432578498796",
        
          "iPhone 17-Pro": "47432578531564",
        
          "iPhone 17-Pro Max": "47432578564332",
        
          "iPhone 17-Air": "47432578597100"
        
      },
    
      "Islimi 1": {
        
          "iPhone 12-Base": "47432582299884",
        
          "iPhone 12-Pro": "47432582332652",
        
          "iPhone 12-Pro Max": "47432582365420",
        
          "iPhone 12-Mini": "47432582398188",
        
          "iPhone 13-Base": "47432582430956",
        
          "iPhone 13-Pro": "47432582463724",
        
          "iPhone 13-Pro Max": "47432582496492",
        
          "iPhone 13-Mini": "47432582529260",
        
          "iPhone 14-Base": "47432582562028",
        
          "iPhone 14-Pro": "47432582594796",
        
          "iPhone 14-Pro Max": "47432582627564",
        
          "iPhone 14-Plus": "47432582660332",
        
          "iPhone 15-Base": "47432582693100",
        
          "iPhone 15-Pro": "47432582725868",
        
          "iPhone 15-Pro Max": "47432582758636",
        
          "iPhone 15-Plus": "47432582791404",
        
          "iPhone 16-Base": "47432582824172",
        
          "iPhone 16-Pro": "47432582856940",
        
          "iPhone 16-Pro Max": "47432582889708",
        
          "iPhone 16-Plus": "47432582922476",
        
          "iPhone 16-E": "47432582955244",
        
          "iPhone 17-Base": "47432582988012",
        
          "iPhone 17-Pro": "47432583020780",
        
          "iPhone 17-Pro Max": "47432583053548",
        
          "iPhone 17-Air": "47432583086316"
        
      },
    
      "Islimi 2": {
        
          "iPhone 12-Base": "47432584233196",
        
          "iPhone 12-Pro": "47432584265964",
        
          "iPhone 12-Pro Max": "47432584298732",
        
          "iPhone 12-Mini": "47432584331500",
        
          "iPhone 13-Base": "47432584364268",
        
          "iPhone 13-Pro": "47432584397036",
        
          "iPhone 13-Pro Max": "47432584429804",
        
          "iPhone 13-Mini": "47432584462572",
        
          "iPhone 14-Base": "47432584495340",
        
          "iPhone 14-Pro": "47432584528108",
        
          "iPhone 14-Pro Max": "47432584560876",
        
          "iPhone 14-Plus": "47432584593644",
        
          "iPhone 15-Base": "47432584626412",
        
          "iPhone 15-Pro": "47432584659180",
        
          "iPhone 15-Pro Max": "47432584691948",
        
          "iPhone 15-Plus": "47432584724716",
        
          "iPhone 16-Base": "47432584757484",
        
          "iPhone 16-Pro": "47432584790252",
        
          "iPhone 16-Pro Max": "47432584823020",
        
          "iPhone 16-Plus": "47432584855788",
        
          "iPhone 16-E": "47432584888556",
        
          "iPhone 17-Base": "47432584921324",
        
          "iPhone 17-Pro": "47432584954092",
        
          "iPhone 17-Pro Max": "47432584986860",
        
          "iPhone 17-Air": "47432585019628"
        
      },
    
      "Islimi + Khatai work 1": {
        
          "iPhone 12-Base": "47432587903212",
        
          "iPhone 12-Pro": "47432587935980",
        
          "iPhone 12-Pro Max": "47432587968748",
        
          "iPhone 12-Mini": "47432588001516",
        
          "iPhone 13-Base": "47432588034284",
        
          "iPhone 13-Pro": "47432588067052",
        
          "iPhone 13-Pro Max": "47432588099820",
        
          "iPhone 13-Mini": "47432588132588",
        
          "iPhone 14-Base": "47432588165356",
        
          "iPhone 14-Pro": "47432588198124",
        
          "iPhone 14-Pro Max": "47432588230892",
        
          "iPhone 14-Plus": "47432588263660",
        
          "iPhone 15-Base": "47432588296428",
        
          "iPhone 15-Pro": "47432588329196",
        
          "iPhone 15-Pro Max": "47432588361964",
        
          "iPhone 15-Plus": "47432588394732",
        
          "iPhone 16-Base": "47432588427500",
        
          "iPhone 16-Pro": "47432588460268",
        
          "iPhone 16-Pro Max": "47432588493036",
        
          "iPhone 16-Plus": "47432588525804",
        
          "iPhone 16-E": "47432588558572",
        
          "iPhone 17-Base": "47432588591340",
        
          "iPhone 17-Pro": "47432588624108",
        
          "iPhone 17-Pro Max": "47432588656876",
        
          "iPhone 17-Air": "47432588689644"
        
      },
    
      "Islimi + Khatai work 2": {
        
          "iPhone 12-Base": "47432589377772",
        
          "iPhone 12-Pro": "47432589410540",
        
          "iPhone 12-Pro Max": "47432589443308",
        
          "iPhone 12-Mini": "47432589476076",
        
          "iPhone 13-Base": "47432589508844",
        
          "iPhone 13-Pro": "47432589541612",
        
          "iPhone 13-Pro Max": "47432589574380",
        
          "iPhone 13-Mini": "47432589607148",
        
          "iPhone 14-Base": "47432589639916",
        
          "iPhone 14-Pro": "47432589672684",
        
          "iPhone 14-Pro Max": "47432589705452",
        
          "iPhone 14-Plus": "47432589738220",
        
          "iPhone 15-Base": "47432589770988",
        
          "iPhone 15-Pro": "47432589803756",
        
          "iPhone 15-Pro Max": "47432589836524",
        
          "iPhone 15-Plus": "47432589869292",
        
          "iPhone 16-Base": "47432589902060",
        
          "iPhone 16-Pro": "47432589934828",
        
          "iPhone 16-Pro Max": "47432589967596",
        
          "iPhone 16-Plus": "47432590000364",
        
          "iPhone 16-E": "47432590033132",
        
          "iPhone 17-Base": "47432590065900",
        
          "iPhone 17-Pro": "47432590098668",
        
          "iPhone 17-Pro Max": "47432590131436",
        
          "iPhone 17-Air": "47432590164204"
        
      },
  
    
      "Sage Green Butta motif Chikankari": {
        
          "iPhone 12-Base": "47162150224108",
        
          "iPhone 12-Pro": "47162150256876",
        
          "iPhone 12-Pro Max": "47162150289644",
        
          "iPhone 12-Mini": "47162150322412",
        
          "iPhone 13-Base": "47162150355180",
        
          "iPhone 13-Pro": "47162150387948",
        
          "iPhone 13-Pro Max": "47162150420716",
        
          "iPhone 13-Mini": "47162150453484",
        
          "iPhone 14-Base": "47162150486252",
        
          "iPhone 14-Pro": "47162150519020",
        
          "iPhone 14-Pro Max": "47162150551788",
        
          "iPhone 14-Plus": "47162150584556",
        
          "iPhone 15-Base": "47162150617324",
        
          "iPhone 15-Pro": "47162150650092",
        
          "iPhone 15-Pro Max": "47162150682860",
        
          "iPhone 15-Plus": "47162150715628",
        
          "iPhone 16-Base": "47162150748396",
        
          "iPhone 16-Pro": "47162150781164",
        
          "iPhone 16-Pro Max": "47162150813932",
        
          "iPhone 16-Plus": "47162150846700",
        
          "iPhone 17-Base": "47162150879468",
        
          "iPhone 17-Air": "47162150912236",
        
          "iPhone 17-Pro": "47162150945004",
        
          "iPhone 17-Pro Max": "47162150977772",
        
          "iPhone 16-E": "47189460222188"
        
      },
    
      "Lemon Yellow Paisley Chikankari": {
        
          "iPhone 12-Base": "47162149437676",
        
          "iPhone 12-Pro": "47162149470444",
        
          "iPhone 12-Pro Max": "47162149503212",
        
          "iPhone 12-Mini": "47162149535980",
        
          "iPhone 13-Base": "47162149568748",
        
          "iPhone 13-Pro": "47162149601516",
        
          "iPhone 13-Pro Max": "47162149634284",
        
          "iPhone 13-Mini": "47162149667052",
        
          "iPhone 14-Base": "47162149699820",
        
          "iPhone 14-Pro": "47162149732588",
        
          "iPhone 14-Pro Max": "47162149765356",
        
          "iPhone 14-Plus": "47162149798124",
        
          "iPhone 15-Base": "47162149830892",
        
          "iPhone 15-Pro": "47162149863660",
        
          "iPhone 15-Pro Max": "47162149896428",
        
          "iPhone 15-Plus": "47162149929196",
        
          "iPhone 16-Base": "47162149961964",
        
          "iPhone 16-Pro": "47162149994732",
        
          "iPhone 16-Pro Max": "47162150027500",
        
          "iPhone 16-Plus": "47162150060268",
        
          "iPhone 17-Base": "47162150093036",
        
          "iPhone 17-Air": "47162150125804",
        
          "iPhone 17-Pro": "47162150158572",
        
          "iPhone 17-Pro Max": "47162150191340",
        
          "iPhone 16-E": "47189460156652"
        
      },
    
      "Seljuk bloom": {
        
          "iPhone 12-Base": "47020531220716",
        
          "iPhone 12-Pro": "47020531253484",
        
          "iPhone 12-Pro Max": "47020531286252",
        
          "iPhone 12-Mini": "47020531319020",
        
          "iPhone 13-Base": "47020531351788",
        
          "iPhone 13-Pro": "47020531384556",
        
          "iPhone 13-Pro Max": "47020531417324",
        
          "iPhone 13-Mini": "47020531450092",
        
          "iPhone 14-Base": "47020531482860",
        
          "iPhone 14-Pro": "47020531515628",
        
          "iPhone 14-Pro Max": "47020531548396",
        
          "iPhone 14-Plus": "47020531581164",
        
          "iPhone 15-Base": "47020531613932",
        
          "iPhone 15-Pro": "47020531646700",
        
          "iPhone 15-Pro Max": "47020531679468",
        
          "iPhone 15-Plus": "47020531712236",
        
          "iPhone 16-Base": "47020531745004",
        
          "iPhone 16-Pro": "47020531777772",
        
          "iPhone 16-Pro Max": "47020531810540",
        
          "iPhone 16-Plus": "47020531843308",
        
          "iPhone 17-Base": "47020531876076",
        
          "iPhone 17-Air": "47020531908844",
        
          "iPhone 17-Pro": "47020531941612",
        
          "iPhone 17-Pro Max": "47020531974380",
        
          "iPhone 16-E": "47189459140844"
        
      },
    
      "Merry reindeer knit": {
        
          "iPhone 12-Base": "47084311871724",
        
          "iPhone 12-Pro": "47084311904492",
        
          "iPhone 12-Pro Max": "47084311937260",
        
          "iPhone 12-Mini": "47084311970028",
        
          "iPhone 13-Base": "47084312002796",
        
          "iPhone 13-Pro": "47084312035564",
        
          "iPhone 13-Pro Max": "47084312068332",
        
          "iPhone 13-Mini": "47084312101100",
        
          "iPhone 14-Base": "47084312133868",
        
          "iPhone 14-Pro": "47084312166636",
        
          "iPhone 14-Pro Max": "47084312199404",
        
          "iPhone 14-Plus": "47084312232172",
        
          "iPhone 15-Base": "47084312264940",
        
          "iPhone 15-Pro": "47084312297708",
        
          "iPhone 15-Pro Max": "47084312330476",
        
          "iPhone 15-Plus": "47084312363244",
        
          "iPhone 16-Base": "47084312396012",
        
          "iPhone 16-Pro": "47084312428780",
        
          "iPhone 16-Pro Max": "47084312461548",
        
          "iPhone 16-Plus": "47084312494316",
        
          "iPhone 17-Base": "47084312527084",
        
          "iPhone 17-Air": "47084312559852",
        
          "iPhone 17-Pro": "47084312592620",
        
          "iPhone 17-Pro Max": "47084312625388",
        
          "iPhone 16-E": "47189459730668"
        
      },
    
      "Kerala hand block print": {
        
          "iPhone 12-Base": "46844282929388",
        
          "iPhone 12-Pro": "46844282962156",
        
          "iPhone 12-Pro Max": "46844282994924",
        
          "iPhone 12-Mini": "46844283027692",
        
          "iPhone 13-Base": "46844283060460",
        
          "iPhone 13-Pro": "46844283093228",
        
          "iPhone 13-Pro Max": "46844283125996",
        
          "iPhone 13-Mini": "46844283158764",
        
          "iPhone 14-Base": "46844283191532",
        
          "iPhone 14-Pro": "46844283224300",
        
          "iPhone 14-Pro Max": "46844283257068",
        
          "iPhone 14-Plus": "46844283289836",
        
          "iPhone 15-Base": "46844283322604",
        
          "iPhone 15-Pro": "46844283355372",
        
          "iPhone 15-Pro Max": "46844283388140",
        
          "iPhone 15-Plus": "46844283420908",
        
          "iPhone 16-Base": "46844283453676",
        
          "iPhone 16-Pro": "46844283486444",
        
          "iPhone 16-Pro Max": "46844283519212",
        
          "iPhone 16-Plus": "46844283551980",
        
          "iPhone 17-Base": "46889578725612",
        
          "iPhone 17-Air": "46889578758380",
        
          "iPhone 17-Pro": "46889578791148",
        
          "iPhone 17-Pro Max": "46889578823916",
        
          "iPhone 16-E": "47189458387180"
        
      },
    
      "Korvai golden triangles": {
        
          "iPhone 12-Base": "46844284731628",
        
          "iPhone 12-Pro": "46844284764396",
        
          "iPhone 12-Pro Max": "46844284797164",
        
          "iPhone 12-Mini": "46844284829932",
        
          "iPhone 13-Base": "46844284862700",
        
          "iPhone 13-Pro": "46844284895468",
        
          "iPhone 13-Pro Max": "46844284928236",
        
          "iPhone 13-Mini": "46844284961004",
        
          "iPhone 14-Base": "46844284993772",
        
          "iPhone 14-Pro": "46844285026540",
        
          "iPhone 14-Pro Max": "46844285059308",
        
          "iPhone 14-Plus": "46844285092076",
        
          "iPhone 15-Base": "46844285124844",
        
          "iPhone 15-Pro": "46844285157612",
        
          "iPhone 15-Pro Max": "46844285190380",
        
          "iPhone 15-Plus": "46844285223148",
        
          "iPhone 16-Base": "46844285255916",
        
          "iPhone 16-Pro": "46844285288684",
        
          "iPhone 16-Pro Max": "46844285321452",
        
          "iPhone 16-Plus": "46844285354220",
        
          "iPhone 17-Base": "46889578463468",
        
          "iPhone 17-Air": "46889578496236",
        
          "iPhone 17-Pro": "46889578529004",
        
          "iPhone 17-Pro Max": "46889578561772",
        
          "iPhone 16-E": "47189458518252"
        
      },
    
      "Royal Blue Bel aur Paisley Chikankari": {
        
          "iPhone 12-Base": "47162162249964",
        
          "iPhone 12-Pro": "47162162282732",
        
          "iPhone 12-Pro Max": "47162162315500",
        
          "iPhone 12-Mini": "47162162348268",
        
          "iPhone 13-Base": "47162162381036",
        
          "iPhone 13-Pro": "47162162413804",
        
          "iPhone 13-Pro Max": "47162162446572",
        
          "iPhone 13-Mini": "47162162479340",
        
          "iPhone 14-Base": "47162162512108",
        
          "iPhone 14-Pro": "47162162544876",
        
          "iPhone 14-Pro Max": "47162162577644",
        
          "iPhone 14-Plus": "47162162610412",
        
          "iPhone 15-Base": "47162162643180",
        
          "iPhone 15-Pro": "47162162675948",
        
          "iPhone 15-Pro Max": "47162162708716",
        
          "iPhone 15-Plus": "47162162741484",
        
          "iPhone 16-Base": "47162162774252",
        
          "iPhone 16-Pro": "47162162807020",
        
          "iPhone 16-Pro Max": "47162162839788",
        
          "iPhone 16-Plus": "47162162872556",
        
          "iPhone 16-E": "47189154201836",
        
          "iPhone 17-Base": "47162162905324",
        
          "iPhone 17-Pro": "47162162970860",
        
          "iPhone 17-Pro Max": "47162163003628",
        
          "iPhone 17-Air": "47162162938092"
        
      },
    
      "Lilac Bel aur Paisley Chikankari": {
        
          "iPhone 12-Base": "47162148585708",
        
          "iPhone 12-Pro": "47162148618476",
        
          "iPhone 12-Pro Max": "47162148651244",
        
          "iPhone 12-Mini": "47162148684012",
        
          "iPhone 13-Base": "47162148716780",
        
          "iPhone 13-Pro": "47162148749548",
        
          "iPhone 13-Pro Max": "47162148782316",
        
          "iPhone 13-Mini": "47162148815084",
        
          "iPhone 14-Base": "47162148847852",
        
          "iPhone 14-Pro": "47162148880620",
        
          "iPhone 14-Pro Max": "47162148913388",
        
          "iPhone 14-Plus": "47162148946156",
        
          "iPhone 15-Base": "47162148978924",
        
          "iPhone 15-Pro": "47162149011692",
        
          "iPhone 15-Pro Max": "47162149044460",
        
          "iPhone 15-Plus": "47162149077228",
        
          "iPhone 16-Base": "47162149109996",
        
          "iPhone 16-Pro": "47162149142764",
        
          "iPhone 16-Pro Max": "47162149175532",
        
          "iPhone 16-Plus": "47162149208300",
        
          "iPhone 17-Base": "47162149241068",
        
          "iPhone 17-Air": "47162149273836",
        
          "iPhone 17-Pro": "47162149306604",
        
          "iPhone 17-Pro Max": "47162149339372",
        
          "iPhone 16-E": "47189460123884"
        
      },
    
      "Mughal court white": {
        
          "iPhone 12-Base": "45953170473196",
        
          "iPhone 12-Pro": "45953170505964",
        
          "iPhone 12-Pro Max": "45953170538732",
        
          "iPhone 12-Mini": "46440680161516",
        
          "iPhone 13-Base": "45953170571500",
        
          "iPhone 13-Pro": "45953170604268",
        
          "iPhone 13-Pro Max": "45953170637036",
        
          "iPhone 13-Mini": "46440680194284",
        
          "iPhone 14-Base": "45953170669804",
        
          "iPhone 14-Pro": "45953170702572",
        
          "iPhone 14-Pro Max": "45953170735340",
        
          "iPhone 14-Plus": "45953170768108",
        
          "iPhone 15-Base": "45953170800876",
        
          "iPhone 15-Pro": "45953170833644",
        
          "iPhone 15-Pro Max": "45953170866412",
        
          "iPhone 15-Plus": "45953170899180",
        
          "iPhone 16-Base": "45953170931948",
        
          "iPhone 16-Pro": "45953170964716",
        
          "iPhone 16-Pro Max": "45953170997484",
        
          "iPhone 16-Plus": "45953171030252",
        
          "iPhone 17-Base": "46889595011308",
        
          "iPhone 17-Air": "46889595044076",
        
          "iPhone 17-Pro": "46889595076844",
        
          "iPhone 17-Pro Max": "46889595109612",
        
          "iPhone 16-E": "47189447540972"
        
      },
    
      "Lilac Butta Motif Chikankari": {
        
          "iPhone 12-Base": "47162147668204",
        
          "iPhone 12-Pro": "47162147700972",
        
          "iPhone 12-Pro Max": "47162147733740",
        
          "iPhone 12-Mini": "47162147766508",
        
          "iPhone 13-Base": "47162147799276",
        
          "iPhone 13-Pro": "47162147832044",
        
          "iPhone 13-Pro Max": "47162147864812",
        
          "iPhone 13-Mini": "47162147897580",
        
          "iPhone 14-Base": "47162147930348",
        
          "iPhone 14-Pro": "47162147963116",
        
          "iPhone 14-Pro Max": "47162147995884",
        
          "iPhone 14-Plus": "47162148028652",
        
          "iPhone 15-Base": "47162148061420",
        
          "iPhone 15-Pro": "47162148094188",
        
          "iPhone 15-Pro Max": "47162148126956",
        
          "iPhone 15-Plus": "47162148159724",
        
          "iPhone 16-Base": "47162148192492",
        
          "iPhone 16-Pro": "47162148225260",
        
          "iPhone 16-Pro Max": "47162148258028",
        
          "iPhone 16-Plus": "47162148290796",
        
          "iPhone 17-Base": "47162148323564",
        
          "iPhone 17-Air": "47162148356332",
        
          "iPhone 17-Pro": "47162148389100",
        
          "iPhone 17-Pro Max": "47162148421868",
        
          "iPhone 16-E": "47189460058348"
        
      },
    
      "Black Buti Motif 1 Chikankari": {
        
          "iPhone 12-Base": "47162167525612",
        
          "iPhone 12-Pro": "47162167558380",
        
          "iPhone 12-Pro Max": "47162167591148",
        
          "iPhone 12-Mini": "47162167623916",
        
          "iPhone 13-Base": "47162167656684",
        
          "iPhone 13-Pro": "47162167689452",
        
          "iPhone 13-Pro Max": "47162167722220",
        
          "iPhone 13-Mini": "47162167754988",
        
          "iPhone 14-Base": "47162167787756",
        
          "iPhone 14-Pro": "47162167820524",
        
          "iPhone 14-Pro Max": "47162167853292",
        
          "iPhone 14-Plus": "47162167886060",
        
          "iPhone 15-Base": "47162167918828",
        
          "iPhone 15-Pro": "47162167951596",
        
          "iPhone 15-Pro Max": "47162167984364",
        
          "iPhone 15-Plus": "47162168017132",
        
          "iPhone 16-Base": "47162168049900",
        
          "iPhone 16-Pro": "47162168082668",
        
          "iPhone 16-Pro Max": "47162168115436",
        
          "iPhone 16-Plus": "47162168148204",
        
          "iPhone 16-E": "47189134311660",
        
          "iPhone 17-Base": "47162168180972",
        
          "iPhone 17-Pro": "47162168246508",
        
          "iPhone 17-Pro Max": "47162168279276",
        
          "iPhone 17-Air": "47162168213740"
        
      },
    
      "Powder Blue Jaal aur Phool Chikankari": {
        
          "iPhone 12-Base": "47162152386796",
        
          "iPhone 12-Pro": "47162152419564",
        
          "iPhone 12-Pro Max": "47162152452332",
        
          "iPhone 12-Mini": "47162152485100",
        
          "iPhone 13-Base": "47162152517868",
        
          "iPhone 13-Pro": "47162152550636",
        
          "iPhone 13-Pro Max": "47162152583404",
        
          "iPhone 13-Mini": "47162152616172",
        
          "iPhone 14-Base": "47162152648940",
        
          "iPhone 14-Pro": "47162152681708",
        
          "iPhone 14-Pro Max": "47162152714476",
        
          "iPhone 14-Plus": "47162152747244",
        
          "iPhone 15-Base": "47162152780012",
        
          "iPhone 15-Pro": "47162152812780",
        
          "iPhone 15-Pro Max": "47162152845548",
        
          "iPhone 15-Plus": "47162152878316",
        
          "iPhone 16-Base": "47162152911084",
        
          "iPhone 16-Pro": "47162152943852",
        
          "iPhone 16-Pro Max": "47162152976620",
        
          "iPhone 16-Plus": "47162153009388",
        
          "iPhone 16-E": "47189247394028",
        
          "iPhone 17-Base": "47162153042156",
        
          "iPhone 17-Pro": "47162153107692",
        
          "iPhone 17-Pro Max": "47162153140460",
        
          "iPhone 17-Air": "47162153074924"
        
      },
    
      "Baby Pink Bel aur Phool Chikankari": {
        
          "iPhone 12-Base": "47162168410348",
        
          "iPhone 12-Pro": "47162168443116",
        
          "iPhone 12-Pro Max": "47162168475884",
        
          "iPhone 12-Mini": "47162168508652",
        
          "iPhone 13-Base": "47162168541420",
        
          "iPhone 13-Pro": "47162168574188",
        
          "iPhone 13-Pro Max": "47162168606956",
        
          "iPhone 13-Mini": "47162168639724",
        
          "iPhone 14-Base": "47162168672492",
        
          "iPhone 14-Pro": "47162168705260",
        
          "iPhone 14-Pro Max": "47162168738028",
        
          "iPhone 14-Plus": "47162168770796",
        
          "iPhone 15-Base": "47162168803564",
        
          "iPhone 15-Pro": "47162168836332",
        
          "iPhone 15-Pro Max": "47162168869100",
        
          "iPhone 15-Plus": "47162168901868",
        
          "iPhone 16-Base": "47162168934636",
        
          "iPhone 16-Pro": "47162168967404",
        
          "iPhone 16-Pro Max": "47162169000172",
        
          "iPhone 16-Plus": "47162169032940",
        
          "iPhone 16-E": "47189123268844",
        
          "iPhone 17-Base": "47162169065708",
        
          "iPhone 17-Pro": "47162169131244",
        
          "iPhone 17-Pro Max": "47162169164012",
        
          "iPhone 17-Air": "47162169098476"
        
      },
    
      "Black Bel Aur Phool Chikankari": {
        
          "iPhone 12-Base": "47162158121196",
        
          "iPhone 12-Pro": "47162158153964",
        
          "iPhone 12-Pro Max": "47162158186732",
        
          "iPhone 12-Mini": "47162158219500",
        
          "iPhone 13-Base": "47162158252268",
        
          "iPhone 13-Pro": "47162158285036",
        
          "iPhone 13-Pro Max": "47162158317804",
        
          "iPhone 13-Mini": "47162158350572",
        
          "iPhone 14-Base": "47162158383340",
        
          "iPhone 14-Pro": "47162158416108",
        
          "iPhone 14-Pro Max": "47162158448876",
        
          "iPhone 14-Plus": "47162158481644",
        
          "iPhone 15-Base": "47162158514412",
        
          "iPhone 15-Pro": "47162158547180",
        
          "iPhone 15-Pro Max": "47162158579948",
        
          "iPhone 15-Plus": "47162158612716",
        
          "iPhone 16-Base": "47162158645484",
        
          "iPhone 16-Pro": "47162158678252",
        
          "iPhone 16-Pro Max": "47162158711020",
        
          "iPhone 16-Plus": "47162158743788",
        
          "iPhone 16-E": "47189239169260",
        
          "iPhone 17-Base": "47162158776556",
        
          "iPhone 17-Pro": "47162158842092",
        
          "iPhone 17-Pro Max": "47162158874860",
        
          "iPhone 17-Air": "47162158809324"
        
      },
    
      "Buti motif": {
        
          "iPhone 12-Base": "46844286533868",
        
          "iPhone 12-Pro": "46844286566636",
        
          "iPhone 12-Pro Max": "46844286599404",
        
          "iPhone 12-Mini": "46844286632172",
        
          "iPhone 13-Base": "46844286664940",
        
          "iPhone 13-Pro": "46844286697708",
        
          "iPhone 13-Pro Max": "46844286730476",
        
          "iPhone 13-Mini": "46844286763244",
        
          "iPhone 14-Base": "46844286796012",
        
          "iPhone 14-Pro": "46844286828780",
        
          "iPhone 14-Pro Max": "46844286861548",
        
          "iPhone 14-Plus": "46844286894316",
        
          "iPhone 15-Base": "46844286927084",
        
          "iPhone 15-Pro": "46844286959852",
        
          "iPhone 15-Pro Max": "46844286992620",
        
          "iPhone 15-Plus": "46844287025388",
        
          "iPhone 16-Base": "46844287058156",
        
          "iPhone 16-Pro": "46844287090924",
        
          "iPhone 16-Pro Max": "46844287123692",
        
          "iPhone 16-Plus": "46844287156460",
        
          "iPhone 17-Base": "46889578201324",
        
          "iPhone 17-Air": "46889578234092",
        
          "iPhone 17-Pro": "46889578266860",
        
          "iPhone 17-Pro Max": "46889578299628",
        
          "iPhone 16-E": "47189458649324"
        
      },
    
      "Mint Green Bel aur Phool Chikankari": {
        
          "iPhone 12-Base": "47162151010540",
        
          "iPhone 12-Pro": "47162151043308",
        
          "iPhone 12-Pro Max": "47162151076076",
        
          "iPhone 12-Mini": "47162151108844",
        
          "iPhone 13-Base": "47162151141612",
        
          "iPhone 13-Pro": "47162151174380",
        
          "iPhone 13-Pro Max": "47162151207148",
        
          "iPhone 13-Mini": "47162151239916",
        
          "iPhone 14-Base": "47162151272684",
        
          "iPhone 14-Pro": "47162151305452",
        
          "iPhone 14-Pro Max": "47162151338220",
        
          "iPhone 14-Plus": "47162151370988",
        
          "iPhone 15-Base": "47162151403756",
        
          "iPhone 15-Pro": "47162151436524",
        
          "iPhone 15-Pro Max": "47162151469292",
        
          "iPhone 15-Plus": "47162151502060",
        
          "iPhone 16-Base": "47162151534828",
        
          "iPhone 16-Pro": "47162151567596",
        
          "iPhone 16-Pro Max": "47162151600364",
        
          "iPhone 16-Plus": "47162151633132",
        
          "iPhone 17-Base": "47162151665900",
        
          "iPhone 17-Air": "47162151698668",
        
          "iPhone 17-Pro": "47162151731436",
        
          "iPhone 17-Pro Max": "47162151764204",
        
          "iPhone 16-E": "47189460287724"
        
      },
    
      "Black Buti Motif 2 Chikankari": {
        
          "iPhone 12-Base": "47162166542572",
        
          "iPhone 12-Pro": "47162166575340",
        
          "iPhone 12-Pro Max": "47162166608108",
        
          "iPhone 12-Mini": "47162166640876",
        
          "iPhone 13-Base": "47162166673644",
        
          "iPhone 13-Pro": "47162166706412",
        
          "iPhone 13-Pro Max": "47162166739180",
        
          "iPhone 13-Mini": "47162166771948",
        
          "iPhone 14-Base": "47162166804716",
        
          "iPhone 14-Pro": "47162166837484",
        
          "iPhone 14-Pro Max": "47162166870252",
        
          "iPhone 14-Plus": "47162166903020",
        
          "iPhone 15-Base": "47162166935788",
        
          "iPhone 15-Pro": "47162166968556",
        
          "iPhone 15-Pro Max": "47162167001324",
        
          "iPhone 15-Plus": "47162167034092",
        
          "iPhone 16-Base": "47162167066860",
        
          "iPhone 16-Pro": "47162167099628",
        
          "iPhone 16-Pro Max": "47162167132396",
        
          "iPhone 16-Plus": "47162167165164",
        
          "iPhone 16-E": "47189147517164",
        
          "iPhone 17-Base": "47162167197932",
        
          "iPhone 17-Pro": "47162167263468",
        
          "iPhone 17-Pro Max": "47162167296236",
        
          "iPhone 17-Air": "47162167230700"
        
      },
    
      "Powder Blue Jaal Chikankari": {
        
          "iPhone 12-Base": "47162154549484",
        
          "iPhone 12-Pro": "47162154582252",
        
          "iPhone 12-Pro Max": "47162154615020",
        
          "iPhone 12-Mini": "47162154647788",
        
          "iPhone 13-Base": "47162154680556",
        
          "iPhone 13-Pro": "47162154713324",
        
          "iPhone 13-Pro Max": "47162154746092",
        
          "iPhone 13-Mini": "47162154778860",
        
          "iPhone 14-Base": "47162154811628",
        
          "iPhone 14-Pro": "47162154844396",
        
          "iPhone 14-Pro Max": "47162154877164",
        
          "iPhone 14-Plus": "47162154909932",
        
          "iPhone 15-Base": "47162154942700",
        
          "iPhone 15-Pro": "47162154975468",
        
          "iPhone 15-Pro Max": "47162155008236",
        
          "iPhone 15-Plus": "47162155041004",
        
          "iPhone 16-Base": "47162155073772",
        
          "iPhone 16-Pro": "47162155106540",
        
          "iPhone 16-Pro Max": "47162155139308",
        
          "iPhone 16-Plus": "47162155172076",
        
          "iPhone 16-E": "47189240545516",
        
          "iPhone 17-Base": "47162155204844",
        
          "iPhone 17-Pro": "47162155270380",
        
          "iPhone 17-Pro Max": "47162155303148",
        
          "iPhone 17-Air": "47162155237612"
        
      },
    
      "Royal Blue Jaal Chikankari": {
        
          "iPhone 12-Base": "47162161430764",
        
          "iPhone 12-Pro": "47162161463532",
        
          "iPhone 12-Pro Max": "47162161496300",
        
          "iPhone 12-Mini": "47162161529068",
        
          "iPhone 13-Base": "47162161561836",
        
          "iPhone 13-Pro": "47162161594604",
        
          "iPhone 13-Pro Max": "47162161627372",
        
          "iPhone 13-Mini": "47162161660140",
        
          "iPhone 14-Base": "47162161692908",
        
          "iPhone 14-Pro": "47162161725676",
        
          "iPhone 14-Pro Max": "47162161758444",
        
          "iPhone 14-Plus": "47162161791212",
        
          "iPhone 15-Base": "47162161823980",
        
          "iPhone 15-Pro": "47162161856748",
        
          "iPhone 15-Pro Max": "47162161889516",
        
          "iPhone 15-Plus": "47162161922284",
        
          "iPhone 16-Base": "47162161955052",
        
          "iPhone 16-Pro": "47162161987820",
        
          "iPhone 16-Pro Max": "47162162020588",
        
          "iPhone 16-Plus": "47162162053356",
        
          "iPhone 16-E": "47189166883052",
        
          "iPhone 17-Base": "47162162086124",
        
          "iPhone 17-Pro": "47162162151660",
        
          "iPhone 17-Pro Max": "47162162184428",
        
          "iPhone 17-Air": "47162162118892"
        
      },
    
      "Power black Jaal 2 Chikankari": {
        
          "iPhone 12-Base": "47162146816236",
        
          "iPhone 12-Pro": "47162146849004",
        
          "iPhone 12-Pro Max": "47162146881772",
        
          "iPhone 12-Mini": "47162146914540",
        
          "iPhone 13-Base": "47162146947308",
        
          "iPhone 13-Pro": "47162146980076",
        
          "iPhone 13-Pro Max": "47162147012844",
        
          "iPhone 13-Mini": "47162147045612",
        
          "iPhone 14-Base": "47162147078380",
        
          "iPhone 14-Pro": "47162147111148",
        
          "iPhone 14-Pro Max": "47162147143916",
        
          "iPhone 14-Plus": "47162147176684",
        
          "iPhone 15-Base": "47162147209452",
        
          "iPhone 15-Pro": "47162147242220",
        
          "iPhone 15-Pro Max": "47162147274988",
        
          "iPhone 15-Plus": "47162147307756",
        
          "iPhone 16-Base": "47162147340524",
        
          "iPhone 16-Pro": "47162147373292",
        
          "iPhone 16-Pro Max": "47162147406060",
        
          "iPhone 16-Plus": "47162147438828",
        
          "iPhone 17-Base": "47162147471596",
        
          "iPhone 17-Air": "47162147504364",
        
          "iPhone 17-Pro": "47162147537132",
        
          "iPhone 17-Pro Max": "47162147569900",
        
          "iPhone 16-E": "47189459992812"
        
      },
    
      "Power black Jaal 1 Chikankari": {
        
          "iPhone 12-Base": "47162146029804",
        
          "iPhone 12-Pro": "47162146062572",
        
          "iPhone 12-Pro Max": "47162146095340",
        
          "iPhone 12-Mini": "47162146128108",
        
          "iPhone 13-Base": "47162146160876",
        
          "iPhone 13-Pro": "47162146193644",
        
          "iPhone 13-Pro Max": "47162146226412",
        
          "iPhone 13-Mini": "47162146259180",
        
          "iPhone 14-Base": "47162146291948",
        
          "iPhone 14-Pro": "47162146324716",
        
          "iPhone 14-Pro Max": "47162146357484",
        
          "iPhone 14-Plus": "47162146390252",
        
          "iPhone 15-Base": "47162146423020",
        
          "iPhone 15-Pro": "47162146455788",
        
          "iPhone 15-Pro Max": "47162146488556",
        
          "iPhone 15-Plus": "47162146521324",
        
          "iPhone 16-Base": "47162146554092",
        
          "iPhone 16-Pro": "47162146586860",
        
          "iPhone 16-Pro Max": "47162146619628",
        
          "iPhone 16-Plus": "47162146652396",
        
          "iPhone 17-Base": "47162146685164",
        
          "iPhone 17-Air": "47162146717932",
        
          "iPhone 17-Pro": "47162146750700",
        
          "iPhone 17-Pro Max": "47162146783468",
        
          "iPhone 16-E": "47189459927276"
        
      },
    
      "Emerald Jaal Chikankari": {
        
          "iPhone 12-Base": "47162144456940",
        
          "iPhone 12-Pro": "47162144489708",
        
          "iPhone 12-Pro Max": "47162144522476",
        
          "iPhone 12-Mini": "47162144555244",
        
          "iPhone 13-Base": "47162144588012",
        
          "iPhone 13-Pro": "47162144620780",
        
          "iPhone 13-Pro Max": "47162144653548",
        
          "iPhone 13-Mini": "47162144686316",
        
          "iPhone 14-Base": "47162144719084",
        
          "iPhone 14-Pro": "47162144751852",
        
          "iPhone 14-Pro Max": "47162144784620",
        
          "iPhone 14-Plus": "47162144817388",
        
          "iPhone 15-Base": "47162144850156",
        
          "iPhone 15-Pro": "47162144882924",
        
          "iPhone 15-Pro Max": "47162144915692",
        
          "iPhone 15-Plus": "47162144948460",
        
          "iPhone 16-Base": "47162144981228",
        
          "iPhone 16-Pro": "47162145013996",
        
          "iPhone 16-Pro Max": "47162145046764",
        
          "iPhone 16-Plus": "47162145079532",
        
          "iPhone 17-Base": "47162145112300",
        
          "iPhone 17-Air": "47162145145068",
        
          "iPhone 17-Pro": "47162145177836",
        
          "iPhone 17-Pro Max": "47162145210604",
        
          "iPhone 16-E": "47189459894508"
        
      },
    
      "8 bit knit": {
        
          "iPhone 12-Base": "47084319080684",
        
          "iPhone 12-Pro": "47084319113452",
        
          "iPhone 12-Pro Max": "47084319146220",
        
          "iPhone 12-Mini": "47084319178988",
        
          "iPhone 13-Base": "47084319211756",
        
          "iPhone 13-Pro": "47084319244524",
        
          "iPhone 13-Pro Max": "47084319277292",
        
          "iPhone 13-Mini": "47084319310060",
        
          "iPhone 14-Base": "47084319342828",
        
          "iPhone 14-Pro": "47084319375596",
        
          "iPhone 14-Pro Max": "47084319408364",
        
          "iPhone 14-Plus": "47084319441132",
        
          "iPhone 15-Base": "47084319473900",
        
          "iPhone 15-Pro": "47084319506668",
        
          "iPhone 15-Pro Max": "47084319539436",
        
          "iPhone 15-Plus": "47084319572204",
        
          "iPhone 16-Base": "47084319604972",
        
          "iPhone 16-Pro": "47084319637740",
        
          "iPhone 16-Pro Max": "47084319670508",
        
          "iPhone 16-Plus": "47084319703276",
        
          "iPhone 17-Base": "47084319736044",
        
          "iPhone 17-Air": "47084319768812",
        
          "iPhone 17-Pro": "47084319801580",
        
          "iPhone 17-Pro Max": "47084319834348",
        
          "iPhone 16-E": "47189459828972"
        
      },
    
      "Tinsel x cats": {
        
          "iPhone 12-Base": "47084308431084",
        
          "iPhone 12-Pro": "47084308463852",
        
          "iPhone 12-Pro Max": "47084308496620",
        
          "iPhone 12-Mini": "47084308529388",
        
          "iPhone 13-Base": "47084308562156",
        
          "iPhone 13-Pro": "47084308594924",
        
          "iPhone 13-Pro Max": "47084308627692",
        
          "iPhone 13-Mini": "47084308660460",
        
          "iPhone 14-Base": "47084308693228",
        
          "iPhone 14-Pro": "47084308725996",
        
          "iPhone 14-Pro Max": "47084308758764",
        
          "iPhone 14-Plus": "47084308791532",
        
          "iPhone 15-Base": "47084308824300",
        
          "iPhone 15-Pro": "47084308857068",
        
          "iPhone 15-Pro Max": "47084308889836",
        
          "iPhone 15-Plus": "47084308922604",
        
          "iPhone 16-Base": "47084308955372",
        
          "iPhone 16-Pro": "47084308988140",
        
          "iPhone 16-Pro Max": "47084309020908",
        
          "iPhone 16-Plus": "47084309053676",
        
          "iPhone 17-Base": "47084309086444",
        
          "iPhone 17-Air": "47084309119212",
        
          "iPhone 17-Pro": "47084309151980",
        
          "iPhone 17-Pro Max": "47084309184748",
        
          "iPhone 16-E": "47189459665132"
        
      },
    
      "Gingerbread men assemble knit": {
        
          "iPhone 12-Base": "47084301517036",
        
          "iPhone 12-Pro": "47084301549804",
        
          "iPhone 12-Pro Max": "47084301582572",
        
          "iPhone 12-Mini": "47084301615340",
        
          "iPhone 13-Base": "47084301648108",
        
          "iPhone 13-Pro": "47084301680876",
        
          "iPhone 13-Pro Max": "47084301713644",
        
          "iPhone 13-Mini": "47084301746412",
        
          "iPhone 14-Base": "47084301779180",
        
          "iPhone 14-Pro": "47084301811948",
        
          "iPhone 14-Pro Max": "47084301844716",
        
          "iPhone 14-Plus": "47084301877484",
        
          "iPhone 15-Base": "47084301910252",
        
          "iPhone 15-Pro": "47084301943020",
        
          "iPhone 15-Pro Max": "47084301975788",
        
          "iPhone 15-Plus": "47084302008556",
        
          "iPhone 16-Base": "47084302041324",
        
          "iPhone 16-Pro": "47084302074092",
        
          "iPhone 16-Pro Max": "47084302106860",
        
          "iPhone 16-Plus": "47084302139628",
        
          "iPhone 17-Base": "47084302172396",
        
          "iPhone 17-Air": "47084302205164",
        
          "iPhone 17-Pro": "47084302237932",
        
          "iPhone 17-Pro Max": "47084302270700",
        
          "iPhone 16-E": "47189459599596"
        
      },
    
      "Snowmen Assemble Knit": {
        
          "iPhone 12-Base": "47084298404076",
        
          "iPhone 12-Pro": "47084298436844",
        
          "iPhone 12-Pro Max": "47084298469612",
        
          "iPhone 12-Mini": "47084298502380",
        
          "iPhone 13-Base": "47084298535148",
        
          "iPhone 13-Pro": "47084298567916",
        
          "iPhone 13-Pro Max": "47084298600684",
        
          "iPhone 13-Mini": "47084298633452",
        
          "iPhone 14-Base": "47084298666220",
        
          "iPhone 14-Pro": "47084298698988",
        
          "iPhone 14-Pro Max": "47084298731756",
        
          "iPhone 14-Plus": "47084298764524",
        
          "iPhone 15-Base": "47084298797292",
        
          "iPhone 15-Pro": "47084298830060",
        
          "iPhone 15-Pro Max": "47084298862828",
        
          "iPhone 15-Plus": "47084298895596",
        
          "iPhone 16-Base": "47084298928364",
        
          "iPhone 16-Pro": "47084298961132",
        
          "iPhone 16-Pro Max": "47084298993900",
        
          "iPhone 16-Plus": "47084299026668",
        
          "iPhone 17-Base": "47084299059436",
        
          "iPhone 17-Air": "47084299092204",
        
          "iPhone 17-Pro": "47084299124972",
        
          "iPhone 17-Pro Max": "47084299157740",
        
          "iPhone 16-E": "47189459534060"
        
      },
    
      "Midnight Reindeer Knit": {
        
          "iPhone 12-Base": "47084294963436",
        
          "iPhone 12-Pro": "47084294996204",
        
          "iPhone 12-Pro Max": "47084295028972",
        
          "iPhone 12-Mini": "47084295061740",
        
          "iPhone 13-Base": "47084295094508",
        
          "iPhone 13-Pro": "47084295127276",
        
          "iPhone 13-Pro Max": "47084295160044",
        
          "iPhone 13-Mini": "47084295192812",
        
          "iPhone 14-Base": "47084295225580",
        
          "iPhone 14-Pro": "47084295258348",
        
          "iPhone 14-Pro Max": "47084295291116",
        
          "iPhone 14-Plus": "47084295323884",
        
          "iPhone 15-Base": "47084295356652",
        
          "iPhone 15-Pro": "47084295389420",
        
          "iPhone 15-Pro Max": "47084295422188",
        
          "iPhone 15-Plus": "47084295454956",
        
          "iPhone 16-Base": "47084295487724",
        
          "iPhone 16-Pro": "47084295520492",
        
          "iPhone 16-Pro Max": "47084295553260",
        
          "iPhone 16-Plus": "47084295586028",
        
          "iPhone 17-Base": "47084295618796",
        
          "iPhone 17-Air": "47084295651564",
        
          "iPhone 17-Pro": "47084295684332",
        
          "iPhone 17-Pro Max": "47084295717100",
        
          "iPhone 16-E": "47189459435756"
        
      },
    
      "Seljuk birds": {
        
          "iPhone 12-Base": "47020533612780",
        
          "iPhone 12-Pro": "47020533645548",
        
          "iPhone 12-Pro Max": "47020533678316",
        
          "iPhone 12-Mini": "47020533711084",
        
          "iPhone 13-Base": "47020533743852",
        
          "iPhone 13-Pro": "47020533776620",
        
          "iPhone 13-Pro Max": "47020533809388",
        
          "iPhone 13-Mini": "47020533842156",
        
          "iPhone 14-Base": "47020533874924",
        
          "iPhone 14-Pro": "47020533907692",
        
          "iPhone 14-Pro Max": "47020533940460",
        
          "iPhone 14-Plus": "47020533973228",
        
          "iPhone 15-Base": "47020534005996",
        
          "iPhone 15-Pro": "47020534038764",
        
          "iPhone 15-Pro Max": "47020534071532",
        
          "iPhone 15-Plus": "47020534104300",
        
          "iPhone 16-Base": "47020534137068",
        
          "iPhone 16-Pro": "47020534169836",
        
          "iPhone 16-Pro Max": "47020534202604",
        
          "iPhone 16-Plus": "47020534235372",
        
          "iPhone 17-Base": "47020534268140",
        
          "iPhone 17-Air": "47020534300908",
        
          "iPhone 17-Pro": "47020534333676",
        
          "iPhone 17-Pro Max": "47020534366444",
        
          "iPhone 16-E": "47189459370220"
        
      },
    
      "Isfahan bloom": {
        
          "iPhone 12-Base": "47020529189100",
        
          "iPhone 12-Pro": "47020529221868",
        
          "iPhone 12-Pro Max": "47020529254636",
        
          "iPhone 12-Mini": "47020529287404",
        
          "iPhone 13-Base": "47020529320172",
        
          "iPhone 13-Pro": "47020529352940",
        
          "iPhone 13-Pro Max": "47020529385708",
        
          "iPhone 13-Mini": "47020529418476",
        
          "iPhone 14-Base": "47020529451244",
        
          "iPhone 14-Pro": "47020529484012",
        
          "iPhone 14-Pro Max": "47020529516780",
        
          "iPhone 14-Plus": "47020529549548",
        
          "iPhone 15-Base": "47020529582316",
        
          "iPhone 15-Pro": "47020529615084",
        
          "iPhone 15-Pro Max": "47020529647852",
        
          "iPhone 15-Plus": "47020529680620",
        
          "iPhone 16-Base": "47020529713388",
        
          "iPhone 16-Pro": "47020529746156",
        
          "iPhone 16-Pro Max": "47020529778924",
        
          "iPhone 16-Plus": "47020529811692",
        
          "iPhone 17-Base": "47020529844460",
        
          "iPhone 17-Air": "47020529877228",
        
          "iPhone 17-Pro": "47020529909996",
        
          "iPhone 17-Pro Max": "47020529942764",
        
          "iPhone 16-E": "47189459009772"
        
      },
    
      "Tufa Garden 2": {
        
          "iPhone 12-Base": "47020527157484",
        
          "iPhone 12-Pro": "47020527190252",
        
          "iPhone 12-Pro Max": "47020527223020",
        
          "iPhone 12-Mini": "47020527255788",
        
          "iPhone 13-Base": "47020527288556",
        
          "iPhone 13-Pro": "47020527321324",
        
          "iPhone 13-Pro Max": "47020527354092",
        
          "iPhone 13-Mini": "47020527386860",
        
          "iPhone 14-Base": "47020527419628",
        
          "iPhone 14-Pro": "47020527452396",
        
          "iPhone 14-Pro Max": "47020527485164",
        
          "iPhone 14-Plus": "47020527517932",
        
          "iPhone 15-Base": "47020527550700",
        
          "iPhone 15-Pro": "47020527583468",
        
          "iPhone 15-Pro Max": "47020527616236",
        
          "iPhone 15-Plus": "47020527649004",
        
          "iPhone 16-Base": "47020527681772",
        
          "iPhone 16-Pro": "47020527714540",
        
          "iPhone 16-Pro Max": "47020527747308",
        
          "iPhone 16-Plus": "47020527780076",
        
          "iPhone 17-Base": "47020527812844",
        
          "iPhone 17-Air": "47020527845612",
        
          "iPhone 17-Pro": "47020527878380",
        
          "iPhone 17-Pro Max": "47020527911148",
        
          "iPhone 16-E": "47189458944236"
        
      },
    
      "Tufa Garden 1": {
        
          "iPhone 12-Base": "47020525748460",
        
          "iPhone 12-Pro": "47020525781228",
        
          "iPhone 12-Pro Max": "47020525813996",
        
          "iPhone 12-Mini": "47020525846764",
        
          "iPhone 13-Base": "47020525879532",
        
          "iPhone 13-Pro": "47020525912300",
        
          "iPhone 13-Pro Max": "47020525945068",
        
          "iPhone 13-Mini": "47020525977836",
        
          "iPhone 14-Base": "47020526010604",
        
          "iPhone 14-Pro": "47020526043372",
        
          "iPhone 14-Pro Max": "47020526076140",
        
          "iPhone 14-Plus": "47020526108908",
        
          "iPhone 15-Base": "47020526141676",
        
          "iPhone 15-Pro": "47020526174444",
        
          "iPhone 15-Pro Max": "47020526207212",
        
          "iPhone 15-Plus": "47020526239980",
        
          "iPhone 16-Base": "47020526272748",
        
          "iPhone 16-Pro": "47020526305516",
        
          "iPhone 16-Pro Max": "47020526338284",
        
          "iPhone 16-Plus": "47020526371052",
        
          "iPhone 17-Base": "47020526403820",
        
          "iPhone 17-Air": "47020526436588",
        
          "iPhone 17-Pro": "47020526469356",
        
          "iPhone 17-Pro Max": "47020526502124",
        
          "iPhone 16-E": "47189458878700"
        
      },
    
      "Golden star Anatolian": {
        
          "iPhone 12-Base": "47020522832108",
        
          "iPhone 12-Pro": "47020522864876",
        
          "iPhone 12-Pro Max": "47020522897644",
        
          "iPhone 12-Mini": "47020522930412",
        
          "iPhone 13-Base": "47020522963180",
        
          "iPhone 13-Pro": "47020522995948",
        
          "iPhone 13-Pro Max": "47020523028716",
        
          "iPhone 13-Mini": "47020523061484",
        
          "iPhone 14-Base": "47020523094252",
        
          "iPhone 14-Pro": "47020523127020",
        
          "iPhone 14-Pro Max": "47020523159788",
        
          "iPhone 14-Plus": "47020523192556",
        
          "iPhone 15-Base": "47020523225324",
        
          "iPhone 15-Pro": "47020523258092",
        
          "iPhone 15-Pro Max": "47020523290860",
        
          "iPhone 15-Plus": "47020523323628",
        
          "iPhone 16-Base": "47020523356396",
        
          "iPhone 16-Pro": "47020523389164",
        
          "iPhone 16-Pro Max": "47020523421932",
        
          "iPhone 16-Plus": "47020523454700",
        
          "iPhone 17-Base": "47020523487468",
        
          "iPhone 17-Air": "47020523520236",
        
          "iPhone 17-Pro": "47020523553004",
        
          "iPhone 17-Pro Max": "47020523585772",
        
          "iPhone 16-E": "47189458813164"
        
      },
    
      "Blue-Pink Anatolian": {
        
          "iPhone 12-Base": "47020520308972",
        
          "iPhone 12-Pro": "47020520341740",
        
          "iPhone 12-Pro Max": "47020520374508",
        
          "iPhone 12-Mini": "47020520407276",
        
          "iPhone 13-Base": "47020520440044",
        
          "iPhone 13-Pro": "47020520472812",
        
          "iPhone 13-Pro Max": "47020520505580",
        
          "iPhone 13-Mini": "47020520538348",
        
          "iPhone 14-Base": "47020520571116",
        
          "iPhone 14-Pro": "47020520603884",
        
          "iPhone 14-Pro Max": "47020520636652",
        
          "iPhone 14-Plus": "47020520669420",
        
          "iPhone 15-Base": "47020520702188",
        
          "iPhone 15-Pro": "47020520734956",
        
          "iPhone 15-Pro Max": "47020520767724",
        
          "iPhone 15-Plus": "47020520800492",
        
          "iPhone 16-Base": "47020520833260",
        
          "iPhone 16-Pro": "47020520866028",
        
          "iPhone 16-Pro Max": "47020520898796",
        
          "iPhone 16-Plus": "47020520931564",
        
          "iPhone 17-Base": "47020520964332",
        
          "iPhone 17-Air": "47020520997100",
        
          "iPhone 17-Pro": "47020521029868",
        
          "iPhone 17-Pro Max": "47020521062636",
        
          "iPhone 16-E": "47189458747628"
        
      },
    
      "Mangalagiri gold": {
        
          "iPhone 12-Base": "46844285616364",
        
          "iPhone 12-Pro": "46844285649132",
        
          "iPhone 12-Pro Max": "46844285681900",
        
          "iPhone 12-Mini": "46844285714668",
        
          "iPhone 13-Base": "46844285747436",
        
          "iPhone 13-Pro": "46844285780204",
        
          "iPhone 13-Pro Max": "46844285812972",
        
          "iPhone 13-Mini": "46844285845740",
        
          "iPhone 14-Base": "46844285878508",
        
          "iPhone 14-Pro": "46844285911276",
        
          "iPhone 14-Pro Max": "46844285944044",
        
          "iPhone 14-Plus": "46844285976812",
        
          "iPhone 15-Base": "46844286009580",
        
          "iPhone 15-Pro": "46844286042348",
        
          "iPhone 15-Pro Max": "46844286075116",
        
          "iPhone 15-Plus": "46844286107884",
        
          "iPhone 16-Base": "46844286140652",
        
          "iPhone 16-Pro": "46844286173420",
        
          "iPhone 16-Pro Max": "46844286206188",
        
          "iPhone 16-Plus": "46844286238956",
        
          "iPhone 17-Base": "46889578332396",
        
          "iPhone 17-Air": "46889578365164",
        
          "iPhone 17-Pro": "46889578397932",
        
          "iPhone 17-Pro Max": "46889578430700",
        
          "iPhone 16-E": "47189458583788"
        
      },
    
      "Handwoven Chettinad": {
        
          "iPhone 12-Base": "46844283781356",
        
          "iPhone 12-Pro": "46844283814124",
        
          "iPhone 12-Pro Max": "46844283846892",
        
          "iPhone 12-Mini": "46844283879660",
        
          "iPhone 13-Base": "46844283912428",
        
          "iPhone 13-Pro": "46844283945196",
        
          "iPhone 13-Pro Max": "46844283977964",
        
          "iPhone 13-Mini": "46844284010732",
        
          "iPhone 14-Base": "46844284043500",
        
          "iPhone 14-Pro": "46844284076268",
        
          "iPhone 14-Pro Max": "46844284109036",
        
          "iPhone 14-Plus": "46844284141804",
        
          "iPhone 15-Base": "46844284174572",
        
          "iPhone 15-Pro": "46844284207340",
        
          "iPhone 15-Pro Max": "46844284240108",
        
          "iPhone 15-Plus": "46844284272876",
        
          "iPhone 16-Base": "46844284305644",
        
          "iPhone 16-Pro": "46844284338412",
        
          "iPhone 16-Pro Max": "46844284371180",
        
          "iPhone 16-Plus": "46844284403948",
        
          "iPhone 17-Base": "46889578594540",
        
          "iPhone 17-Air": "46889578627308",
        
          "iPhone 17-Pro": "46889578660076",
        
          "iPhone 17-Pro Max": "46889578692844",
        
          "iPhone 16-E": "47189458452716"
        
      },
    
      "Kasuvu": {
        
          "iPhone 12-Base": "46844282077420",
        
          "iPhone 12-Pro": "46844282110188",
        
          "iPhone 12-Pro Max": "46844282142956",
        
          "iPhone 12-Mini": "46844282175724",
        
          "iPhone 13-Base": "46844282208492",
        
          "iPhone 13-Pro": "46844282241260",
        
          "iPhone 13-Pro Max": "46844282274028",
        
          "iPhone 13-Mini": "46844282306796",
        
          "iPhone 14-Base": "46844282339564",
        
          "iPhone 14-Pro": "46844282372332",
        
          "iPhone 14-Pro Max": "46844282405100",
        
          "iPhone 14-Plus": "46844282437868",
        
          "iPhone 15-Base": "46844282470636",
        
          "iPhone 15-Pro": "46844282503404",
        
          "iPhone 15-Pro Max": "46844282536172",
        
          "iPhone 15-Plus": "46844282568940",
        
          "iPhone 16-Base": "46844282601708",
        
          "iPhone 16-Pro": "46844282634476",
        
          "iPhone 16-Pro Max": "46844282667244",
        
          "iPhone 16-Plus": "46844282700012",
        
          "iPhone 17-Base": "46889578856684",
        
          "iPhone 17-Air": "46889578889452",
        
          "iPhone 17-Pro": "46889578922220",
        
          "iPhone 17-Pro Max": "46889578954988",
        
          "iPhone 16-E": "47189458288876"
        
      },
    
      "Alpona Chalk work": {
        
          "iPhone 12-Base": "46844280897772",
        
          "iPhone 12-Pro": "46844280930540",
        
          "iPhone 12-Pro Max": "46844280963308",
        
          "iPhone 12-Mini": "46844280996076",
        
          "iPhone 13-Base": "46844281028844",
        
          "iPhone 13-Pro": "46844281061612",
        
          "iPhone 13-Pro Max": "46844281094380",
        
          "iPhone 13-Mini": "46844281127148",
        
          "iPhone 14-Base": "46844281159916",
        
          "iPhone 14-Pro": "46844281192684",
        
          "iPhone 14-Pro Max": "46844281225452",
        
          "iPhone 14-Plus": "46844281258220",
        
          "iPhone 15-Base": "46844281290988",
        
          "iPhone 15-Pro": "46844281323756",
        
          "iPhone 15-Pro Max": "46844281356524",
        
          "iPhone 15-Plus": "46844281389292",
        
          "iPhone 16-Base": "46844281422060",
        
          "iPhone 16-Pro": "46844281454828",
        
          "iPhone 16-Pro Max": "46844281487596",
        
          "iPhone 16-Plus": "46844281520364",
        
          "iPhone 17-Base": "46889578987756",
        
          "iPhone 17-Air": "46889579020524",
        
          "iPhone 17-Pro": "46889579053292",
        
          "iPhone 17-Pro Max": "46889579086060",
        
          "iPhone 16-E": "47189458190572"
        
      },
    
      "Khovar engraving 3": {
        
          "iPhone 12-Base": "46844279881964",
        
          "iPhone 12-Pro": "46844279914732",
        
          "iPhone 12-Pro Max": "46844279947500",
        
          "iPhone 12-Mini": "46844279980268",
        
          "iPhone 13-Base": "46844280013036",
        
          "iPhone 13-Pro": "46844280045804",
        
          "iPhone 13-Pro Max": "46844280078572",
        
          "iPhone 13-Mini": "46844280111340",
        
          "iPhone 14-Base": "46844280144108",
        
          "iPhone 14-Pro": "46844280176876",
        
          "iPhone 14-Pro Max": "46844280209644",
        
          "iPhone 14-Plus": "46844280242412",
        
          "iPhone 15-Base": "46844280275180",
        
          "iPhone 15-Pro": "46844280307948",
        
          "iPhone 15-Pro Max": "46844280340716",
        
          "iPhone 15-Plus": "46844280373484",
        
          "iPhone 16-Base": "46844280406252",
        
          "iPhone 16-Pro": "46844280439020",
        
          "iPhone 16-Pro Max": "46844280471788",
        
          "iPhone 16-Plus": "46844280504556",
        
          "iPhone 17-Base": "46889579118828",
        
          "iPhone 17-Air": "46889579151596",
        
          "iPhone 17-Pro": "46889579184364",
        
          "iPhone 17-Pro Max": "46889579217132",
        
          "iPhone 16-E": "47189458125036"
        
      },
    
      "Khovar engraving 2": {
        
          "iPhone 12-Base": "46844278866156",
        
          "iPhone 12-Pro": "46844278898924",
        
          "iPhone 12-Pro Max": "46844278931692",
        
          "iPhone 12-Mini": "46844278964460",
        
          "iPhone 13-Base": "46844278997228",
        
          "iPhone 13-Pro": "46844279029996",
        
          "iPhone 13-Pro Max": "46844279062764",
        
          "iPhone 13-Mini": "46844279095532",
        
          "iPhone 14-Base": "46844279128300",
        
          "iPhone 14-Pro": "46844279161068",
        
          "iPhone 14-Pro Max": "46844279193836",
        
          "iPhone 14-Plus": "46844279226604",
        
          "iPhone 15-Base": "46844279259372",
        
          "iPhone 15-Pro": "46844279292140",
        
          "iPhone 15-Pro Max": "46844279324908",
        
          "iPhone 15-Plus": "46844279357676",
        
          "iPhone 16-Base": "46844279390444",
        
          "iPhone 16-Pro": "46844279423212",
        
          "iPhone 16-Pro Max": "46844279455980",
        
          "iPhone 16-Plus": "46844279488748",
        
          "iPhone 17-Base": "46889579249900",
        
          "iPhone 17-Air": "46889579282668",
        
          "iPhone 17-Pro": "46889579315436",
        
          "iPhone 17-Pro Max": "46889579348204",
        
          "iPhone 16-E": "47189458059500"
        
      },
    
      "Khovar engraving 1": {
        
          "iPhone 12-Base": "46844277686508",
        
          "iPhone 12-Pro": "46844277719276",
        
          "iPhone 12-Pro Max": "46844277752044",
        
          "iPhone 12-Mini": "46844277784812",
        
          "iPhone 13-Base": "46844277817580",
        
          "iPhone 13-Pro": "46844277850348",
        
          "iPhone 13-Pro Max": "46844277883116",
        
          "iPhone 13-Mini": "46844277915884",
        
          "iPhone 14-Base": "46844277948652",
        
          "iPhone 14-Pro": "46844277981420",
        
          "iPhone 14-Pro Max": "46844278014188",
        
          "iPhone 14-Plus": "46844278046956",
        
          "iPhone 15-Base": "46844278079724",
        
          "iPhone 15-Pro": "46844278112492",
        
          "iPhone 15-Pro Max": "46844278145260",
        
          "iPhone 15-Plus": "46844278178028",
        
          "iPhone 16-Base": "46844278210796",
        
          "iPhone 16-Pro": "46844278243564",
        
          "iPhone 16-Pro Max": "46844278276332",
        
          "iPhone 16-Plus": "46844278309100",
        
          "iPhone 17-Base": "46889579380972",
        
          "iPhone 17-Air": "46889579413740",
        
          "iPhone 17-Pro": "46889579446508",
        
          "iPhone 17-Pro Max": "46889579479276",
        
          "iPhone 16-E": "47189457961196"
        
      },
    
      "Sohrai": {
        
          "iPhone 12-Base": "46844276670700",
        
          "iPhone 12-Pro": "46844276703468",
        
          "iPhone 12-Pro Max": "46844276736236",
        
          "iPhone 12-Mini": "46844276769004",
        
          "iPhone 13-Base": "46844276801772",
        
          "iPhone 13-Pro": "46844276834540",
        
          "iPhone 13-Pro Max": "46844276867308",
        
          "iPhone 13-Mini": "46844276900076",
        
          "iPhone 14-Base": "46844276932844",
        
          "iPhone 14-Pro": "46844276965612",
        
          "iPhone 14-Pro Max": "46844276998380",
        
          "iPhone 14-Plus": "46844277031148",
        
          "iPhone 15-Base": "46844277063916",
        
          "iPhone 15-Pro": "46844277096684",
        
          "iPhone 15-Pro Max": "46844277129452",
        
          "iPhone 15-Plus": "46844277162220",
        
          "iPhone 16-Base": "46844277194988",
        
          "iPhone 16-Pro": "46844277227756",
        
          "iPhone 16-Pro Max": "46844277260524",
        
          "iPhone 16-Plus": "46844277293292",
        
          "iPhone 17-Base": "46889579512044",
        
          "iPhone 17-Air": "46889579544812",
        
          "iPhone 17-Pro": "46889579577580",
        
          "iPhone 17-Pro Max": "46889579610348",
        
          "iPhone 16-E": "47189457862892"
        
      },
    
      "Navaratri mirror work 3": {
        
          "iPhone 12-Base": "46844275392748",
        
          "iPhone 12-Pro": "46844275425516",
        
          "iPhone 12-Pro Max": "46844275458284",
        
          "iPhone 12-Mini": "46844275491052",
        
          "iPhone 13-Base": "46844275523820",
        
          "iPhone 13-Pro": "46844275556588",
        
          "iPhone 13-Pro Max": "46844275589356",
        
          "iPhone 13-Mini": "46844275622124",
        
          "iPhone 14-Base": "46844275654892",
        
          "iPhone 14-Pro": "46844275687660",
        
          "iPhone 14-Pro Max": "46844275720428",
        
          "iPhone 14-Plus": "46844275753196",
        
          "iPhone 15-Base": "46844275785964",
        
          "iPhone 15-Pro": "46844275818732",
        
          "iPhone 15-Pro Max": "46844275851500",
        
          "iPhone 15-Plus": "46844275884268",
        
          "iPhone 16-Base": "46844275917036",
        
          "iPhone 16-Pro": "46844275949804",
        
          "iPhone 16-Pro Max": "46844275982572",
        
          "iPhone 16-Plus": "46844276015340",
        
          "iPhone 17-Base": "46889579643116",
        
          "iPhone 17-Air": "46889579675884",
        
          "iPhone 17-Pro": "46889579708652",
        
          "iPhone 17-Pro Max": "46889579741420",
        
          "iPhone 16-E": "47189457699052"
        
      },
    
      "Navaratri mirror work 2": {
        
          "iPhone 12-Base": "46844274475244",
        
          "iPhone 12-Pro": "46844274508012",
        
          "iPhone 12-Pro Max": "46844274540780",
        
          "iPhone 12-Mini": "46844274573548",
        
          "iPhone 13-Base": "46844274606316",
        
          "iPhone 13-Pro": "46844274639084",
        
          "iPhone 13-Pro Max": "46844274671852",
        
          "iPhone 13-Mini": "46844274704620",
        
          "iPhone 14-Base": "46844274737388",
        
          "iPhone 14-Pro": "46844274770156",
        
          "iPhone 14-Pro Max": "46844274802924",
        
          "iPhone 14-Plus": "46844274835692",
        
          "iPhone 15-Base": "46844274868460",
        
          "iPhone 15-Pro": "46844274901228",
        
          "iPhone 15-Pro Max": "46844274933996",
        
          "iPhone 15-Plus": "46844274966764",
        
          "iPhone 16-Base": "46844274999532",
        
          "iPhone 16-Pro": "46844275032300",
        
          "iPhone 16-Pro Max": "46844275065068",
        
          "iPhone 16-Plus": "46844275097836",
        
          "iPhone 17-Base": "46889579872492",
        
          "iPhone 17-Air": "46889579905260",
        
          "iPhone 17-Pro": "46889579938028",
        
          "iPhone 17-Pro Max": "46889579970796",
        
          "iPhone 16-E": "47189457633516"
        
      },
    
      "Navaratri mirror work 1": {
        
          "iPhone 12-Base": "46844273721580",
        
          "iPhone 12-Pro": "46844273754348",
        
          "iPhone 12-Pro Max": "46844273787116",
        
          "iPhone 12-Mini": "46844273819884",
        
          "iPhone 13-Base": "46844273852652",
        
          "iPhone 13-Pro": "46844273885420",
        
          "iPhone 13-Pro Max": "46844273918188",
        
          "iPhone 13-Mini": "46844273950956",
        
          "iPhone 14-Base": "46844273983724",
        
          "iPhone 14-Pro": "46844274016492",
        
          "iPhone 14-Pro Max": "46844274049260",
        
          "iPhone 14-Plus": "46844274082028",
        
          "iPhone 15-Base": "46844274114796",
        
          "iPhone 15-Pro": "46844274147564",
        
          "iPhone 15-Pro Max": "46844274180332",
        
          "iPhone 15-Plus": "46844274213100",
        
          "iPhone 16-Base": "46844274245868",
        
          "iPhone 16-Pro": "46844274278636",
        
          "iPhone 16-Pro Max": "46844274311404",
        
          "iPhone 16-Plus": "46844274344172",
        
          "iPhone 17-Base": "46889580003564",
        
          "iPhone 17-Air": "46889580036332",
        
          "iPhone 17-Pro": "46889580069100",
        
          "iPhone 17-Pro Max": "46889580101868",
        
          "iPhone 16-E": "47189457567980"
        
      },
    
      "Kutch Embroidery motif 6": {
        
          "iPhone 12-Base": "46844272410860",
        
          "iPhone 12-Pro": "46844272443628",
        
          "iPhone 12-Pro Max": "46844272476396",
        
          "iPhone 12-Mini": "46844272509164",
        
          "iPhone 13-Base": "46844272541932",
        
          "iPhone 13-Pro": "46844272574700",
        
          "iPhone 13-Pro Max": "46844272607468",
        
          "iPhone 13-Mini": "46844272640236",
        
          "iPhone 14-Base": "46844272673004",
        
          "iPhone 14-Pro": "46844272705772",
        
          "iPhone 14-Pro Max": "46844272738540",
        
          "iPhone 14-Plus": "46844272771308",
        
          "iPhone 15-Base": "46844272804076",
        
          "iPhone 15-Pro": "46844272836844",
        
          "iPhone 15-Pro Max": "46844272869612",
        
          "iPhone 15-Plus": "46844272902380",
        
          "iPhone 16-Base": "46844272935148",
        
          "iPhone 16-Pro": "46844272967916",
        
          "iPhone 16-Pro Max": "46844273000684",
        
          "iPhone 16-Plus": "46844273033452",
        
          "iPhone 17-Base": "46889580167404",
        
          "iPhone 17-Air": "46889580200172",
        
          "iPhone 17-Pro": "46889580232940",
        
          "iPhone 17-Pro Max": "46889580265708",
        
          "iPhone 16-E": "47189457469676"
        
      },
    
      "Rabari Patchwork 2": {
        
          "iPhone 12-Base": "46844270379244",
        
          "iPhone 12-Pro": "46844270412012",
        
          "iPhone 12-Pro Max": "46844270444780",
        
          "iPhone 12-Mini": "46844270477548",
        
          "iPhone 13-Base": "46844270510316",
        
          "iPhone 13-Pro": "46844270543084",
        
          "iPhone 13-Pro Max": "46844270575852",
        
          "iPhone 13-Mini": "46844270608620",
        
          "iPhone 14-Base": "46844270641388",
        
          "iPhone 14-Pro": "46844270674156",
        
          "iPhone 14-Pro Max": "46844270706924",
        
          "iPhone 14-Plus": "46844270739692",
        
          "iPhone 15-Base": "46844270772460",
        
          "iPhone 15-Pro": "46844270805228",
        
          "iPhone 15-Pro Max": "46844270837996",
        
          "iPhone 15-Plus": "46844270870764",
        
          "iPhone 16-Base": "46844270903532",
        
          "iPhone 16-Pro": "46844270936300",
        
          "iPhone 16-Pro Max": "46844270969068",
        
          "iPhone 16-Plus": "46844271001836",
        
          "iPhone 17-Base": "46889580298476",
        
          "iPhone 17-Air": "46889580331244",
        
          "iPhone 17-Pro": "46889580364012",
        
          "iPhone 17-Pro Max": "46889580396780",
        
          "iPhone 16-E": "47189457404140"
        
      },
    
      "Rabari Patchwork 1": {
        
          "iPhone 12-Base": "46844269560044",
        
          "iPhone 12-Pro": "46844269592812",
        
          "iPhone 12-Pro Max": "46844269625580",
        
          "iPhone 12-Mini": "46844269658348",
        
          "iPhone 13-Base": "46844269691116",
        
          "iPhone 13-Pro": "46844269723884",
        
          "iPhone 13-Pro Max": "46844269756652",
        
          "iPhone 13-Mini": "46844269789420",
        
          "iPhone 14-Base": "46844269822188",
        
          "iPhone 14-Pro": "46844269854956",
        
          "iPhone 14-Pro Max": "46844269887724",
        
          "iPhone 14-Plus": "46844269920492",
        
          "iPhone 15-Base": "46844269953260",
        
          "iPhone 15-Pro": "46844269986028",
        
          "iPhone 15-Pro Max": "46844270018796",
        
          "iPhone 15-Plus": "46844270051564",
        
          "iPhone 16-Base": "46844270084332",
        
          "iPhone 16-Pro": "46844270117100",
        
          "iPhone 16-Pro Max": "46844270149868",
        
          "iPhone 16-Plus": "46844270182636",
        
          "iPhone 17-Base": "46889580429548",
        
          "iPhone 17-Air": "46889580462316",
        
          "iPhone 17-Pro": "46889580495084",
        
          "iPhone 17-Pro Max": "46889580527852",
        
          "iPhone 16-E": "47189457109228"
        
      },
    
      "Mata ni pachedi": {
        
          "iPhone 12-Base": "46844265922796",
        
          "iPhone 12-Pro": "46844265955564",
        
          "iPhone 12-Pro Max": "46844265988332",
        
          "iPhone 12-Mini": "46844266021100",
        
          "iPhone 13-Base": "46844266053868",
        
          "iPhone 13-Pro": "46844266086636",
        
          "iPhone 13-Pro Max": "46844266119404",
        
          "iPhone 13-Mini": "46844266152172",
        
          "iPhone 14-Base": "46844266184940",
        
          "iPhone 14-Pro": "46844266217708",
        
          "iPhone 14-Pro Max": "46844266250476",
        
          "iPhone 14-Plus": "46844266283244",
        
          "iPhone 15-Base": "46844266316012",
        
          "iPhone 15-Pro": "46844266348780",
        
          "iPhone 15-Pro Max": "46844266381548",
        
          "iPhone 15-Plus": "46844266414316",
        
          "iPhone 16-Base": "46844266447084",
        
          "iPhone 16-Pro": "46844266479852",
        
          "iPhone 16-Pro Max": "46844266512620",
        
          "iPhone 16-Plus": "46844266545388",
        
          "iPhone 17-Base": "46889580560620",
        
          "iPhone 17-Air": "46889580593388",
        
          "iPhone 17-Pro": "46889580626156",
        
          "iPhone 17-Pro Max": "46889580658924",
        
          "iPhone 16-E": "47189457010924"
        
      },
    
      "Lepcha weave": {
        
          "iPhone 12-Base": "46844264939756",
        
          "iPhone 12-Pro": "46844264972524",
        
          "iPhone 12-Pro Max": "46844265005292",
        
          "iPhone 12-Mini": "46844265038060",
        
          "iPhone 13-Base": "46844265070828",
        
          "iPhone 13-Pro": "46844265103596",
        
          "iPhone 13-Pro Max": "46844265136364",
        
          "iPhone 13-Mini": "46844265169132",
        
          "iPhone 14-Base": "46844265201900",
        
          "iPhone 14-Pro": "46844265234668",
        
          "iPhone 14-Pro Max": "46844265267436",
        
          "iPhone 14-Plus": "46844265300204",
        
          "iPhone 15-Base": "46844265332972",
        
          "iPhone 15-Pro": "46844265365740",
        
          "iPhone 15-Pro Max": "46844265398508",
        
          "iPhone 15-Plus": "46844265431276",
        
          "iPhone 16-Base": "46844265464044",
        
          "iPhone 16-Pro": "46844265496812",
        
          "iPhone 16-Pro Max": "46844265529580",
        
          "iPhone 16-Plus": "46844265562348",
        
          "iPhone 17-Base": "46889580691692",
        
          "iPhone 17-Air": "46889580724460",
        
          "iPhone 17-Pro": "46889580757228",
        
          "iPhone 17-Pro Max": "46889580789996",
        
          "iPhone 16-E": "47189456945388"
        
      },
    
      "Kullu Shawl - Gold wool on black base": {
        
          "iPhone 12-Base": "46844264022252",
        
          "iPhone 12-Pro": "46844264055020",
        
          "iPhone 12-Pro Max": "46844264087788",
        
          "iPhone 12-Mini": "46844264120556",
        
          "iPhone 13-Base": "46844264153324",
        
          "iPhone 13-Pro": "46844264186092",
        
          "iPhone 13-Pro Max": "46844264218860",
        
          "iPhone 13-Mini": "46844264251628",
        
          "iPhone 14-Base": "46844264284396",
        
          "iPhone 14-Pro": "46844264317164",
        
          "iPhone 14-Pro Max": "46844264349932",
        
          "iPhone 14-Plus": "46844264382700",
        
          "iPhone 15-Base": "46844264415468",
        
          "iPhone 15-Pro": "46844264448236",
        
          "iPhone 15-Pro Max": "46844264481004",
        
          "iPhone 15-Plus": "46844264513772",
        
          "iPhone 16-Base": "46844264546540",
        
          "iPhone 16-Pro": "46844264579308",
        
          "iPhone 16-Pro Max": "46844264612076",
        
          "iPhone 16-Plus": "46844264644844",
        
          "iPhone 17-Base": "46889580822764",
        
          "iPhone 17-Air": "46889580855532",
        
          "iPhone 17-Pro": "46889580888300",
        
          "iPhone 17-Pro Max": "46889580921068",
        
          "iPhone 16-E": "47189456879852"
        
      },
    
      "Kullu Shawl - Triangular work": {
        
          "iPhone 12-Base": "46844259795180",
        
          "iPhone 12-Pro": "46844259827948",
        
          "iPhone 12-Pro Max": "46844259860716",
        
          "iPhone 12-Mini": "46844259893484",
        
          "iPhone 13-Base": "46844259926252",
        
          "iPhone 13-Pro": "46844259959020",
        
          "iPhone 13-Pro Max": "46844259991788",
        
          "iPhone 13-Mini": "46844260024556",
        
          "iPhone 14-Base": "46844260057324",
        
          "iPhone 14-Pro": "46844260090092",
        
          "iPhone 14-Pro Max": "46844260122860",
        
          "iPhone 14-Plus": "46844260155628",
        
          "iPhone 15-Base": "46844260188396",
        
          "iPhone 15-Pro": "46844260221164",
        
          "iPhone 15-Pro Max": "46844260253932",
        
          "iPhone 15-Plus": "46844260286700",
        
          "iPhone 16-Base": "46844260319468",
        
          "iPhone 16-Pro": "46844260352236",
        
          "iPhone 16-Pro Max": "46844260385004",
        
          "iPhone 16-Plus": "46844260417772",
        
          "iPhone 17-Base": "46889580953836",
        
          "iPhone 17-Air": "46889580986604",
        
          "iPhone 17-Pro": "46889581019372",
        
          "iPhone 17-Pro Max": "46889581052140",
        
          "iPhone 16-E": "47189456781548"
        
      },
    
      "Kullu Shawl - Bold motif 2": {
        
          "iPhone 12-Base": "46844258124012",
        
          "iPhone 12-Pro": "46844258156780",
        
          "iPhone 12-Pro Max": "46844258189548",
        
          "iPhone 12-Mini": "46844258222316",
        
          "iPhone 13-Base": "46844258255084",
        
          "iPhone 13-Pro": "46844258287852",
        
          "iPhone 13-Pro Max": "46844258320620",
        
          "iPhone 13-Mini": "46844258353388",
        
          "iPhone 14-Base": "46844258386156",
        
          "iPhone 14-Pro": "46844258418924",
        
          "iPhone 14-Pro Max": "46844258451692",
        
          "iPhone 14-Plus": "46844258484460",
        
          "iPhone 15-Base": "46844258517228",
        
          "iPhone 15-Pro": "46844258549996",
        
          "iPhone 15-Pro Max": "46844258582764",
        
          "iPhone 15-Plus": "46844258615532",
        
          "iPhone 16-Base": "46844258648300",
        
          "iPhone 16-Pro": "46844258681068",
        
          "iPhone 16-Pro Max": "46844258713836",
        
          "iPhone 16-Plus": "46844258746604",
        
          "iPhone 17-Base": "46889581084908",
        
          "iPhone 17-Air": "46889581117676",
        
          "iPhone 17-Pro": "46889581150444",
        
          "iPhone 17-Pro Max": "46889581183212",
        
          "iPhone 16-E": "47189456716012"
        
      },
    
      "Kullu Shawl - Bold motif 1": {
        
          "iPhone 12-Base": "46844253569260",
        
          "iPhone 12-Pro": "46844253602028",
        
          "iPhone 12-Pro Max": "46844253634796",
        
          "iPhone 12-Mini": "46844253667564",
        
          "iPhone 13-Base": "46844253700332",
        
          "iPhone 13-Pro": "46844253733100",
        
          "iPhone 13-Pro Max": "46844253765868",
        
          "iPhone 13-Mini": "46844253798636",
        
          "iPhone 14-Base": "46844253831404",
        
          "iPhone 14-Pro": "46844253864172",
        
          "iPhone 14-Pro Max": "46844253896940",
        
          "iPhone 14-Plus": "46844253929708",
        
          "iPhone 15-Base": "46844253962476",
        
          "iPhone 15-Pro": "46844253995244",
        
          "iPhone 15-Pro Max": "46844254028012",
        
          "iPhone 15-Plus": "46844254060780",
        
          "iPhone 16-Base": "46844254093548",
        
          "iPhone 16-Pro": "46844254126316",
        
          "iPhone 16-Pro Max": "46844254159084",
        
          "iPhone 16-Plus": "46844254191852",
        
          "iPhone 17-Base": "46889581248748",
        
          "iPhone 17-Air": "46889581281516",
        
          "iPhone 17-Pro": "46889581314284",
        
          "iPhone 17-Pro Max": "46889581347052",
        
          "iPhone 16-E": "47189456650476"
        
      },
    
      "Kullu Shawl - Dotted motif": {
        
          "iPhone 12-Base": "46844246229228",
        
          "iPhone 12-Pro": "46844246261996",
        
          "iPhone 12-Pro Max": "46844246294764",
        
          "iPhone 12-Mini": "46844246327532",
        
          "iPhone 13-Base": "46844246360300",
        
          "iPhone 13-Pro": "46844246393068",
        
          "iPhone 13-Pro Max": "46844246425836",
        
          "iPhone 13-Mini": "46844246458604",
        
          "iPhone 14-Base": "46844246491372",
        
          "iPhone 14-Pro": "46844246524140",
        
          "iPhone 14-Pro Max": "46844246556908",
        
          "iPhone 14-Plus": "46844246589676",
        
          "iPhone 15-Base": "46844246622444",
        
          "iPhone 15-Pro": "46844246655212",
        
          "iPhone 15-Pro Max": "46844246687980",
        
          "iPhone 15-Plus": "46844246720748",
        
          "iPhone 16-Base": "46844246753516",
        
          "iPhone 16-Pro": "46844246786284",
        
          "iPhone 16-Pro Max": "46844246819052",
        
          "iPhone 16-Plus": "46844246851820",
        
          "iPhone 17-Base": "46889581379820",
        
          "iPhone 17-Air": "46889581412588",
        
          "iPhone 17-Pro": "46889581445356",
        
          "iPhone 17-Pro Max": "46889581478124",
        
          "iPhone 16-E": "47189456552172"
        
      },
    
      "Kullu Shawl - Serrated Diamonds": {
        
          "iPhone 12-Base": "46844245442796",
        
          "iPhone 12-Pro": "46844245475564",
        
          "iPhone 12-Pro Max": "46844245508332",
        
          "iPhone 12-Mini": "46844245541100",
        
          "iPhone 13-Base": "46844245573868",
        
          "iPhone 13-Pro": "46844245606636",
        
          "iPhone 13-Pro Max": "46844245639404",
        
          "iPhone 13-Mini": "46844245672172",
        
          "iPhone 14-Base": "46844245704940",
        
          "iPhone 14-Pro": "46844245737708",
        
          "iPhone 14-Pro Max": "46844245770476",
        
          "iPhone 14-Plus": "46844245803244",
        
          "iPhone 15-Base": "46844245836012",
        
          "iPhone 15-Pro": "46844245868780",
        
          "iPhone 15-Pro Max": "46844245901548",
        
          "iPhone 15-Plus": "46844245934316",
        
          "iPhone 16-Base": "46844245967084",
        
          "iPhone 16-Pro": "46844245999852",
        
          "iPhone 16-Pro Max": "46844246032620",
        
          "iPhone 16-Plus": "46844246065388",
        
          "iPhone 17-Base": "46889581510892",
        
          "iPhone 17-Air": "46889581543660",
        
          "iPhone 17-Pro": "46889581576428",
        
          "iPhone 17-Pro Max": "46889581609196",
        
          "iPhone 16-E": "47189456421100"
        
      },
    
      "Kullu Shawl - Stepped Chevron": {
        
          "iPhone 12-Base": "46844240232684",
        
          "iPhone 12-Pro": "46844240265452",
        
          "iPhone 12-Pro Max": "46844240298220",
        
          "iPhone 12-Mini": "46844240330988",
        
          "iPhone 13-Base": "46844240363756",
        
          "iPhone 13-Pro": "46844240396524",
        
          "iPhone 13-Pro Max": "46844240429292",
        
          "iPhone 13-Mini": "46844240462060",
        
          "iPhone 14-Base": "46844240494828",
        
          "iPhone 14-Pro": "46844240527596",
        
          "iPhone 14-Pro Max": "46844240560364",
        
          "iPhone 14-Plus": "46844240593132",
        
          "iPhone 15-Base": "46844240625900",
        
          "iPhone 15-Pro": "46844240658668",
        
          "iPhone 15-Pro Max": "46844240691436",
        
          "iPhone 15-Plus": "46844240724204",
        
          "iPhone 16-Base": "46844240756972",
        
          "iPhone 16-Pro": "46844240789740",
        
          "iPhone 16-Pro Max": "46844240822508",
        
          "iPhone 16-Plus": "46844240855276",
        
          "iPhone 17-Base": "46889581641964",
        
          "iPhone 17-Air": "46889581674732",
        
          "iPhone 17-Pro": "46889581707500",
        
          "iPhone 17-Pro Max": "46889581740268",
        
          "iPhone 16-E": "47189456355564"
        
      },
    
      "Kullu shawl - Maroon with beige base": {
        
          "iPhone 12-Base": "46844229091564",
        
          "iPhone 12-Pro": "46844229124332",
        
          "iPhone 12-Pro Max": "46844229157100",
        
          "iPhone 12-Mini": "46844229189868",
        
          "iPhone 13-Base": "46844229222636",
        
          "iPhone 13-Pro": "46844229255404",
        
          "iPhone 13-Pro Max": "46844229288172",
        
          "iPhone 13-Mini": "46844229320940",
        
          "iPhone 14-Base": "46844229353708",
        
          "iPhone 14-Pro": "46844229386476",
        
          "iPhone 14-Pro Max": "46844229419244",
        
          "iPhone 14-Plus": "46844229452012",
        
          "iPhone 15-Base": "46844229484780",
        
          "iPhone 15-Pro": "46844229517548",
        
          "iPhone 15-Pro Max": "46844229550316",
        
          "iPhone 15-Plus": "46844229583084",
        
          "iPhone 16-Base": "46844229615852",
        
          "iPhone 16-Pro": "46844229648620",
        
          "iPhone 16-Pro Max": "46844229681388",
        
          "iPhone 16-Plus": "46844229714156",
        
          "iPhone 17-Base": "46889581773036",
        
          "iPhone 17-Air": "46889581805804",
        
          "iPhone 17-Pro": "46889581838572",
        
          "iPhone 17-Pro Max": "46889581871340",
        
          "iPhone 16-E": "47189456290028"
        
      },
    
      "Sanganeri": {
        
          "iPhone 12-Base": "46844224700652",
        
          "iPhone 12-Pro": "46844224733420",
        
          "iPhone 12-Pro Max": "46844224766188",
        
          "iPhone 12-Mini": "46844224798956",
        
          "iPhone 13-Base": "46844224831724",
        
          "iPhone 13-Pro": "46844224864492",
        
          "iPhone 13-Pro Max": "46844224897260",
        
          "iPhone 13-Mini": "46844224930028",
        
          "iPhone 14-Base": "46844224962796",
        
          "iPhone 14-Pro": "46844224995564",
        
          "iPhone 14-Pro Max": "46844225028332",
        
          "iPhone 14-Plus": "46844225061100",
        
          "iPhone 15-Base": "46844225093868",
        
          "iPhone 15-Pro": "46844225126636",
        
          "iPhone 15-Pro Max": "46844225159404",
        
          "iPhone 15-Plus": "46844225192172",
        
          "iPhone 16-Base": "46844225224940",
        
          "iPhone 16-Pro": "46844225257708",
        
          "iPhone 16-Pro Max": "46844225290476",
        
          "iPhone 16-Plus": "46844225323244",
        
          "iPhone 17-Base": "46889582035180",
        
          "iPhone 17-Air": "46889582067948",
        
          "iPhone 17-Pro": "46889582100716",
        
          "iPhone 17-Pro Max": "46889582133484",
        
          "iPhone 16-E": "47189456257260"
        
      },
    
      "Kutch embroidery motif 7": {
        
          "iPhone 12-Base": "46844220211436",
        
          "iPhone 12-Pro": "46844220244204",
        
          "iPhone 12-Pro Max": "46844220276972",
        
          "iPhone 12-Mini": "46844220309740",
        
          "iPhone 13-Base": "46844220342508",
        
          "iPhone 13-Pro": "46844220375276",
        
          "iPhone 13-Pro Max": "46844220408044",
        
          "iPhone 13-Mini": "46844220440812",
        
          "iPhone 14-Base": "46844220473580",
        
          "iPhone 14-Pro": "46844220506348",
        
          "iPhone 14-Pro Max": "46844220539116",
        
          "iPhone 14-Plus": "46844220571884",
        
          "iPhone 15-Base": "46844220604652",
        
          "iPhone 15-Pro": "46844220637420",
        
          "iPhone 15-Pro Max": "46844220670188",
        
          "iPhone 15-Plus": "46844220702956",
        
          "iPhone 16-Base": "46844220735724",
        
          "iPhone 16-Pro": "46844220768492",
        
          "iPhone 16-Pro Max": "46844220801260",
        
          "iPhone 16-Plus": "46844220834028",
        
          "iPhone 17-Base": "46889582166252",
        
          "iPhone 17-Air": "46889582199020",
        
          "iPhone 17-Pro": "46889582231788",
        
          "iPhone 17-Pro Max": "46889582264556",
        
          "iPhone 16-E": "47189456191724"
        
      },
    
      "Kutch embroidery motif 5": {
        
          "iPhone 12-Base": "46844218474732",
        
          "iPhone 12-Pro": "46844218507500",
        
          "iPhone 12-Pro Max": "46844218540268",
        
          "iPhone 12-Mini": "46844218573036",
        
          "iPhone 13-Base": "46844218605804",
        
          "iPhone 13-Pro": "46844218638572",
        
          "iPhone 13-Pro Max": "46844218671340",
        
          "iPhone 13-Mini": "46844218704108",
        
          "iPhone 14-Base": "46844218736876",
        
          "iPhone 14-Pro": "46844218769644",
        
          "iPhone 14-Pro Max": "46844218802412",
        
          "iPhone 14-Plus": "46844218835180",
        
          "iPhone 15-Base": "46844218867948",
        
          "iPhone 15-Pro": "46844218900716",
        
          "iPhone 15-Pro Max": "46844218933484",
        
          "iPhone 15-Plus": "46844218966252",
        
          "iPhone 16-Base": "46844218999020",
        
          "iPhone 16-Pro": "46844219031788",
        
          "iPhone 16-Pro Max": "46844219064556",
        
          "iPhone 16-Plus": "46844219097324",
        
          "iPhone 17-Base": "46889582330092",
        
          "iPhone 17-Air": "46889582362860",
        
          "iPhone 17-Pro": "46889582395628",
        
          "iPhone 17-Pro Max": "46889582428396",
        
          "iPhone 16-E": "47189456126188"
        
      },
    
      "Gond line mesh 2": {
        
          "iPhone 12-Base": "46844210675948",
        
          "iPhone 12-Pro": "46844210708716",
        
          "iPhone 12-Pro Max": "46844210741484",
        
          "iPhone 12-Mini": "46844210774252",
        
          "iPhone 13-Base": "46844210807020",
        
          "iPhone 13-Pro": "46844210839788",
        
          "iPhone 13-Pro Max": "46844210872556",
        
          "iPhone 13-Mini": "46844210905324",
        
          "iPhone 14-Base": "46844210938092",
        
          "iPhone 14-Pro": "46844210970860",
        
          "iPhone 14-Pro Max": "46844211003628",
        
          "iPhone 14-Plus": "46844211036396",
        
          "iPhone 15-Base": "46844211069164",
        
          "iPhone 15-Pro": "46844211101932",
        
          "iPhone 15-Pro Max": "46844211134700",
        
          "iPhone 15-Plus": "46844211167468",
        
          "iPhone 16-Base": "46844211200236",
        
          "iPhone 16-Pro": "46844211233004",
        
          "iPhone 16-Pro Max": "46844211265772",
        
          "iPhone 16-Plus": "46844211298540",
        
          "iPhone 17-Base": "46889582461164",
        
          "iPhone 17-Air": "46889582493932",
        
          "iPhone 17-Pro": "46889582526700",
        
          "iPhone 17-Pro Max": "46889582559468",
        
          "iPhone 16-E": "47189456060652"
        
      },
    
      "Jaipuria blue pottery": {
        
          "iPhone 12-Base": "46844194128108",
        
          "iPhone 12-Pro": "46844194160876",
        
          "iPhone 12-Pro Max": "46844194193644",
        
          "iPhone 12-Mini": "46844194226412",
        
          "iPhone 13-Base": "46844194259180",
        
          "iPhone 13-Pro": "46844194291948",
        
          "iPhone 13-Pro Max": "46844194324716",
        
          "iPhone 13-Mini": "46844194357484",
        
          "iPhone 14-Base": "46844194390252",
        
          "iPhone 14-Pro": "46844194423020",
        
          "iPhone 14-Pro Max": "46844194455788",
        
          "iPhone 14-Plus": "46844194488556",
        
          "iPhone 15-Base": "46844194521324",
        
          "iPhone 15-Pro": "46844194554092",
        
          "iPhone 15-Pro Max": "46844194586860",
        
          "iPhone 15-Plus": "46844194619628",
        
          "iPhone 16-Base": "46844194652396",
        
          "iPhone 16-Pro": "46844194685164",
        
          "iPhone 16-Pro Max": "46844194717932",
        
          "iPhone 16-Plus": "46844194750700",
        
          "iPhone 17-Base": "46889582592236",
        
          "iPhone 17-Air": "46889582625004",
        
          "iPhone 17-Pro": "46889582657772",
        
          "iPhone 17-Pro Max": "46889582690540",
        
          "iPhone 16-E": "47189455995116"
        
      },
    
      "Aainakari 1": {
        
          "iPhone 12-Base": "46844193341676",
        
          "iPhone 12-Pro": "46844193374444",
        
          "iPhone 12-Pro Max": "46844193407212",
        
          "iPhone 12-Mini": "46844193439980",
        
          "iPhone 13-Base": "46844193472748",
        
          "iPhone 13-Pro": "46844193505516",
        
          "iPhone 13-Pro Max": "46844193538284",
        
          "iPhone 13-Mini": "46844193571052",
        
          "iPhone 14-Base": "46844193603820",
        
          "iPhone 14-Pro": "46844193636588",
        
          "iPhone 14-Pro Max": "46844193669356",
        
          "iPhone 14-Plus": "46844193702124",
        
          "iPhone 15-Base": "46844193734892",
        
          "iPhone 15-Pro": "46844193767660",
        
          "iPhone 15-Pro Max": "46844193800428",
        
          "iPhone 15-Plus": "46844193833196",
        
          "iPhone 16-Base": "46844193865964",
        
          "iPhone 16-Pro": "46844193898732",
        
          "iPhone 16-Pro Max": "46844193931500",
        
          "iPhone 16-Plus": "46844193964268",
        
          "iPhone 17-Base": "46889582723308",
        
          "iPhone 17-Air": "46889582756076",
        
          "iPhone 17-Pro": "46889582788844",
        
          "iPhone 17-Pro Max": "46889582821612",
        
          "iPhone 16-E": "47189455929580"
        
      },
    
      "Aainakari 2": {
        
          "iPhone 12-Base": "46844191736044",
        
          "iPhone 12-Pro": "46844191768812",
        
          "iPhone 12-Pro Max": "46844191801580",
        
          "iPhone 12-Mini": "46844191834348",
        
          "iPhone 13-Base": "46844191867116",
        
          "iPhone 13-Pro": "46844191899884",
        
          "iPhone 13-Pro Max": "46844191932652",
        
          "iPhone 13-Mini": "46844191965420",
        
          "iPhone 14-Base": "46844191998188",
        
          "iPhone 14-Pro": "46844192030956",
        
          "iPhone 14-Pro Max": "46844192063724",
        
          "iPhone 14-Plus": "46844192096492",
        
          "iPhone 15-Base": "46844192129260",
        
          "iPhone 15-Pro": "46844192162028",
        
          "iPhone 15-Pro Max": "46844192194796",
        
          "iPhone 15-Plus": "46844192227564",
        
          "iPhone 16-Base": "46844192260332",
        
          "iPhone 16-Pro": "46844192293100",
        
          "iPhone 16-Pro Max": "46844192325868",
        
          "iPhone 16-Plus": "46844192358636",
        
          "iPhone 17-Base": "46889582854380",
        
          "iPhone 17-Air": "46889582887148",
        
          "iPhone 17-Pro": "46889582919916",
        
          "iPhone 17-Pro Max": "46889582952684",
        
          "iPhone 16-E": "47189455864044"
        
      },
    
      "Moarragh tile": {
        
          "iPhone 12-Base": "46844190753004",
        
          "iPhone 12-Pro": "46844190785772",
        
          "iPhone 12-Pro Max": "46844190818540",
        
          "iPhone 12-Mini": "46844190851308",
        
          "iPhone 13-Base": "46844190884076",
        
          "iPhone 13-Pro": "46844190916844",
        
          "iPhone 13-Pro Max": "46844190949612",
        
          "iPhone 13-Mini": "46844190982380",
        
          "iPhone 14-Base": "46844191015148",
        
          "iPhone 14-Pro": "46844191047916",
        
          "iPhone 14-Pro Max": "46844191080684",
        
          "iPhone 14-Plus": "46844191113452",
        
          "iPhone 15-Base": "46844191146220",
        
          "iPhone 15-Pro": "46844191178988",
        
          "iPhone 15-Pro Max": "46844191211756",
        
          "iPhone 15-Plus": "46844191244524",
        
          "iPhone 16-Base": "46844191277292",
        
          "iPhone 16-Pro": "46844191310060",
        
          "iPhone 16-Pro Max": "46844191342828",
        
          "iPhone 16-Plus": "46844191375596",
        
          "iPhone 17-Base": "46889582985452",
        
          "iPhone 17-Air": "46889583018220",
        
          "iPhone 17-Pro": "46889583050988",
        
          "iPhone 17-Pro Max": "46889583083756",
        
          "iPhone 16-E": "47189455798508"
        
      },
    
      "Haft rang ceramic 1": {
        
          "iPhone 12-Base": "46844189573356",
        
          "iPhone 12-Pro": "46844189606124",
        
          "iPhone 12-Pro Max": "46844189638892",
        
          "iPhone 12-Mini": "46844189671660",
        
          "iPhone 13-Base": "46844189704428",
        
          "iPhone 13-Pro": "46844189737196",
        
          "iPhone 13-Pro Max": "46844189769964",
        
          "iPhone 13-Mini": "46844189802732",
        
          "iPhone 14-Base": "46844189835500",
        
          "iPhone 14-Pro": "46844189868268",
        
          "iPhone 14-Pro Max": "46844189901036",
        
          "iPhone 14-Plus": "46844189933804",
        
          "iPhone 15-Base": "46844189966572",
        
          "iPhone 15-Pro": "46844189999340",
        
          "iPhone 15-Pro Max": "46844190032108",
        
          "iPhone 15-Plus": "46844190064876",
        
          "iPhone 16-Base": "46844190097644",
        
          "iPhone 16-Pro": "46844190130412",
        
          "iPhone 16-Pro Max": "46844190163180",
        
          "iPhone 16-Plus": "46844190195948",
        
          "iPhone 17-Base": "46889583116524",
        
          "iPhone 17-Air": "46889583149292",
        
          "iPhone 17-Pro": "46889583182060",
        
          "iPhone 17-Pro Max": "46889583214828",
        
          "iPhone 16-E": "47189455732972"
        
      },
    
      "Haft rang ceramic 2": {
        
          "iPhone 12-Base": "46844188655852",
        
          "iPhone 12-Pro": "46844188688620",
        
          "iPhone 12-Pro Max": "46844188721388",
        
          "iPhone 12-Mini": "46844188754156",
        
          "iPhone 13-Base": "46844188786924",
        
          "iPhone 13-Pro": "46844188819692",
        
          "iPhone 13-Pro Max": "46844188852460",
        
          "iPhone 13-Mini": "46844188885228",
        
          "iPhone 14-Base": "46844188917996",
        
          "iPhone 14-Pro": "46844188950764",
        
          "iPhone 14-Pro Max": "46844188983532",
        
          "iPhone 14-Plus": "46844189016300",
        
          "iPhone 15-Base": "46844189049068",
        
          "iPhone 15-Pro": "46844189081836",
        
          "iPhone 15-Pro Max": "46844189114604",
        
          "iPhone 15-Plus": "46844189147372",
        
          "iPhone 16-Base": "46844189180140",
        
          "iPhone 16-Pro": "46844189212908",
        
          "iPhone 16-Pro Max": "46844189245676",
        
          "iPhone 16-Plus": "46844189278444",
        
          "iPhone 17-Base": "46889583247596",
        
          "iPhone 17-Air": "46889583280364",
        
          "iPhone 17-Pro": "46889583313132",
        
          "iPhone 17-Pro Max": "46889583345900",
        
          "iPhone 16-E": "47189455667436"
        
      },
    
      "Iberian heritage 1": {
        
          "iPhone 12-Base": "46844187017452",
        
          "iPhone 12-Pro": "46844187050220",
        
          "iPhone 12-Pro Max": "46844187082988",
        
          "iPhone 12-Mini": "46844187115756",
        
          "iPhone 13-Base": "46844187148524",
        
          "iPhone 13-Pro": "46844187181292",
        
          "iPhone 13-Pro Max": "46844187214060",
        
          "iPhone 13-Mini": "46844187246828",
        
          "iPhone 14-Base": "46844187279596",
        
          "iPhone 14-Pro": "46844187312364",
        
          "iPhone 14-Pro Max": "46844187345132",
        
          "iPhone 14-Plus": "46844187377900",
        
          "iPhone 15-Base": "46844187410668",
        
          "iPhone 15-Pro": "46844187443436",
        
          "iPhone 15-Pro Max": "46844187476204",
        
          "iPhone 15-Plus": "46844187508972",
        
          "iPhone 16-Base": "46844187541740",
        
          "iPhone 16-Pro": "46844187574508",
        
          "iPhone 16-Pro Max": "46844187607276",
        
          "iPhone 16-Plus": "46844187640044",
        
          "iPhone 17-Base": "46889583411436",
        
          "iPhone 17-Air": "46889583444204",
        
          "iPhone 17-Pro": "46889583476972",
        
          "iPhone 17-Pro Max": "46889583509740",
        
          "iPhone 16-E": "47189455569132"
        
      },
    
      "Iberian heritage 2": {
        
          "iPhone 12-Base": "46844185444588",
        
          "iPhone 12-Pro": "46844185477356",
        
          "iPhone 12-Pro Max": "46844185510124",
        
          "iPhone 12-Mini": "46844185542892",
        
          "iPhone 13-Base": "46844185575660",
        
          "iPhone 13-Pro": "46844185608428",
        
          "iPhone 13-Pro Max": "46844185641196",
        
          "iPhone 13-Mini": "46844185673964",
        
          "iPhone 14-Base": "46844185706732",
        
          "iPhone 14-Pro": "46844185739500",
        
          "iPhone 14-Pro Max": "46844185772268",
        
          "iPhone 14-Plus": "46844185805036",
        
          "iPhone 15-Base": "46844185837804",
        
          "iPhone 15-Pro": "46844185870572",
        
          "iPhone 15-Pro Max": "46844185903340",
        
          "iPhone 15-Plus": "46844185936108",
        
          "iPhone 16-Base": "46844185968876",
        
          "iPhone 16-Pro": "46844186001644",
        
          "iPhone 16-Pro Max": "46844186034412",
        
          "iPhone 16-Plus": "46844186067180",
        
          "iPhone 17-Base": "46889583542508",
        
          "iPhone 17-Air": "46889583575276",
        
          "iPhone 17-Pro": "46889583608044",
        
          "iPhone 17-Pro Max": "46889583640812",
        
          "iPhone 16-E": "47189455470828"
        
      },
    
      "Azulejo tile 2": {
        
          "iPhone 12-Base": "46844183085292",
        
          "iPhone 12-Pro": "46844183118060",
        
          "iPhone 12-Pro Max": "46844183150828",
        
          "iPhone 12-Mini": "46844183183596",
        
          "iPhone 13-Base": "46844183216364",
        
          "iPhone 13-Pro": "46844183249132",
        
          "iPhone 13-Pro Max": "46844183281900",
        
          "iPhone 13-Mini": "46844183314668",
        
          "iPhone 14-Base": "46844183347436",
        
          "iPhone 14-Pro": "46844183380204",
        
          "iPhone 14-Pro Max": "46844183412972",
        
          "iPhone 14-Plus": "46844183445740",
        
          "iPhone 15-Base": "46844183478508",
        
          "iPhone 15-Pro": "46844183511276",
        
          "iPhone 15-Pro Max": "46844183544044",
        
          "iPhone 15-Plus": "46844183576812",
        
          "iPhone 16-Base": "46844183609580",
        
          "iPhone 16-Pro": "46844183642348",
        
          "iPhone 16-Pro Max": "46844183675116",
        
          "iPhone 16-Plus": "46844183707884",
        
          "iPhone 17-Base": "46889583706348",
        
          "iPhone 17-Air": "46889583739116",
        
          "iPhone 17-Pro": "46889583771884",
        
          "iPhone 17-Pro Max": "46889583804652",
        
          "iPhone 16-E": "47189455372524"
        
      },
    
      "Azulejo tile 1": {
        
          "iPhone 12-Base": "46844182102252",
        
          "iPhone 12-Pro": "46844182135020",
        
          "iPhone 12-Pro Max": "46844182167788",
        
          "iPhone 12-Mini": "46844182200556",
        
          "iPhone 13-Base": "46844182233324",
        
          "iPhone 13-Pro": "46844182266092",
        
          "iPhone 13-Pro Max": "46844182298860",
        
          "iPhone 13-Mini": "46844182331628",
        
          "iPhone 14-Base": "46844182364396",
        
          "iPhone 14-Pro": "46844182397164",
        
          "iPhone 14-Pro Max": "46844182429932",
        
          "iPhone 14-Plus": "46844182462700",
        
          "iPhone 15-Base": "46844182495468",
        
          "iPhone 15-Pro": "46844182528236",
        
          "iPhone 15-Pro Max": "46844182561004",
        
          "iPhone 15-Plus": "46844182593772",
        
          "iPhone 16-Base": "46844182626540",
        
          "iPhone 16-Pro": "46844182659308",
        
          "iPhone 16-Pro Max": "46844182692076",
        
          "iPhone 16-Plus": "46844182724844",
        
          "iPhone 17-Base": "46889583837420",
        
          "iPhone 17-Air": "46889583870188",
        
          "iPhone 17-Pro": "46889583902956",
        
          "iPhone 17-Pro Max": "46889583935724",
        
          "iPhone 16-E": "47189455274220"
        
      },
    
      "Papier mache": {
        
          "iPhone 12-Base": "46844181283052",
        
          "iPhone 12-Pro": "46844181315820",
        
          "iPhone 12-Pro Max": "46844181348588",
        
          "iPhone 12-Mini": "46844181381356",
        
          "iPhone 13-Base": "46844181414124",
        
          "iPhone 13-Pro": "46844181446892",
        
          "iPhone 13-Pro Max": "46844181479660",
        
          "iPhone 13-Mini": "46844181512428",
        
          "iPhone 14-Base": "46844181545196",
        
          "iPhone 14-Pro": "46844181577964",
        
          "iPhone 14-Pro Max": "46844181610732",
        
          "iPhone 14-Plus": "46844181643500",
        
          "iPhone 15-Base": "46844181676268",
        
          "iPhone 15-Pro": "46844181709036",
        
          "iPhone 15-Pro Max": "46844181741804",
        
          "iPhone 15-Plus": "46844181774572",
        
          "iPhone 16-Base": "46844181807340",
        
          "iPhone 16-Pro": "46844181840108",
        
          "iPhone 16-Pro Max": "46844181872876",
        
          "iPhone 16-Plus": "46844181905644",
        
          "iPhone 17-Base": "46889584001260",
        
          "iPhone 17-Air": "46889584034028",
        
          "iPhone 17-Pro": "46889584066796",
        
          "iPhone 17-Pro Max": "46889584099564",
        
          "iPhone 16-E": "47189455175916"
        
      },
    
      "Chinar motif": {
        
          "iPhone 12-Base": "46844180234476",
        
          "iPhone 12-Pro": "46844180267244",
        
          "iPhone 12-Pro Max": "46844180300012",
        
          "iPhone 12-Mini": "46844180332780",
        
          "iPhone 13-Base": "46844180365548",
        
          "iPhone 13-Pro": "46844180398316",
        
          "iPhone 13-Pro Max": "46844180431084",
        
          "iPhone 13-Mini": "46844180463852",
        
          "iPhone 14-Base": "46844180496620",
        
          "iPhone 14-Pro": "46844180529388",
        
          "iPhone 14-Pro Max": "46844180562156",
        
          "iPhone 14-Plus": "46844180594924",
        
          "iPhone 15-Base": "46844180627692",
        
          "iPhone 15-Pro": "46844180660460",
        
          "iPhone 15-Pro Max": "46844180693228",
        
          "iPhone 15-Plus": "46844180725996",
        
          "iPhone 16-Base": "46844180758764",
        
          "iPhone 16-Pro": "46844180791532",
        
          "iPhone 16-Pro Max": "46844180824300",
        
          "iPhone 16-Plus": "46844180857068",
        
          "iPhone 17-Base": "46889584197868",
        
          "iPhone 17-Air": "46889584230636",
        
          "iPhone 17-Pro": "46889584263404",
        
          "iPhone 17-Pro Max": "46889584296172",
        
          "iPhone 16-E": "47189454913772"
        
      },
    
      "Kani weave": {
        
          "iPhone 12-Base": "46844179382508",
        
          "iPhone 12-Pro": "46844179415276",
        
          "iPhone 12-Pro Max": "46844179448044",
        
          "iPhone 12-Mini": "46844179480812",
        
          "iPhone 13-Base": "46844179513580",
        
          "iPhone 13-Pro": "46844179546348",
        
          "iPhone 13-Pro Max": "46844179579116",
        
          "iPhone 13-Mini": "46844179611884",
        
          "iPhone 14-Base": "46844179644652",
        
          "iPhone 14-Pro": "46844179677420",
        
          "iPhone 14-Pro Max": "46844179710188",
        
          "iPhone 14-Plus": "46844179742956",
        
          "iPhone 15-Base": "46844179775724",
        
          "iPhone 15-Pro": "46844179808492",
        
          "iPhone 15-Pro Max": "46844179841260",
        
          "iPhone 15-Plus": "46844179874028",
        
          "iPhone 16-Base": "46844179906796",
        
          "iPhone 16-Pro": "46844179939564",
        
          "iPhone 16-Pro Max": "46844179972332",
        
          "iPhone 16-Plus": "46844180005100",
        
          "iPhone 17-Base": "46889584361708",
        
          "iPhone 17-Air": "46889584394476",
        
          "iPhone 17-Pro": "46889584427244",
        
          "iPhone 17-Pro Max": "46889584460012",
        
          "iPhone 16-E": "47189454618860"
        
      },
    
      "Tikuli Motif": {
        
          "iPhone 12-Base": "46844177940716",
        
          "iPhone 12-Pro": "46844177973484",
        
          "iPhone 12-Pro Max": "46844178006252",
        
          "iPhone 12-Mini": "46844178039020",
        
          "iPhone 13-Base": "46844178071788",
        
          "iPhone 13-Pro": "46844178104556",
        
          "iPhone 13-Pro Max": "46844178137324",
        
          "iPhone 13-Mini": "46844178170092",
        
          "iPhone 14-Base": "46844178202860",
        
          "iPhone 14-Pro": "46844178235628",
        
          "iPhone 14-Pro Max": "46844178268396",
        
          "iPhone 14-Plus": "46844178301164",
        
          "iPhone 15-Base": "46844178333932",
        
          "iPhone 15-Pro": "46844178366700",
        
          "iPhone 15-Pro Max": "46844178399468",
        
          "iPhone 15-Plus": "46844178432236",
        
          "iPhone 16-Base": "46844178465004",
        
          "iPhone 16-Pro": "46844178497772",
        
          "iPhone 16-Pro Max": "46844178530540",
        
          "iPhone 16-Plus": "46844178563308",
        
          "iPhone 17-Base": "46889584492780",
        
          "iPhone 17-Air": "46889584525548",
        
          "iPhone 17-Pro": "46889584558316",
        
          "iPhone 17-Pro Max": "46889584591084",
        
          "iPhone 16-E": "47189454356716"
        
      },
    
      "Kachni Madhubani": {
        
          "iPhone 12-Base": "46844176761068",
        
          "iPhone 12-Pro": "46844176793836",
        
          "iPhone 12-Pro Max": "46844176826604",
        
          "iPhone 12-Mini": "46844176859372",
        
          "iPhone 13-Base": "46844176892140",
        
          "iPhone 13-Pro": "46844176924908",
        
          "iPhone 13-Pro Max": "46844176957676",
        
          "iPhone 13-Mini": "46844176990444",
        
          "iPhone 14-Base": "46844177023212",
        
          "iPhone 14-Pro": "46844177055980",
        
          "iPhone 14-Pro Max": "46844177088748",
        
          "iPhone 14-Plus": "46844177121516",
        
          "iPhone 15-Base": "46844177154284",
        
          "iPhone 15-Pro": "46844177187052",
        
          "iPhone 15-Pro Max": "46844177219820",
        
          "iPhone 15-Plus": "46844177252588",
        
          "iPhone 16-Base": "46844177285356",
        
          "iPhone 16-Pro": "46844177318124",
        
          "iPhone 16-Pro Max": "46844177350892",
        
          "iPhone 16-Plus": "46844177383660",
        
          "iPhone 17-Base": "46889584623852",
        
          "iPhone 17-Air": "46889584656620",
        
          "iPhone 17-Pro": "46889584689388",
        
          "iPhone 17-Pro Max": "46889584722156",
        
          "iPhone 16-E": "47189454094572"
        
      },
    
      "Hereke Silk Carpet 2": {
        
          "iPhone 12-Base": "46694213157100",
        
          "iPhone 12-Pro": "46694213189868",
        
          "iPhone 12-Pro Max": "46694213222636",
        
          "iPhone 12-Mini": "46694213255404",
        
          "iPhone 13-Base": "46694213288172",
        
          "iPhone 13-Pro": "46694213320940",
        
          "iPhone 13-Pro Max": "46694213353708",
        
          "iPhone 13-Mini": "46694213386476",
        
          "iPhone 14-Base": "46694213419244",
        
          "iPhone 14-Pro": "46694213452012",
        
          "iPhone 14-Pro Max": "46694213484780",
        
          "iPhone 14-Plus": "46694213517548",
        
          "iPhone 15-Base": "46694213550316",
        
          "iPhone 15-Pro": "46694213583084",
        
          "iPhone 15-Pro Max": "46694213615852",
        
          "iPhone 15-Plus": "46694213648620",
        
          "iPhone 16-Base": "46694213681388",
        
          "iPhone 16-Pro": "46694213714156",
        
          "iPhone 16-Pro Max": "46694213746924",
        
          "iPhone 16-Plus": "46694213779692",
        
          "iPhone 17-Base": "46889584754924",
        
          "iPhone 17-Air": "46889584787692",
        
          "iPhone 17-Pro": "46889584820460",
        
          "iPhone 17-Pro Max": "46889584853228",
        
          "iPhone 16-E": "47189453832428"
        
      },
    
      "Hereke Silk Carpet 1": {
        
          "iPhone 12-Base": "46694212305132",
        
          "iPhone 12-Pro": "46694212337900",
        
          "iPhone 12-Pro Max": "46694212370668",
        
          "iPhone 12-Mini": "46694212403436",
        
          "iPhone 13-Base": "46694212436204",
        
          "iPhone 13-Pro": "46694212468972",
        
          "iPhone 13-Pro Max": "46694212501740",
        
          "iPhone 13-Mini": "46694212534508",
        
          "iPhone 14-Base": "46694212567276",
        
          "iPhone 14-Pro": "46694212600044",
        
          "iPhone 14-Pro Max": "46694212632812",
        
          "iPhone 14-Plus": "46694212665580",
        
          "iPhone 15-Base": "46694212698348",
        
          "iPhone 15-Pro": "46694212731116",
        
          "iPhone 15-Pro Max": "46694212763884",
        
          "iPhone 15-Plus": "46694212796652",
        
          "iPhone 16-Base": "46694212829420",
        
          "iPhone 16-Pro": "46694212862188",
        
          "iPhone 16-Pro Max": "46694212894956",
        
          "iPhone 16-Plus": "46694212927724",
        
          "iPhone 17-Base": "46889584885996",
        
          "iPhone 17-Air": "46889584918764",
        
          "iPhone 17-Pro": "46889584951532",
        
          "iPhone 17-Pro Max": "46889584984300",
        
          "iPhone 16-E": "47189453537516"
        
      },
    
      "Flatwoven Turkish Kilim 2": {
        
          "iPhone 12-Base": "46694210961644",
        
          "iPhone 12-Pro": "46694210994412",
        
          "iPhone 12-Pro Max": "46694211027180",
        
          "iPhone 12-Mini": "46694211059948",
        
          "iPhone 13-Base": "46694211092716",
        
          "iPhone 13-Pro": "46694211125484",
        
          "iPhone 13-Pro Max": "46694211158252",
        
          "iPhone 13-Mini": "46694211191020",
        
          "iPhone 14-Base": "46694211223788",
        
          "iPhone 14-Pro": "46694211256556",
        
          "iPhone 14-Pro Max": "46694211289324",
        
          "iPhone 14-Plus": "46694211322092",
        
          "iPhone 15-Base": "46694211354860",
        
          "iPhone 15-Pro": "46694211387628",
        
          "iPhone 15-Pro Max": "46694211420396",
        
          "iPhone 15-Plus": "46694211453164",
        
          "iPhone 16-Base": "46694211485932",
        
          "iPhone 16-Pro": "46694211518700",
        
          "iPhone 16-Pro Max": "46694211551468",
        
          "iPhone 16-Plus": "46694211584236",
        
          "iPhone 17-Base": "46889585017068",
        
          "iPhone 17-Air": "46889585049836",
        
          "iPhone 17-Pro": "46889585082604",
        
          "iPhone 17-Pro Max": "46889585115372",
        
          "iPhone 16-E": "47189453308140"
        
      },
    
      "Flatwoven Turkish Kilim 1": {
        
          "iPhone 12-Base": "46694210076908",
        
          "iPhone 12-Pro": "46694210109676",
        
          "iPhone 12-Pro Max": "46694210142444",
        
          "iPhone 12-Mini": "46694210175212",
        
          "iPhone 13-Base": "46694210207980",
        
          "iPhone 13-Pro": "46694210240748",
        
          "iPhone 13-Pro Max": "46694210273516",
        
          "iPhone 13-Mini": "46694210306284",
        
          "iPhone 14-Base": "46694210339052",
        
          "iPhone 14-Pro": "46694210371820",
        
          "iPhone 14-Pro Max": "46694210404588",
        
          "iPhone 14-Plus": "46694210437356",
        
          "iPhone 15-Base": "46694210470124",
        
          "iPhone 15-Pro": "46694210502892",
        
          "iPhone 15-Pro Max": "46694210535660",
        
          "iPhone 15-Plus": "46694210568428",
        
          "iPhone 16-Base": "46694210601196",
        
          "iPhone 16-Pro": "46694210633964",
        
          "iPhone 16-Pro Max": "46694210666732",
        
          "iPhone 16-Plus": "46694210699500",
        
          "iPhone 17-Base": "46889585148140",
        
          "iPhone 17-Air": "46889585180908",
        
          "iPhone 17-Pro": "46889585213676",
        
          "iPhone 17-Pro Max": "46889585246444",
        
          "iPhone 16-E": "47189453111532"
        
      },
    
      "Cappadocian Nomadic Wool 2": {
        
          "iPhone 12-Base": "46694209257708",
        
          "iPhone 12-Pro": "46694209290476",
        
          "iPhone 12-Pro Max": "46694209323244",
        
          "iPhone 12-Mini": "46694209356012",
        
          "iPhone 13-Base": "46694209388780",
        
          "iPhone 13-Pro": "46694209421548",
        
          "iPhone 13-Pro Max": "46694209454316",
        
          "iPhone 13-Mini": "46694209487084",
        
          "iPhone 14-Base": "46694209519852",
        
          "iPhone 14-Pro": "46694209552620",
        
          "iPhone 14-Pro Max": "46694209585388",
        
          "iPhone 14-Plus": "46694209618156",
        
          "iPhone 15-Base": "46694209650924",
        
          "iPhone 15-Pro": "46694209683692",
        
          "iPhone 15-Pro Max": "46694209716460",
        
          "iPhone 15-Plus": "46694209749228",
        
          "iPhone 16-Base": "46694209781996",
        
          "iPhone 16-Pro": "46694209814764",
        
          "iPhone 16-Pro Max": "46694209847532",
        
          "iPhone 16-Plus": "46694209880300",
        
          "iPhone 17-Base": "46889585279212",
        
          "iPhone 17-Air": "46889585311980",
        
          "iPhone 17-Pro": "46889585344748",
        
          "iPhone 17-Pro Max": "46889585377516",
        
          "iPhone 16-E": "47189452980460"
        
      },
    
      "Cappadocian Nomadic Wool 1": {
        
          "iPhone 12-Base": "46694208372972",
        
          "iPhone 12-Pro": "46694208405740",
        
          "iPhone 12-Pro Max": "46694208438508",
        
          "iPhone 12-Mini": "46694208471276",
        
          "iPhone 13-Base": "46694208504044",
        
          "iPhone 13-Pro": "46694208536812",
        
          "iPhone 13-Pro Max": "46694208569580",
        
          "iPhone 13-Mini": "46694208602348",
        
          "iPhone 14-Base": "46694208635116",
        
          "iPhone 14-Pro": "46694208667884",
        
          "iPhone 14-Pro Max": "46694208700652",
        
          "iPhone 14-Plus": "46694208733420",
        
          "iPhone 15-Base": "46694208766188",
        
          "iPhone 15-Pro": "46694208798956",
        
          "iPhone 15-Pro Max": "46694208831724",
        
          "iPhone 15-Plus": "46694208864492",
        
          "iPhone 16-Base": "46694208897260",
        
          "iPhone 16-Pro": "46694208930028",
        
          "iPhone 16-Pro Max": "46694208962796",
        
          "iPhone 16-Plus": "46694208995564",
        
          "iPhone 17-Base": "46889585410284",
        
          "iPhone 17-Air": "46889585443052",
        
          "iPhone 17-Pro": "46889585475820",
        
          "iPhone 17-Pro Max": "46889585508588",
        
          "iPhone 16-E": "47189452849388"
        
      },
    
      "Iznik Ceramic Carnations 2": {
        
          "iPhone 12-Base": "46694207422700",
        
          "iPhone 12-Pro": "46694207455468",
        
          "iPhone 12-Pro Max": "46694207488236",
        
          "iPhone 12-Mini": "46694207521004",
        
          "iPhone 13-Base": "46694207553772",
        
          "iPhone 13-Pro": "46694207586540",
        
          "iPhone 13-Pro Max": "46694207619308",
        
          "iPhone 13-Mini": "46694207652076",
        
          "iPhone 14-Base": "46694207684844",
        
          "iPhone 14-Pro": "46694207717612",
        
          "iPhone 14-Pro Max": "46694207750380",
        
          "iPhone 14-Plus": "46694207783148",
        
          "iPhone 15-Base": "46694207815916",
        
          "iPhone 15-Pro": "46694207848684",
        
          "iPhone 15-Pro Max": "46694207881452",
        
          "iPhone 15-Plus": "46694207914220",
        
          "iPhone 16-Base": "46694207946988",
        
          "iPhone 16-Pro": "46694207979756",
        
          "iPhone 16-Pro Max": "46694208012524",
        
          "iPhone 16-Plus": "46694208045292",
        
          "iPhone 17-Base": "46889585541356",
        
          "iPhone 17-Air": "46889585574124",
        
          "iPhone 17-Pro": "46889585606892",
        
          "iPhone 17-Pro Max": "46889585639660",
        
          "iPhone 16-E": "47189452751084"
        
      },
    
      "Iznik Ceramic Carnations 1": {
        
          "iPhone 12-Base": "46694206603500",
        
          "iPhone 12-Pro": "46694206636268",
        
          "iPhone 12-Pro Max": "46694206669036",
        
          "iPhone 12-Mini": "46694206701804",
        
          "iPhone 13-Base": "46694206734572",
        
          "iPhone 13-Pro": "46694206767340",
        
          "iPhone 13-Pro Max": "46694206800108",
        
          "iPhone 13-Mini": "46694206832876",
        
          "iPhone 14-Base": "46694206865644",
        
          "iPhone 14-Pro": "46694206898412",
        
          "iPhone 14-Pro Max": "46694206931180",
        
          "iPhone 14-Plus": "46694206963948",
        
          "iPhone 15-Base": "46694206996716",
        
          "iPhone 15-Pro": "46694207029484",
        
          "iPhone 15-Pro Max": "46694207062252",
        
          "iPhone 15-Plus": "46694207095020",
        
          "iPhone 16-Base": "46694207127788",
        
          "iPhone 16-Pro": "46694207160556",
        
          "iPhone 16-Pro Max": "46694207193324",
        
          "iPhone 16-Plus": "46694207226092",
        
          "iPhone 17-Base": "46889587245292",
        
          "iPhone 17-Air": "46889587278060",
        
          "iPhone 17-Pro": "46889587310828",
        
          "iPhone 17-Pro Max": "46889587343596",
        
          "iPhone 16-E": "47189452652780"
        
      },
    
      "Muga silk embroidery 2": {
        
          "iPhone 12-Base": "46694205292780",
        
          "iPhone 12-Pro": "46694205325548",
        
          "iPhone 12-Pro Max": "46694205358316",
        
          "iPhone 12-Mini": "46694205391084",
        
          "iPhone 13-Base": "46694205423852",
        
          "iPhone 13-Pro": "46694205456620",
        
          "iPhone 13-Pro Max": "46694205489388",
        
          "iPhone 13-Mini": "46694205522156",
        
          "iPhone 14-Base": "46694205554924",
        
          "iPhone 14-Pro": "46694205587692",
        
          "iPhone 14-Pro Max": "46694205620460",
        
          "iPhone 14-Plus": "46694205653228",
        
          "iPhone 15-Base": "46694205685996",
        
          "iPhone 15-Pro": "46694205718764",
        
          "iPhone 15-Pro Max": "46694205751532",
        
          "iPhone 15-Plus": "46694205784300",
        
          "iPhone 16-Base": "46694205817068",
        
          "iPhone 16-Pro": "46694205849836",
        
          "iPhone 16-Pro Max": "46694205882604",
        
          "iPhone 16-Plus": "46694205915372",
        
          "iPhone 17-Base": "46889587376364",
        
          "iPhone 17-Air": "46889587409132",
        
          "iPhone 17-Pro": "46889587441900",
        
          "iPhone 17-Pro Max": "46889587474668",
        
          "iPhone 16-E": "47189452554476"
        
      },
    
      "Banjara embroidery motif 2": {
        
          "iPhone 12-Base": "46595448930540",
        
          "iPhone 12-Pro": "46595448963308",
        
          "iPhone 12-Pro Max": "46595448996076",
        
          "iPhone 12-Mini": "46595449028844",
        
          "iPhone 13-Base": "46595449061612",
        
          "iPhone 13-Pro": "46595449094380",
        
          "iPhone 13-Pro Max": "46595449127148",
        
          "iPhone 13-Mini": "46595449159916",
        
          "iPhone 14-Base": "46595449192684",
        
          "iPhone 14-Pro": "46595449225452",
        
          "iPhone 14-Pro Max": "46595449258220",
        
          "iPhone 14-Plus": "46595449290988",
        
          "iPhone 15-Base": "46595449323756",
        
          "iPhone 15-Pro": "46595449356524",
        
          "iPhone 15-Pro Max": "46595449389292",
        
          "iPhone 15-Plus": "46595449422060",
        
          "iPhone 16-Base": "46595449454828",
        
          "iPhone 16-Pro": "46595449487596",
        
          "iPhone 16-Pro Max": "46595449520364",
        
          "iPhone 16-Plus": "46595449553132",
        
          "iPhone 17-Base": "46889587507436",
        
          "iPhone 17-Air": "46889587540204",
        
          "iPhone 17-Pro": "46889587572972",
        
          "iPhone 17-Pro Max": "46889587605740",
        
          "iPhone 16-E": "47189452456172"
        
      },
    
      "Banjara embroidery motif 1": {
        
          "iPhone 12-Base": "46595448275180",
        
          "iPhone 12-Pro": "46595448307948",
        
          "iPhone 12-Pro Max": "46595448340716",
        
          "iPhone 12-Mini": "46595448373484",
        
          "iPhone 13-Base": "46595448406252",
        
          "iPhone 13-Pro": "46595448439020",
        
          "iPhone 13-Pro Max": "46595448471788",
        
          "iPhone 13-Mini": "46595448504556",
        
          "iPhone 14-Base": "46595448537324",
        
          "iPhone 14-Pro": "46595448570092",
        
          "iPhone 14-Pro Max": "46595448602860",
        
          "iPhone 14-Plus": "46595448635628",
        
          "iPhone 15-Base": "46595448668396",
        
          "iPhone 15-Pro": "46595448701164",
        
          "iPhone 15-Pro Max": "46595448733932",
        
          "iPhone 15-Plus": "46595448766700",
        
          "iPhone 16-Base": "46595448799468",
        
          "iPhone 16-Pro": "46595448832236",
        
          "iPhone 16-Pro Max": "46595448865004",
        
          "iPhone 16-Plus": "46595448897772",
        
          "iPhone 17-Base": "46889587638508",
        
          "iPhone 17-Air": "46889587671276",
        
          "iPhone 17-Pro": "46889587704044",
        
          "iPhone 17-Pro Max": "46889587736812",
        
          "iPhone 16-E": "47189452357868"
        
      },
    
      "Farrukhabadi block print": {
        
          "iPhone 12-Base": "46595447554284",
        
          "iPhone 12-Pro": "46595447587052",
        
          "iPhone 12-Pro Max": "46595447619820",
        
          "iPhone 12-Mini": "46595447652588",
        
          "iPhone 13-Base": "46595447685356",
        
          "iPhone 13-Pro": "46595447718124",
        
          "iPhone 13-Pro Max": "46595447750892",
        
          "iPhone 13-Mini": "46595447783660",
        
          "iPhone 14-Base": "46595447816428",
        
          "iPhone 14-Pro": "46595447849196",
        
          "iPhone 14-Pro Max": "46595447881964",
        
          "iPhone 14-Plus": "46595447914732",
        
          "iPhone 15-Base": "46595447947500",
        
          "iPhone 15-Pro": "46595447980268",
        
          "iPhone 15-Pro Max": "46595448013036",
        
          "iPhone 15-Plus": "46595448045804",
        
          "iPhone 16-Base": "46595448078572",
        
          "iPhone 16-Pro": "46595448111340",
        
          "iPhone 16-Pro Max": "46595448144108",
        
          "iPhone 16-Plus": "46595448176876",
        
          "iPhone 17-Base": "46889587769580",
        
          "iPhone 17-Air": "46889587802348",
        
          "iPhone 17-Pro": "46889587835116",
        
          "iPhone 17-Pro Max": "46889587867884",
        
          "iPhone 16-E": "47189452325100"
        
      },
    
      "Jogi folk wilderness 3": {
        
          "iPhone 12-Base": "46595446735084",
        
          "iPhone 12-Pro": "46595446767852",
        
          "iPhone 12-Pro Max": "46595446800620",
        
          "iPhone 12-Mini": "46595446833388",
        
          "iPhone 13-Base": "46595446866156",
        
          "iPhone 13-Pro": "46595446898924",
        
          "iPhone 13-Pro Max": "46595446931692",
        
          "iPhone 13-Mini": "46595446964460",
        
          "iPhone 14-Base": "46595446997228",
        
          "iPhone 14-Pro": "46595447029996",
        
          "iPhone 14-Pro Max": "46595447062764",
        
          "iPhone 14-Plus": "46595447095532",
        
          "iPhone 15-Base": "46595447128300",
        
          "iPhone 15-Pro": "46595447161068",
        
          "iPhone 15-Pro Max": "46595447193836",
        
          "iPhone 15-Plus": "46595447226604",
        
          "iPhone 16-Base": "46595447259372",
        
          "iPhone 16-Pro": "46595447292140",
        
          "iPhone 16-Pro Max": "46595447324908",
        
          "iPhone 16-Plus": "46595447357676",
        
          "iPhone 17-Base": "46889587900652",
        
          "iPhone 17-Air": "46889587933420",
        
          "iPhone 17-Pro": "46889587966188",
        
          "iPhone 17-Pro Max": "46889587998956",
        
          "iPhone 16-E": "47189452259564"
        
      },
    
      "Jogi folk wilderness 1": {
        
          "iPhone 12-Base": "46595440115948",
        
          "iPhone 12-Pro": "46595440148716",
        
          "iPhone 12-Pro Max": "46595440181484",
        
          "iPhone 12-Mini": "46595440214252",
        
          "iPhone 13-Base": "46595440247020",
        
          "iPhone 13-Pro": "46595440279788",
        
          "iPhone 13-Pro Max": "46595440312556",
        
          "iPhone 13-Mini": "46595440345324",
        
          "iPhone 14-Base": "46595440378092",
        
          "iPhone 14-Pro": "46595440410860",
        
          "iPhone 14-Pro Max": "46595440443628",
        
          "iPhone 14-Plus": "46595440476396",
        
          "iPhone 15-Base": "46595440509164",
        
          "iPhone 15-Pro": "46595440541932",
        
          "iPhone 15-Pro Max": "46595440574700",
        
          "iPhone 15-Plus": "46595440607468",
        
          "iPhone 16-Base": "46595440640236",
        
          "iPhone 16-Pro": "46595440673004",
        
          "iPhone 16-Pro Max": "46595440705772",
        
          "iPhone 16-Plus": "46595440738540",
        
          "iPhone 17-Base": "46889588457708",
        
          "iPhone 17-Air": "46889588490476",
        
          "iPhone 17-Pro": "46889588523244",
        
          "iPhone 17-Pro Max": "46889588556012",
        
          "iPhone 16-E": "47189452161260"
        
      },
    
      "Bhujodi weave": {
        
          "iPhone 12-Base": "46595438674156",
        
          "iPhone 12-Pro": "46595438706924",
        
          "iPhone 12-Pro Max": "46595438739692",
        
          "iPhone 12-Mini": "46595438772460",
        
          "iPhone 13-Base": "46595438805228",
        
          "iPhone 13-Pro": "46595438837996",
        
          "iPhone 13-Pro Max": "46595438870764",
        
          "iPhone 13-Mini": "46595438903532",
        
          "iPhone 14-Base": "46595438936300",
        
          "iPhone 14-Pro": "46595438969068",
        
          "iPhone 14-Pro Max": "46595439001836",
        
          "iPhone 14-Plus": "46595439034604",
        
          "iPhone 15-Base": "46595439067372",
        
          "iPhone 15-Pro": "46595439100140",
        
          "iPhone 15-Pro Max": "46595439132908",
        
          "iPhone 15-Plus": "46595439165676",
        
          "iPhone 16-Base": "46595439198444",
        
          "iPhone 16-Pro": "46595439231212",
        
          "iPhone 16-Pro Max": "46595439263980",
        
          "iPhone 16-Plus": "46595439296748",
        
          "iPhone 17-Base": "46889588588780",
        
          "iPhone 17-Air": "46889588621548",
        
          "iPhone 17-Pro": "46889588654316",
        
          "iPhone 17-Pro Max": "46889588687084",
        
          "iPhone 16-E": "47189452062956"
        
      },
    
      "Sujani embroidery motif 2": {
        
          "iPhone 12-Base": "46595437854956",
        
          "iPhone 12-Pro": "46595437887724",
        
          "iPhone 12-Pro Max": "46595437920492",
        
          "iPhone 12-Mini": "46595437953260",
        
          "iPhone 13-Base": "46595437986028",
        
          "iPhone 13-Pro": "46595438018796",
        
          "iPhone 13-Pro Max": "46595438051564",
        
          "iPhone 13-Mini": "46595438084332",
        
          "iPhone 14-Base": "46595438117100",
        
          "iPhone 14-Pro": "46595438149868",
        
          "iPhone 14-Pro Max": "46595438182636",
        
          "iPhone 14-Plus": "46595438215404",
        
          "iPhone 15-Base": "46595438248172",
        
          "iPhone 15-Pro": "46595438280940",
        
          "iPhone 15-Pro Max": "46595438313708",
        
          "iPhone 15-Plus": "46595438346476",
        
          "iPhone 16-Base": "46595438379244",
        
          "iPhone 16-Pro": "46595438412012",
        
          "iPhone 16-Pro Max": "46595438444780",
        
          "iPhone 16-Plus": "46595438477548",
        
          "iPhone 17-Base": "46889588719852",
        
          "iPhone 17-Air": "46889588752620",
        
          "iPhone 17-Pro": "46889588785388",
        
          "iPhone 17-Pro Max": "46889588818156",
        
          "iPhone 16-E": "47189451997420"
        
      },
    
      "Sujani embroidery motif 1": {
        
          "iPhone 12-Base": "46595437199596",
        
          "iPhone 12-Pro": "46595437232364",
        
          "iPhone 12-Pro Max": "46595437265132",
        
          "iPhone 12-Mini": "46595437297900",
        
          "iPhone 13-Base": "46595437330668",
        
          "iPhone 13-Pro": "46595437363436",
        
          "iPhone 13-Pro Max": "46595437396204",
        
          "iPhone 13-Mini": "46595437428972",
        
          "iPhone 14-Base": "46595437461740",
        
          "iPhone 14-Pro": "46595437494508",
        
          "iPhone 14-Pro Max": "46595437527276",
        
          "iPhone 14-Plus": "46595437560044",
        
          "iPhone 15-Base": "46595437592812",
        
          "iPhone 15-Pro": "46595437625580",
        
          "iPhone 15-Pro Max": "46595437658348",
        
          "iPhone 15-Plus": "46595437691116",
        
          "iPhone 16-Base": "46595437723884",
        
          "iPhone 16-Pro": "46595437756652",
        
          "iPhone 16-Pro Max": "46595437789420",
        
          "iPhone 16-Plus": "46595437822188",
        
          "iPhone 17-Base": "46889588850924",
        
          "iPhone 17-Air": "46889588883692",
        
          "iPhone 17-Pro": "46889588916460",
        
          "iPhone 17-Pro Max": "46889588949228",
        
          "iPhone 16-E": "47189451866348"
        
      },
    
      "Bagh block print 1": {
        
          "iPhone 12-Base": "46595435823340",
        
          "iPhone 12-Pro": "46595435856108",
        
          "iPhone 12-Pro Max": "46595435888876",
        
          "iPhone 12-Mini": "46595435921644",
        
          "iPhone 13-Base": "46595435954412",
        
          "iPhone 13-Pro": "46595435987180",
        
          "iPhone 13-Pro Max": "46595436019948",
        
          "iPhone 13-Mini": "46595436052716",
        
          "iPhone 14-Base": "46595436085484",
        
          "iPhone 14-Pro": "46595436118252",
        
          "iPhone 14-Pro Max": "46595436151020",
        
          "iPhone 14-Plus": "46595436183788",
        
          "iPhone 15-Base": "46595436216556",
        
          "iPhone 15-Pro": "46595436249324",
        
          "iPhone 15-Pro Max": "46595436282092",
        
          "iPhone 15-Plus": "46595436314860",
        
          "iPhone 16-Base": "46595436347628",
        
          "iPhone 16-Pro": "46595436380396",
        
          "iPhone 16-Pro Max": "46595436413164",
        
          "iPhone 16-Plus": "46595436445932",
        
          "iPhone 17-Base": "46889589047532",
        
          "iPhone 17-Air": "46889589080300",
        
          "iPhone 17-Pro": "46889589113068",
        
          "iPhone 17-Pro Max": "46889589145836",
        
          "iPhone 16-E": "47189451735276"
        
      },
    
      "Kharad rug 2": {
        
          "iPhone 12-Base": "46595435167980",
        
          "iPhone 12-Pro": "46595435200748",
        
          "iPhone 12-Pro Max": "46595435233516",
        
          "iPhone 12-Mini": "46595435266284",
        
          "iPhone 13-Base": "46595435299052",
        
          "iPhone 13-Pro": "46595435331820",
        
          "iPhone 13-Pro Max": "46595435364588",
        
          "iPhone 13-Mini": "46595435397356",
        
          "iPhone 14-Base": "46595435430124",
        
          "iPhone 14-Pro": "46595435462892",
        
          "iPhone 14-Pro Max": "46595435495660",
        
          "iPhone 14-Plus": "46595435528428",
        
          "iPhone 15-Base": "46595435561196",
        
          "iPhone 15-Pro": "46595435593964",
        
          "iPhone 15-Pro Max": "46595435626732",
        
          "iPhone 15-Plus": "46595435659500",
        
          "iPhone 16-Base": "46595435692268",
        
          "iPhone 16-Pro": "46595435725036",
        
          "iPhone 16-Pro Max": "46595435757804",
        
          "iPhone 16-Plus": "46595435790572",
        
          "iPhone 17-Base": "46889589211372",
        
          "iPhone 17-Air": "46889589244140",
        
          "iPhone 17-Pro": "46889589276908",
        
          "iPhone 17-Pro Max": "46889589309676",
        
          "iPhone 16-E": "47189451604204"
        
      },
    
      "Kharad rug 1": {
        
          "iPhone 12-Base": "46595434479852",
        
          "iPhone 12-Pro": "46595434512620",
        
          "iPhone 12-Pro Max": "46595434545388",
        
          "iPhone 12-Mini": "46595434578156",
        
          "iPhone 13-Base": "46595434610924",
        
          "iPhone 13-Pro": "46595434643692",
        
          "iPhone 13-Pro Max": "46595434676460",
        
          "iPhone 13-Mini": "46595434709228",
        
          "iPhone 14-Base": "46595434741996",
        
          "iPhone 14-Pro": "46595434774764",
        
          "iPhone 14-Pro Max": "46595434807532",
        
          "iPhone 14-Plus": "46595434840300",
        
          "iPhone 15-Base": "46595434873068",
        
          "iPhone 15-Pro": "46595434905836",
        
          "iPhone 15-Pro Max": "46595434938604",
        
          "iPhone 15-Plus": "46595434971372",
        
          "iPhone 16-Base": "46595435004140",
        
          "iPhone 16-Pro": "46595435036908",
        
          "iPhone 16-Pro Max": "46595435069676",
        
          "iPhone 16-Plus": "46595435102444",
        
          "iPhone 17-Base": "46889589342444",
        
          "iPhone 17-Air": "46889589375212",
        
          "iPhone 17-Pro": "46889589407980",
        
          "iPhone 17-Pro Max": "46889589440748",
        
          "iPhone 16-E": "47189451538668"
        
      },
    
      "Lehariya": {
        
          "iPhone 12-Base": "46595433660652",
        
          "iPhone 12-Pro": "46595433693420",
        
          "iPhone 12-Pro Max": "46595433726188",
        
          "iPhone 12-Mini": "46595433758956",
        
          "iPhone 13-Base": "46595433791724",
        
          "iPhone 13-Pro": "46595433824492",
        
          "iPhone 13-Pro Max": "46595433857260",
        
          "iPhone 13-Mini": "46595433890028",
        
          "iPhone 14-Base": "46595433922796",
        
          "iPhone 14-Pro": "46595433955564",
        
          "iPhone 14-Pro Max": "46595433988332",
        
          "iPhone 14-Plus": "46595434021100",
        
          "iPhone 15-Base": "46595434053868",
        
          "iPhone 15-Pro": "46595434086636",
        
          "iPhone 15-Pro Max": "46595434119404",
        
          "iPhone 15-Plus": "46595434152172",
        
          "iPhone 16-Base": "46595434184940",
        
          "iPhone 16-Pro": "46595434217708",
        
          "iPhone 16-Pro Max": "46595434250476",
        
          "iPhone 16-Plus": "46595434283244",
        
          "iPhone 17-Base": "46889589473516",
        
          "iPhone 17-Air": "46889589506284",
        
          "iPhone 17-Pro": "46889589539052",
        
          "iPhone 17-Pro Max": "46889589571820",
        
          "iPhone 16-E": "47189451505900"
        
      },
    
      "Zardozi Jaal": {
        
          "iPhone 12-Base": "46595430809836",
        
          "iPhone 12-Pro": "46595430842604",
        
          "iPhone 12-Pro Max": "46595430875372",
        
          "iPhone 12-Mini": "46595430908140",
        
          "iPhone 13-Base": "46595430940908",
        
          "iPhone 13-Pro": "46595430973676",
        
          "iPhone 13-Pro Max": "46595431006444",
        
          "iPhone 13-Mini": "46595431039212",
        
          "iPhone 14-Base": "46595431071980",
        
          "iPhone 14-Pro": "46595431104748",
        
          "iPhone 14-Pro Max": "46595431137516",
        
          "iPhone 14-Plus": "46595431170284",
        
          "iPhone 15-Base": "46595431203052",
        
          "iPhone 15-Pro": "46595431235820",
        
          "iPhone 15-Pro Max": "46595431268588",
        
          "iPhone 15-Plus": "46595431301356",
        
          "iPhone 16-Base": "46595431334124",
        
          "iPhone 16-Pro": "46595431366892",
        
          "iPhone 16-Pro Max": "46595431399660",
        
          "iPhone 16-Plus": "46595431432428",
        
          "iPhone 17-Base": "46889589604588",
        
          "iPhone 17-Air": "46889589637356",
        
          "iPhone 17-Pro": "46889589670124",
        
          "iPhone 17-Pro Max": "46889589702892",
        
          "iPhone 16-E": "47189450359020"
        
      },
    
      "Paithani asawali navy": {
        
          "iPhone 12-Base": "46595430056172",
        
          "iPhone 12-Pro": "46595430088940",
        
          "iPhone 12-Pro Max": "46595430121708",
        
          "iPhone 12-Mini": "46595430154476",
        
          "iPhone 13-Base": "46595430187244",
        
          "iPhone 13-Pro": "46595430220012",
        
          "iPhone 13-Pro Max": "46595430252780",
        
          "iPhone 13-Mini": "46595430285548",
        
          "iPhone 14-Base": "46595430318316",
        
          "iPhone 14-Pro": "46595430351084",
        
          "iPhone 14-Pro Max": "46595430383852",
        
          "iPhone 14-Plus": "46595430416620",
        
          "iPhone 15-Base": "46595430449388",
        
          "iPhone 15-Pro": "46595430482156",
        
          "iPhone 15-Pro Max": "46595430514924",
        
          "iPhone 15-Plus": "46595430547692",
        
          "iPhone 16-Base": "46595430580460",
        
          "iPhone 16-Pro": "46595430613228",
        
          "iPhone 16-Pro Max": "46595430645996",
        
          "iPhone 16-Plus": "46595430678764",
        
          "iPhone 17-Base": "46889589735660",
        
          "iPhone 17-Air": "46889589768428",
        
          "iPhone 17-Pro": "46889589801196",
        
          "iPhone 17-Pro Max": "46889589833964",
        
          "iPhone 16-E": "47189449212140"
        
      },
    
      "Paithani asawali dark": {
        
          "iPhone 12-Base": "46595429335276",
        
          "iPhone 12-Pro": "46595429368044",
        
          "iPhone 12-Pro Max": "46595429400812",
        
          "iPhone 12-Mini": "46595429433580",
        
          "iPhone 13-Base": "46595429466348",
        
          "iPhone 13-Pro": "46595429499116",
        
          "iPhone 13-Pro Max": "46595429531884",
        
          "iPhone 13-Mini": "46595429564652",
        
          "iPhone 14-Base": "46595429597420",
        
          "iPhone 14-Pro": "46595429630188",
        
          "iPhone 14-Pro Max": "46595429662956",
        
          "iPhone 14-Plus": "46595429695724",
        
          "iPhone 15-Base": "46595429728492",
        
          "iPhone 15-Pro": "46595429761260",
        
          "iPhone 15-Pro Max": "46595429794028",
        
          "iPhone 15-Plus": "46595429826796",
        
          "iPhone 16-Base": "46595429859564",
        
          "iPhone 16-Pro": "46595429892332",
        
          "iPhone 16-Pro Max": "46595429925100",
        
          "iPhone 16-Plus": "46595429957868",
        
          "iPhone 17-Base": "46889589866732",
        
          "iPhone 17-Air": "46889589899500",
        
          "iPhone 17-Pro": "46889589932268",
        
          "iPhone 17-Pro Max": "46889589965036",
        
          "iPhone 16-E": "47189449179372"
        
      },
    
      "Paithani asawali parrot": {
        
          "iPhone 12-Base": "46595428647148",
        
          "iPhone 12-Pro": "46595428679916",
        
          "iPhone 12-Pro Max": "46595428712684",
        
          "iPhone 12-Mini": "46595428745452",
        
          "iPhone 13-Base": "46595428778220",
        
          "iPhone 13-Pro": "46595428810988",
        
          "iPhone 13-Pro Max": "46595428843756",
        
          "iPhone 13-Mini": "46595428876524",
        
          "iPhone 14-Base": "46595428909292",
        
          "iPhone 14-Pro": "46595428942060",
        
          "iPhone 14-Pro Max": "46595428974828",
        
          "iPhone 14-Plus": "46595429007596",
        
          "iPhone 15-Base": "46595429040364",
        
          "iPhone 15-Pro": "46595429073132",
        
          "iPhone 15-Pro Max": "46595429105900",
        
          "iPhone 15-Plus": "46595429138668",
        
          "iPhone 16-Base": "46595429171436",
        
          "iPhone 16-Pro": "46595429204204",
        
          "iPhone 16-Pro Max": "46595429236972",
        
          "iPhone 16-Plus": "46595429269740",
        
          "iPhone 17-Base": "46889589997804",
        
          "iPhone 17-Air": "46889590030572",
        
          "iPhone 17-Pro": "46889590063340",
        
          "iPhone 17-Pro Max": "46889590096108",
        
          "iPhone 16-E": "47189449146604"
        
      },
    
      "Paithani asawali dark green": {
        
          "iPhone 12-Base": "46595427893484",
        
          "iPhone 12-Pro": "46595427926252",
        
          "iPhone 12-Pro Max": "46595427959020",
        
          "iPhone 12-Mini": "46595427991788",
        
          "iPhone 13-Base": "46595428024556",
        
          "iPhone 13-Pro": "46595428057324",
        
          "iPhone 13-Pro Max": "46595428090092",
        
          "iPhone 13-Mini": "46595428122860",
        
          "iPhone 14-Base": "46595428155628",
        
          "iPhone 14-Pro": "46595428188396",
        
          "iPhone 14-Pro Max": "46595428221164",
        
          "iPhone 14-Plus": "46595428253932",
        
          "iPhone 15-Base": "46595428286700",
        
          "iPhone 15-Pro": "46595428319468",
        
          "iPhone 15-Pro Max": "46595428352236",
        
          "iPhone 15-Plus": "46595428385004",
        
          "iPhone 16-Base": "46595428417772",
        
          "iPhone 16-Pro": "46595428450540",
        
          "iPhone 16-Pro Max": "46595428483308",
        
          "iPhone 16-Plus": "46595428516076",
        
          "iPhone 17-Base": "46889590128876",
        
          "iPhone 17-Air": "46889590161644",
        
          "iPhone 17-Pro": "46889590194412",
        
          "iPhone 17-Pro Max": "46889590227180",
        
          "iPhone 16-E": "47189449113836"
        
      },
    
      "Warli tribal story strip": {
        
          "iPhone 12-Base": "46595425272044",
        
          "iPhone 12-Pro": "46595425304812",
        
          "iPhone 12-Pro Max": "46595425337580",
        
          "iPhone 12-Mini": "46595425370348",
        
          "iPhone 13-Base": "46595425403116",
        
          "iPhone 13-Pro": "46595425435884",
        
          "iPhone 13-Pro Max": "46595425468652",
        
          "iPhone 13-Mini": "46595425501420",
        
          "iPhone 14-Base": "46595425534188",
        
          "iPhone 14-Pro": "46595425566956",
        
          "iPhone 14-Pro Max": "46595425599724",
        
          "iPhone 14-Plus": "46595425632492",
        
          "iPhone 15-Base": "46595425665260",
        
          "iPhone 15-Pro": "46595425698028",
        
          "iPhone 15-Pro Max": "46595425730796",
        
          "iPhone 15-Plus": "46595425763564",
        
          "iPhone 16-Base": "46595425796332",
        
          "iPhone 16-Pro": "46595425829100",
        
          "iPhone 16-Pro Max": "46595425861868",
        
          "iPhone 16-Plus": "46595425894636",
        
          "iPhone 17-Base": "46889590259948",
        
          "iPhone 17-Air": "46889590292716",
        
          "iPhone 17-Pro": "46889590325484",
        
          "iPhone 17-Pro Max": "46889590358252",
        
          "iPhone 16-E": "47189449081068"
        
      },
    
      "Patola ikat bloom 1": {
        
          "iPhone 12-Base": "46511182545132",
        
          "iPhone 12-Pro": "46511182577900",
        
          "iPhone 12-Pro Max": "46511182610668",
        
          "iPhone 12-Mini": "46511182643436",
        
          "iPhone 13-Base": "46511182676204",
        
          "iPhone 13-Pro": "46511182708972",
        
          "iPhone 13-Pro Max": "46511182741740",
        
          "iPhone 13-Mini": "46511182774508",
        
          "iPhone 14-Base": "46511182807276",
        
          "iPhone 14-Pro": "46511182840044",
        
          "iPhone 14-Pro Max": "46511182872812",
        
          "iPhone 14-Plus": "46511182905580",
        
          "iPhone 15-Base": "46511182938348",
        
          "iPhone 15-Pro": "46511182971116",
        
          "iPhone 15-Pro Max": "46511183003884",
        
          "iPhone 15-Plus": "46511183036652",
        
          "iPhone 16-Base": "46511183069420",
        
          "iPhone 16-Pro": "46511183102188",
        
          "iPhone 16-Pro Max": "46511183134956",
        
          "iPhone 16-Plus": "46511183167724",
        
          "iPhone 17-Base": "46889590391020",
        
          "iPhone 17-Air": "46889590423788",
        
          "iPhone 17-Pro": "46889590456556",
        
          "iPhone 17-Pro Max": "46889590489324",
        
          "iPhone 16-E": "47189449048300"
        
      },
    
      "Patola ikat bloom 2": {
        
          "iPhone 12-Base": "46511180873964",
        
          "iPhone 12-Pro": "46511180906732",
        
          "iPhone 12-Pro Max": "46511180939500",
        
          "iPhone 12-Mini": "46511180972268",
        
          "iPhone 13-Base": "46511181005036",
        
          "iPhone 13-Pro": "46511181037804",
        
          "iPhone 13-Pro Max": "46511181070572",
        
          "iPhone 13-Mini": "46511181103340",
        
          "iPhone 14-Base": "46511181136108",
        
          "iPhone 14-Pro": "46511181168876",
        
          "iPhone 14-Pro Max": "46511181201644",
        
          "iPhone 14-Plus": "46511181234412",
        
          "iPhone 15-Base": "46511181267180",
        
          "iPhone 15-Pro": "46511181299948",
        
          "iPhone 15-Pro Max": "46511181332716",
        
          "iPhone 15-Plus": "46511181365484",
        
          "iPhone 16-Base": "46511181398252",
        
          "iPhone 16-Pro": "46511181431020",
        
          "iPhone 16-Pro Max": "46511181463788",
        
          "iPhone 16-Plus": "46511181496556",
        
          "iPhone 17-Base": "46889590587628",
        
          "iPhone 17-Air": "46889590653164",
        
          "iPhone 17-Pro": "46889590685932",
        
          "iPhone 17-Pro Max": "46889590718700",
        
          "iPhone 16-E": "47189449015532"
        
      },
    
      "Gamosa Embroidery": {
        
          "iPhone 12-Base": "46511178973420",
        
          "iPhone 12-Pro": "46511179006188",
        
          "iPhone 12-Pro Max": "46511179038956",
        
          "iPhone 12-Mini": "46511179071724",
        
          "iPhone 13-Base": "46511179104492",
        
          "iPhone 13-Pro": "46511179137260",
        
          "iPhone 13-Pro Max": "46511179170028",
        
          "iPhone 13-Mini": "46511179202796",
        
          "iPhone 14-Base": "46511179235564",
        
          "iPhone 14-Pro": "46511179268332",
        
          "iPhone 14-Pro Max": "46511179301100",
        
          "iPhone 14-Plus": "46511179333868",
        
          "iPhone 15-Base": "46511179366636",
        
          "iPhone 15-Pro": "46511179399404",
        
          "iPhone 15-Pro Max": "46511179432172",
        
          "iPhone 15-Plus": "46511179464940",
        
          "iPhone 16-Base": "46511179497708",
        
          "iPhone 16-Pro": "46511179530476",
        
          "iPhone 16-Pro Max": "46511179563244",
        
          "iPhone 16-Plus": "46511179596012",
        
          "iPhone 17-Base": "46889590751468",
        
          "iPhone 17-Air": "46889590784236",
        
          "iPhone 17-Pro": "46889590817004",
        
          "iPhone 17-Pro Max": "46889590849772",
        
          "iPhone 16-E": "47189448982764"
        
      },
    
      "Kutch Embroidery Motif 3": {
        
          "iPhone 12-Base": "46511174877420",
        
          "iPhone 12-Pro": "46511174910188",
        
          "iPhone 12-Pro Max": "46511174942956",
        
          "iPhone 12-Mini": "46511174975724",
        
          "iPhone 13-Base": "46511175008492",
        
          "iPhone 13-Pro": "46511175041260",
        
          "iPhone 13-Pro Max": "46511175074028",
        
          "iPhone 13-Mini": "46511175106796",
        
          "iPhone 14-Base": "46511175139564",
        
          "iPhone 14-Pro": "46511175172332",
        
          "iPhone 14-Pro Max": "46511175205100",
        
          "iPhone 14-Plus": "46511175237868",
        
          "iPhone 15-Base": "46511175270636",
        
          "iPhone 15-Pro": "46511175303404",
        
          "iPhone 15-Pro Max": "46511175336172",
        
          "iPhone 15-Plus": "46511175368940",
        
          "iPhone 16-Base": "46511175401708",
        
          "iPhone 16-Pro": "46511175434476",
        
          "iPhone 16-Pro Max": "46511175467244",
        
          "iPhone 16-Plus": "46511175500012",
        
          "iPhone 17-Base": "46889590882540",
        
          "iPhone 17-Air": "46889590915308",
        
          "iPhone 17-Pro": "46889590948076",
        
          "iPhone 17-Pro Max": "46889590980844",
        
          "iPhone 16-E": "47189448949996"
        
      },
    
      "Kutch Embroidery Motif 4": {
        
          "iPhone 12-Base": "46511173042412",
        
          "iPhone 12-Pro": "46511173075180",
        
          "iPhone 12-Pro Max": "46511173107948",
        
          "iPhone 12-Mini": "46511173140716",
        
          "iPhone 13-Base": "46511173173484",
        
          "iPhone 13-Pro": "46511173206252",
        
          "iPhone 13-Pro Max": "46511173239020",
        
          "iPhone 13-Mini": "46511173271788",
        
          "iPhone 14-Base": "46511173304556",
        
          "iPhone 14-Pro": "46511173337324",
        
          "iPhone 14-Pro Max": "46511173370092",
        
          "iPhone 14-Plus": "46511173402860",
        
          "iPhone 15-Base": "46511173435628",
        
          "iPhone 15-Pro": "46511173468396",
        
          "iPhone 15-Pro Max": "46511173501164",
        
          "iPhone 15-Plus": "46511173533932",
        
          "iPhone 16-Base": "46511173566700",
        
          "iPhone 16-Pro": "46511173599468",
        
          "iPhone 16-Pro Max": "46511173632236",
        
          "iPhone 16-Plus": "46511173665004",
        
          "iPhone 17-Base": "46889591046380",
        
          "iPhone 17-Air": "46889591079148",
        
          "iPhone 17-Pro": "46889591111916",
        
          "iPhone 17-Pro Max": "46889591144684",
        
          "iPhone 16-E": "47189448917228"
        
      },
    
      "Patola Ikat Dark Bloom 1": {
        
          "iPhone 12-Base": "46511170978028",
        
          "iPhone 12-Pro": "46511171010796",
        
          "iPhone 12-Pro Max": "46511171043564",
        
          "iPhone 12-Mini": "46511171076332",
        
          "iPhone 13-Base": "46511171109100",
        
          "iPhone 13-Pro": "46511171141868",
        
          "iPhone 13-Pro Max": "46511171174636",
        
          "iPhone 13-Mini": "46511171207404",
        
          "iPhone 14-Base": "46511171240172",
        
          "iPhone 14-Pro": "46511171272940",
        
          "iPhone 14-Pro Max": "46511171305708",
        
          "iPhone 14-Plus": "46511171338476",
        
          "iPhone 15-Base": "46511171371244",
        
          "iPhone 15-Pro": "46511171404012",
        
          "iPhone 15-Pro Max": "46511171436780",
        
          "iPhone 15-Plus": "46511171469548",
        
          "iPhone 16-Base": "46511171502316",
        
          "iPhone 16-Pro": "46511171535084",
        
          "iPhone 16-Pro Max": "46511171567852",
        
          "iPhone 16-Plus": "46511171600620",
        
          "iPhone 17-Base": "46889591177452",
        
          "iPhone 17-Air": "46889591210220",
        
          "iPhone 17-Pro": "46889591242988",
        
          "iPhone 17-Pro Max": "46889591275756",
        
          "iPhone 16-E": "47189448884460"
        
      },
    
      "Patola Ikat Light Bloom 1": {
        
          "iPhone 12-Base": "46511167537388",
        
          "iPhone 12-Pro": "46511167570156",
        
          "iPhone 12-Pro Max": "46511167602924",
        
          "iPhone 12-Mini": "46511167635692",
        
          "iPhone 13-Base": "46511167668460",
        
          "iPhone 13-Pro": "46511167701228",
        
          "iPhone 13-Pro Max": "46511167733996",
        
          "iPhone 13-Mini": "46511167766764",
        
          "iPhone 14-Base": "46511167799532",
        
          "iPhone 14-Pro": "46511167832300",
        
          "iPhone 14-Pro Max": "46511167865068",
        
          "iPhone 14-Plus": "46511167897836",
        
          "iPhone 15-Base": "46511167930604",
        
          "iPhone 15-Pro": "46511167963372",
        
          "iPhone 15-Pro Max": "46511167996140",
        
          "iPhone 15-Plus": "46511168028908",
        
          "iPhone 16-Base": "46511168061676",
        
          "iPhone 16-Pro": "46511168094444",
        
          "iPhone 16-Pro Max": "46511168127212",
        
          "iPhone 16-Plus": "46511168159980",
        
          "iPhone 17-Base": "46889591308524",
        
          "iPhone 17-Air": "46889591341292",
        
          "iPhone 17-Pro": "46889591374060",
        
          "iPhone 17-Pro Max": "46889591406828",
        
          "iPhone 16-E": "47189448851692"
        
      },
    
      "Kashmiri Sozni Brocade": {
        
          "iPhone 12-Base": "46511165538540",
        
          "iPhone 12-Pro": "46511165571308",
        
          "iPhone 12-Pro Max": "46511165604076",
        
          "iPhone 12-Mini": "46511165636844",
        
          "iPhone 13-Base": "46511165669612",
        
          "iPhone 13-Pro": "46511165702380",
        
          "iPhone 13-Pro Max": "46511165735148",
        
          "iPhone 13-Mini": "46511165767916",
        
          "iPhone 14-Base": "46511165800684",
        
          "iPhone 14-Pro": "46511165833452",
        
          "iPhone 14-Pro Max": "46511165866220",
        
          "iPhone 14-Plus": "46511165898988",
        
          "iPhone 15-Base": "46511165931756",
        
          "iPhone 15-Pro": "46511165964524",
        
          "iPhone 15-Pro Max": "46511165997292",
        
          "iPhone 15-Plus": "46511166030060",
        
          "iPhone 16-Base": "46511166062828",
        
          "iPhone 16-Pro": "46511166095596",
        
          "iPhone 16-Pro Max": "46511166128364",
        
          "iPhone 16-Plus": "46511166161132",
        
          "iPhone 17-Base": "46889591439596",
        
          "iPhone 17-Air": "46889591472364",
        
          "iPhone 17-Pro": "46889591505132",
        
          "iPhone 17-Pro Max": "46889591537900",
        
          "iPhone 16-E": "47189448818924"
        
      },
    
      "Forest Green Chikankari 1": {
        
          "iPhone 12-Base": "46511163277548",
        
          "iPhone 12-Pro": "46511163310316",
        
          "iPhone 12-Pro Max": "46511163343084",
        
          "iPhone 12-Mini": "46511163375852",
        
          "iPhone 13-Base": "46511163408620",
        
          "iPhone 13-Pro": "46511163441388",
        
          "iPhone 13-Pro Max": "46511163474156",
        
          "iPhone 13-Mini": "46511163506924",
        
          "iPhone 14-Base": "46511163539692",
        
          "iPhone 14-Pro": "46511163572460",
        
          "iPhone 14-Pro Max": "46511163605228",
        
          "iPhone 14-Plus": "46511163637996",
        
          "iPhone 15-Base": "46511163670764",
        
          "iPhone 15-Pro": "46511163703532",
        
          "iPhone 15-Pro Max": "46511163736300",
        
          "iPhone 15-Plus": "46511163769068",
        
          "iPhone 16-Base": "46511163801836",
        
          "iPhone 16-Pro": "46511163834604",
        
          "iPhone 16-Pro Max": "46511163867372",
        
          "iPhone 16-Plus": "46511163900140",
        
          "iPhone 17-Base": "46889591570668",
        
          "iPhone 17-Air": "46889591603436",
        
          "iPhone 17-Pro": "46889591636204",
        
          "iPhone 17-Pro Max": "46889591668972",
        
          "iPhone 16-E": "47189448786156"
        
      },
    
      "Forest Green Chikankari 2": {
        
          "iPhone 12-Base": "46511160688876",
        
          "iPhone 12-Pro": "46511160721644",
        
          "iPhone 12-Pro Max": "46511160754412",
        
          "iPhone 12-Mini": "46511160787180",
        
          "iPhone 13-Base": "46511160819948",
        
          "iPhone 13-Pro": "46511160852716",
        
          "iPhone 13-Pro Max": "46511160885484",
        
          "iPhone 13-Mini": "46511160918252",
        
          "iPhone 14-Base": "46511160951020",
        
          "iPhone 14-Pro": "46511160983788",
        
          "iPhone 14-Pro Max": "46511161016556",
        
          "iPhone 14-Plus": "46511161049324",
        
          "iPhone 15-Base": "46511161082092",
        
          "iPhone 15-Pro": "46511161114860",
        
          "iPhone 15-Pro Max": "46511161147628",
        
          "iPhone 15-Plus": "46511161180396",
        
          "iPhone 16-Base": "46511161213164",
        
          "iPhone 16-Pro": "46511161245932",
        
          "iPhone 16-Pro Max": "46511161278700",
        
          "iPhone 16-Plus": "46511161311468",
        
          "iPhone 17-Base": "46889591701740",
        
          "iPhone 17-Air": "46889591734508",
        
          "iPhone 17-Pro": "46889591767276",
        
          "iPhone 17-Pro Max": "46889591800044",
        
          "iPhone 16-E": "47189448753388"
        
      },
    
      "Navy Voile Chikankari": {
        
          "iPhone 12-Base": "46511158788332",
        
          "iPhone 12-Pro": "46511158821100",
        
          "iPhone 12-Pro Max": "46511158853868",
        
          "iPhone 12-Mini": "46511158886636",
        
          "iPhone 13-Base": "46511158919404",
        
          "iPhone 13-Pro": "46511158952172",
        
          "iPhone 13-Pro Max": "46511158984940",
        
          "iPhone 13-Mini": "46511159017708",
        
          "iPhone 14-Base": "46511159050476",
        
          "iPhone 14-Pro": "46511159083244",
        
          "iPhone 14-Pro Max": "46511159116012",
        
          "iPhone 14-Plus": "46511159148780",
        
          "iPhone 15-Base": "46511159181548",
        
          "iPhone 15-Pro": "46511159214316",
        
          "iPhone 15-Pro Max": "46511159247084",
        
          "iPhone 15-Plus": "46511159279852",
        
          "iPhone 16-Base": "46511159312620",
        
          "iPhone 16-Pro": "46511159345388",
        
          "iPhone 16-Pro Max": "46511159378156",
        
          "iPhone 16-Plus": "46511159410924",
        
          "iPhone 17-Base": "46889591832812",
        
          "iPhone 17-Air": "46889591865580",
        
          "iPhone 17-Pro": "46889591898348",
        
          "iPhone 17-Pro Max": "46889591931116",
        
          "iPhone 16-E": "47189448720620"
        
      },
    
      "Himachali Woolen Tapestry 2": {
        
          "iPhone 12-Base": "46511154069740",
        
          "iPhone 12-Pro": "46511154102508",
        
          "iPhone 12-Pro Max": "46511154135276",
        
          "iPhone 12-Mini": "46511154168044",
        
          "iPhone 13-Base": "46511154200812",
        
          "iPhone 13-Pro": "46511154233580",
        
          "iPhone 13-Pro Max": "46511154266348",
        
          "iPhone 13-Mini": "46511154299116",
        
          "iPhone 14-Base": "46511154331884",
        
          "iPhone 14-Pro": "46511154364652",
        
          "iPhone 14-Pro Max": "46511154397420",
        
          "iPhone 14-Plus": "46511154430188",
        
          "iPhone 15-Base": "46511154462956",
        
          "iPhone 15-Pro": "46511154495724",
        
          "iPhone 15-Pro Max": "46511154528492",
        
          "iPhone 15-Plus": "46511154561260",
        
          "iPhone 16-Base": "46511154594028",
        
          "iPhone 16-Pro": "46511154626796",
        
          "iPhone 16-Pro Max": "46511154659564",
        
          "iPhone 16-Plus": "46511154692332",
        
          "iPhone 17-Base": "46889591963884",
        
          "iPhone 17-Air": "46889591996652",
        
          "iPhone 17-Pro": "46889592029420",
        
          "iPhone 17-Pro Max": "46889592062188",
        
          "iPhone 16-E": "47189448687852"
        
      },
    
      "Chikankari 1": {
        
          "iPhone 12-Base": "46458949435628",
        
          "iPhone 12-Pro": "46458949468396",
        
          "iPhone 12-Pro Max": "46458949501164",
        
          "iPhone 12-Mini": "46458949533932",
        
          "iPhone 13-Base": "46458949566700",
        
          "iPhone 13-Pro": "46458949599468",
        
          "iPhone 13-Pro Max": "46458949632236",
        
          "iPhone 13-Mini": "46458949665004",
        
          "iPhone 14-Base": "46458949697772",
        
          "iPhone 14-Pro": "46458949730540",
        
          "iPhone 14-Pro Max": "46458949763308",
        
          "iPhone 14-Plus": "46458949796076",
        
          "iPhone 15-Base": "46458949828844",
        
          "iPhone 15-Pro": "46458949861612",
        
          "iPhone 15-Pro Max": "46458949894380",
        
          "iPhone 15-Plus": "46458949927148",
        
          "iPhone 16-Base": "46458949959916",
        
          "iPhone 16-Pro": "46458949992684",
        
          "iPhone 16-Pro Max": "46458950025452",
        
          "iPhone 16-Plus": "46458950058220",
        
          "iPhone 17-Base": "47035533721836",
        
          "iPhone 17-Pro": "47035533754604",
        
          "iPhone 17-Pro Max": "47035533787372",
        
          "iPhone 17-Air": "47035533820140",
        
          "iPhone 16-E": "47189448655084"
        
      },
    
      "Patola Ikat precision 2": {
        
          "iPhone 12-Base": "46458948387052",
        
          "iPhone 12-Pro": "46458948419820",
        
          "iPhone 12-Pro Max": "46458948452588",
        
          "iPhone 12-Mini": "46458948485356",
        
          "iPhone 13-Base": "46458948518124",
        
          "iPhone 13-Pro": "46458948550892",
        
          "iPhone 13-Pro Max": "46458948583660",
        
          "iPhone 13-Mini": "46458948616428",
        
          "iPhone 14-Base": "46458948649196",
        
          "iPhone 14-Pro": "46458948681964",
        
          "iPhone 14-Pro Max": "46458948714732",
        
          "iPhone 14-Plus": "46458948747500",
        
          "iPhone 15-Base": "46458948780268",
        
          "iPhone 15-Pro": "46458948813036",
        
          "iPhone 15-Pro Max": "46458948845804",
        
          "iPhone 15-Plus": "46458948878572",
        
          "iPhone 16-Base": "46458948911340",
        
          "iPhone 16-Pro": "46458948944108",
        
          "iPhone 16-Pro Max": "46458948976876",
        
          "iPhone 16-Plus": "46458949009644",
        
          "iPhone 17-Base": "46889592094956",
        
          "iPhone 17-Air": "46889592127724",
        
          "iPhone 17-Pro": "46889592160492",
        
          "iPhone 17-Pro Max": "46889592193260",
        
          "iPhone 16-E": "47189448622316"
        
      },
    
      "Patola Ikat precision 1": {
        
          "iPhone 12-Base": "46458947109100",
        
          "iPhone 12-Pro": "46458947141868",
        
          "iPhone 12-Pro Max": "46458947174636",
        
          "iPhone 12-Mini": "46458947207404",
        
          "iPhone 13-Base": "46458947240172",
        
          "iPhone 13-Pro": "46458947272940",
        
          "iPhone 13-Pro Max": "46458947305708",
        
          "iPhone 13-Mini": "46458947338476",
        
          "iPhone 14-Base": "46458947371244",
        
          "iPhone 14-Pro": "46458947404012",
        
          "iPhone 14-Pro Max": "46458947436780",
        
          "iPhone 14-Plus": "46458947469548",
        
          "iPhone 15-Base": "46458947502316",
        
          "iPhone 15-Pro": "46458947535084",
        
          "iPhone 15-Pro Max": "46458947567852",
        
          "iPhone 15-Plus": "46458947600620",
        
          "iPhone 16-Base": "46458947633388",
        
          "iPhone 16-Pro": "46458947666156",
        
          "iPhone 16-Pro Max": "46458947698924",
        
          "iPhone 16-Plus": "46458947731692",
        
          "iPhone 17-Base": "46889592226028",
        
          "iPhone 17-Air": "46889592258796",
        
          "iPhone 17-Pro": "46889592291564",
        
          "iPhone 17-Pro Max": "46889592324332",
        
          "iPhone 16-E": "47189448589548"
        
      },
    
      "Banarasi floral brocade 2": {
        
          "iPhone 12-Base": "46458945536236",
        
          "iPhone 12-Pro": "46458945569004",
        
          "iPhone 12-Pro Max": "46458945601772",
        
          "iPhone 12-Mini": "46458945634540",
        
          "iPhone 13-Base": "46458945667308",
        
          "iPhone 13-Pro": "46458945700076",
        
          "iPhone 13-Pro Max": "46458945732844",
        
          "iPhone 13-Mini": "46458945765612",
        
          "iPhone 14-Base": "46458945798380",
        
          "iPhone 14-Pro": "46458945831148",
        
          "iPhone 14-Pro Max": "46458945863916",
        
          "iPhone 14-Plus": "46458945896684",
        
          "iPhone 15-Base": "46458945929452",
        
          "iPhone 15-Pro": "46458945962220",
        
          "iPhone 15-Pro Max": "46458945994988",
        
          "iPhone 15-Plus": "46458946027756",
        
          "iPhone 16-Base": "46458946060524",
        
          "iPhone 16-Pro": "46458946093292",
        
          "iPhone 16-Pro Max": "46458946126060",
        
          "iPhone 16-Plus": "46458946158828",
        
          "iPhone 17-Base": "46889592357100",
        
          "iPhone 17-Air": "46889592389868",
        
          "iPhone 17-Pro": "46889592422636",
        
          "iPhone 17-Pro Max": "46889592455404",
        
          "iPhone 16-E": "47189448556780"
        
      },
    
      "Bagru block geometry 1": {
        
          "iPhone 12-Base": "46458942062828",
        
          "iPhone 12-Pro": "46458942095596",
        
          "iPhone 12-Pro Max": "46458942128364",
        
          "iPhone 12-Mini": "46458942161132",
        
          "iPhone 13-Base": "46458942193900",
        
          "iPhone 13-Pro": "46458942226668",
        
          "iPhone 13-Pro Max": "46458942259436",
        
          "iPhone 13-Mini": "46458942292204",
        
          "iPhone 14-Base": "46458942324972",
        
          "iPhone 14-Pro": "46458942357740",
        
          "iPhone 14-Pro Max": "46458942390508",
        
          "iPhone 14-Plus": "46458942423276",
        
          "iPhone 15-Base": "46458942456044",
        
          "iPhone 15-Pro": "46458942488812",
        
          "iPhone 15-Pro Max": "46458942521580",
        
          "iPhone 15-Plus": "46458942554348",
        
          "iPhone 16-Base": "46458942587116",
        
          "iPhone 16-Pro": "46458942619884",
        
          "iPhone 16-Pro Max": "46458942652652",
        
          "iPhone 16-Plus": "46458942685420",
        
          "iPhone 17-Base": "46889592488172",
        
          "iPhone 17-Air": "46889592520940",
        
          "iPhone 17-Pro": "46889592553708",
        
          "iPhone 17-Pro Max": "46889592586476",
        
          "iPhone 16-E": "47189448458476"
        
      },
    
      "Pichwai Lotus 2": {
        
          "iPhone 12-Base": "46458938654956",
        
          "iPhone 12-Pro": "46458938687724",
        
          "iPhone 12-Pro Max": "46458938720492",
        
          "iPhone 12-Mini": "46458938753260",
        
          "iPhone 13-Base": "46458938786028",
        
          "iPhone 13-Pro": "46458938818796",
        
          "iPhone 13-Pro Max": "46458938851564",
        
          "iPhone 13-Mini": "46458938884332",
        
          "iPhone 14-Base": "46458938917100",
        
          "iPhone 14-Pro": "46458938949868",
        
          "iPhone 14-Pro Max": "46458938982636",
        
          "iPhone 14-Plus": "46458939015404",
        
          "iPhone 15-Base": "46458939048172",
        
          "iPhone 15-Pro": "46458939080940",
        
          "iPhone 15-Pro Max": "46458939113708",
        
          "iPhone 15-Plus": "46458939146476",
        
          "iPhone 16-Base": "46458939179244",
        
          "iPhone 16-Pro": "46458939212012",
        
          "iPhone 16-Pro Max": "46458939244780",
        
          "iPhone 16-Plus": "46458939277548",
        
          "iPhone 17-Base": "46889592619244",
        
          "iPhone 17-Air": "46889592652012",
        
          "iPhone 17-Pro": "46889592684780",
        
          "iPhone 17-Pro Max": "46889592717548",
        
          "iPhone 16-E": "47189448425708"
        
      },
    
      "Ajrakh geometric grid": {
        
          "iPhone 12-Base": "46458934919404",
        
          "iPhone 12-Pro": "46458934952172",
        
          "iPhone 12-Pro Max": "46458934984940",
        
          "iPhone 12-Mini": "46458935017708",
        
          "iPhone 13-Base": "46458935050476",
        
          "iPhone 13-Pro": "46458935083244",
        
          "iPhone 13-Pro Max": "46458935116012",
        
          "iPhone 13-Mini": "46458935148780",
        
          "iPhone 14-Base": "46458935181548",
        
          "iPhone 14-Pro": "46458935214316",
        
          "iPhone 14-Pro Max": "46458935247084",
        
          "iPhone 14-Plus": "46458935279852",
        
          "iPhone 15-Base": "46458935312620",
        
          "iPhone 15-Pro": "46458935345388",
        
          "iPhone 15-Pro Max": "46458935378156",
        
          "iPhone 15-Plus": "46458935410924",
        
          "iPhone 16-Base": "46458935443692",
        
          "iPhone 16-Pro": "46458935476460",
        
          "iPhone 16-Pro Max": "46458935509228",
        
          "iPhone 16-Plus": "46458935541996",
        
          "iPhone 17-Base": "46889592750316",
        
          "iPhone 17-Air": "46889592783084",
        
          "iPhone 17-Pro": "46889592815852",
        
          "iPhone 17-Pro Max": "46889592848620",
        
          "iPhone 16-E": "47189448392940"
        
      },
    
      "Gond line mesh": {
        
          "iPhone 12-Base": "46436871405804",
        
          "iPhone 12-Pro": "46436871438572",
        
          "iPhone 12-Pro Max": "46436871471340",
        
          "iPhone 12-Mini": "46440150597868",
        
          "iPhone 13-Base": "46436871504108",
        
          "iPhone 13-Pro": "46436871536876",
        
          "iPhone 13-Pro Max": "46436871569644",
        
          "iPhone 13-Mini": "46440150630636",
        
          "iPhone 14-Base": "46436871602412",
        
          "iPhone 14-Pro": "46436871635180",
        
          "iPhone 14-Pro Max": "46436871667948",
        
          "iPhone 14-Plus": "46436871700716",
        
          "iPhone 15-Base": "46436871733484",
        
          "iPhone 15-Pro": "46436871766252",
        
          "iPhone 15-Pro Max": "46436871799020",
        
          "iPhone 15-Plus": "46436871831788",
        
          "iPhone 16-Base": "46436871864556",
        
          "iPhone 16-Pro": "46436871897324",
        
          "iPhone 16-Pro Max": "46436871930092",
        
          "iPhone 16-Plus": "46436871962860",
        
          "iPhone 17-Base": "46889592881388",
        
          "iPhone 17-Air": "46889592914156",
        
          "iPhone 17-Pro": "46889592946924",
        
          "iPhone 17-Pro Max": "46889592979692",
        
          "iPhone 16-E": "47189448196332"
        
      },
    
      "Kutch embroidery motif 2": {
        
          "iPhone 12-Base": "46436868423916",
        
          "iPhone 12-Pro": "46436868456684",
        
          "iPhone 12-Pro Max": "46436868489452",
        
          "iPhone 12-Mini": "46440153186540",
        
          "iPhone 13-Base": "46436868522220",
        
          "iPhone 13-Pro": "46436868554988",
        
          "iPhone 13-Pro Max": "46436868587756",
        
          "iPhone 13-Mini": "46440153219308",
        
          "iPhone 14-Base": "46436868620524",
        
          "iPhone 14-Pro": "46436868653292",
        
          "iPhone 14-Pro Max": "46436868686060",
        
          "iPhone 14-Plus": "46436868718828",
        
          "iPhone 15-Base": "46436868751596",
        
          "iPhone 15-Pro": "46436868784364",
        
          "iPhone 15-Pro Max": "46436868817132",
        
          "iPhone 15-Plus": "46436868849900",
        
          "iPhone 16-Base": "46436868882668",
        
          "iPhone 16-Pro": "46436868915436",
        
          "iPhone 16-Pro Max": "46436868948204",
        
          "iPhone 16-Plus": "46436868980972",
        
          "iPhone 17-Base": "46889593012460",
        
          "iPhone 17-Air": "46889593045228",
        
          "iPhone 17-Pro": "46889593077996",
        
          "iPhone 17-Pro Max": "46889593110764",
        
          "iPhone 16-E": "47189448163564"
        
      },
    
      "Kutch embroidery motif 1": {
        
          "iPhone 12-Base": "46436867408108",
        
          "iPhone 12-Pro": "46436867440876",
        
          "iPhone 12-Pro Max": "46436867473644",
        
          "iPhone 12-Mini": "46440157839596",
        
          "iPhone 13-Base": "46436867506412",
        
          "iPhone 13-Pro": "46436867539180",
        
          "iPhone 13-Pro Max": "46436867571948",
        
          "iPhone 13-Mini": "46440157872364",
        
          "iPhone 14-Base": "46436867604716",
        
          "iPhone 14-Pro": "46436867637484",
        
          "iPhone 14-Pro Max": "46436867670252",
        
          "iPhone 14-Plus": "46436867703020",
        
          "iPhone 15-Base": "46436867735788",
        
          "iPhone 15-Pro": "46436867768556",
        
          "iPhone 15-Pro Max": "46436867801324",
        
          "iPhone 15-Plus": "46436867834092",
        
          "iPhone 16-Base": "46436867866860",
        
          "iPhone 16-Pro": "46436867899628",
        
          "iPhone 16-Pro Max": "46436867932396",
        
          "iPhone 16-Plus": "46436867965164",
        
          "iPhone 17-Base": "46889593143532",
        
          "iPhone 17-Air": "46889593176300",
        
          "iPhone 17-Pro": "46889593209068",
        
          "iPhone 17-Pro Max": "46889593241836",
        
          "iPhone 16-E": "47189448130796"
        
      },
    
      "Flowery essentials 4 red": {
        
          "iPhone 12-Base": "46435335995628",
        
          "iPhone 12-Pro": "46435336028396",
        
          "iPhone 12-Pro Max": "46435336061164",
        
          "iPhone 12-Mini": "46440595456236",
        
          "iPhone 13-Base": "46435336093932",
        
          "iPhone 13-Pro": "46435336126700",
        
          "iPhone 13-Pro Max": "46435336159468",
        
          "iPhone 13-Mini": "46440595489004",
        
          "iPhone 14-Base": "46435336192236",
        
          "iPhone 14-Pro": "46435336225004",
        
          "iPhone 14-Pro Max": "46435336257772",
        
          "iPhone 14-Plus": "46435336290540",
        
          "iPhone 15-Base": "46435336323308",
        
          "iPhone 15-Pro": "46435336356076",
        
          "iPhone 15-Pro Max": "46435336388844",
        
          "iPhone 15-Plus": "46435336421612",
        
          "iPhone 16-Base": "46435336454380",
        
          "iPhone 16-Pro": "46435336487148",
        
          "iPhone 16-Pro Max": "46435336519916",
        
          "iPhone 16-Plus": "46435336552684",
        
          "iPhone 17-Base": "46889593274604",
        
          "iPhone 17-Air": "46889593307372",
        
          "iPhone 17-Pro": "46889593340140",
        
          "iPhone 17-Pro Max": "46889593372908",
        
          "iPhone 16-E": "47189447901420"
        
      },
    
      "Flowery essentials 3 yellow": {
        
          "iPhone 12-Base": "46435334619372",
        
          "iPhone 12-Pro": "46435334652140",
        
          "iPhone 12-Pro Max": "46435334684908",
        
          "iPhone 12-Mini": "46440595914988",
        
          "iPhone 13-Base": "46435334717676",
        
          "iPhone 13-Pro": "46435334750444",
        
          "iPhone 13-Pro Max": "46435334783212",
        
          "iPhone 13-Mini": "46440595947756",
        
          "iPhone 14-Base": "46435334815980",
        
          "iPhone 14-Pro": "46435334848748",
        
          "iPhone 14-Pro Max": "46435334881516",
        
          "iPhone 14-Plus": "46435334914284",
        
          "iPhone 15-Base": "46435334947052",
        
          "iPhone 15-Pro": "46435334979820",
        
          "iPhone 15-Pro Max": "46435335012588",
        
          "iPhone 15-Plus": "46435335045356",
        
          "iPhone 16-Base": "46435335078124",
        
          "iPhone 16-Pro": "46435335110892",
        
          "iPhone 16-Pro Max": "46435335143660",
        
          "iPhone 16-Plus": "46435335176428",
        
          "iPhone 17-Base": "46889593405676",
        
          "iPhone 17-Air": "46889593438444",
        
          "iPhone 17-Pro": "46889593471212",
        
          "iPhone 17-Pro Max": "46889593503980",
        
          "iPhone 16-E": "47189447868652"
        
      },
    
      "Flowery essentials 2 green": {
        
          "iPhone 12-Base": "46435330588908",
        
          "iPhone 12-Pro": "46435330621676",
        
          "iPhone 12-Pro Max": "46435330654444",
        
          "iPhone 12-Mini": "46440596439276",
        
          "iPhone 13-Base": "46435330687212",
        
          "iPhone 13-Pro": "46435330719980",
        
          "iPhone 13-Pro Max": "46435330752748",
        
          "iPhone 13-Mini": "46440596472044",
        
          "iPhone 14-Base": "46435330785516",
        
          "iPhone 14-Pro": "46435330818284",
        
          "iPhone 14-Pro Max": "46435330851052",
        
          "iPhone 14-Plus": "46435330883820",
        
          "iPhone 15-Base": "46435330916588",
        
          "iPhone 15-Pro": "46435330949356",
        
          "iPhone 15-Pro Max": "46435330982124",
        
          "iPhone 15-Plus": "46435331014892",
        
          "iPhone 16-Base": "46435331047660",
        
          "iPhone 16-Pro": "46435331080428",
        
          "iPhone 16-Pro Max": "46435331113196",
        
          "iPhone 16-Plus": "46435331145964",
        
          "iPhone 17-Base": "46889593536748",
        
          "iPhone 17-Air": "46889593569516",
        
          "iPhone 17-Pro": "46889593602284",
        
          "iPhone 17-Pro Max": "46889593635052",
        
          "iPhone 16-E": "47189447835884"
        
      },
    
      "Flowery essentials 1 pink": {
        
          "iPhone 12-Base": "46435328721132",
        
          "iPhone 12-Pro": "46435328753900",
        
          "iPhone 12-Pro Max": "46435328786668",
        
          "iPhone 12-Mini": "46440596832492",
        
          "iPhone 13-Base": "46435328819436",
        
          "iPhone 13-Pro": "46435328852204",
        
          "iPhone 13-Pro Max": "46435328884972",
        
          "iPhone 13-Mini": "46440596865260",
        
          "iPhone 14-Base": "46435328917740",
        
          "iPhone 14-Pro": "46435328950508",
        
          "iPhone 14-Pro Max": "46435328983276",
        
          "iPhone 14-Plus": "46435329016044",
        
          "iPhone 15-Base": "46435329048812",
        
          "iPhone 15-Pro": "46435329081580",
        
          "iPhone 15-Pro Max": "46435329114348",
        
          "iPhone 15-Plus": "46435329147116",
        
          "iPhone 16-Base": "46435329179884",
        
          "iPhone 16-Pro": "46435329212652",
        
          "iPhone 16-Pro Max": "46435329245420",
        
          "iPhone 16-Plus": "46435329278188",
        
          "iPhone 17-Base": "46889593766124",
        
          "iPhone 17-Air": "46889593798892",
        
          "iPhone 17-Pro": "46889593831660",
        
          "iPhone 17-Pro Max": "46889593864428",
        
          "iPhone 16-E": "47189447573740"
        
      },
    
      "Mughal court purple": {
        
          "iPhone 12-Base": "45953180106988",
        
          "iPhone 12-Pro": "45953180139756",
        
          "iPhone 12-Pro Max": "45953180172524",
        
          "iPhone 12-Mini": "46440719253740",
        
          "iPhone 13-Base": "45953180205292",
        
          "iPhone 13-Pro": "45953180238060",
        
          "iPhone 13-Pro Max": "45953180270828",
        
          "iPhone 13-Mini": "46440719286508",
        
          "iPhone 14-Base": "45953180303596",
        
          "iPhone 14-Pro": "45953180336364",
        
          "iPhone 14-Pro Max": "45953180369132",
        
          "iPhone 14-Plus": "45953180401900",
        
          "iPhone 15-Base": "45953180434668",
        
          "iPhone 15-Pro": "45953180467436",
        
          "iPhone 15-Pro Max": "45953180500204",
        
          "iPhone 15-Plus": "45953180532972",
        
          "iPhone 16-Base": "45953180565740",
        
          "iPhone 16-Pro": "45953180598508",
        
          "iPhone 16-Pro Max": "45953180631276",
        
          "iPhone 16-Plus": "45953180664044",
        
          "iPhone 17-Base": "46889595273452",
        
          "iPhone 17-Air": "46889595306220",
        
          "iPhone 17-Pro": "46889595338988",
        
          "iPhone 17-Pro Max": "46889595371756",
        
          "iPhone 16-E": "47189447475436"
        
      },
    
      "Parizat": {
        
          "iPhone 12-Base": "45953182073068",
        
          "iPhone 12-Pro": "45953182105836",
        
          "iPhone 12-Pro Max": "45953182138604",
        
          "iPhone 12-Mini": "46440729116908",
        
          "iPhone 13-Base": "45953182171372",
        
          "iPhone 13-Pro": "45953182204140",
        
          "iPhone 13-Pro Max": "45953182236908",
        
          "iPhone 13-Mini": "46440729149676",
        
          "iPhone 14-Base": "45953182269676",
        
          "iPhone 14-Pro": "45953182302444",
        
          "iPhone 14-Pro Max": "45953182335212",
        
          "iPhone 14-Plus": "45953182367980",
        
          "iPhone 15-Base": "45953182400748",
        
          "iPhone 15-Pro": "45953182433516",
        
          "iPhone 15-Pro Max": "45953182466284",
        
          "iPhone 15-Plus": "45953182499052",
        
          "iPhone 16-Base": "45953182531820",
        
          "iPhone 16-Pro": "45953182564588",
        
          "iPhone 16-Pro Max": "45953182597356",
        
          "iPhone 16-Plus": "45953182630124",
        
          "iPhone 17-Base": "46889595633900",
        
          "iPhone 17-Air": "46889595666668",
        
          "iPhone 17-Pro": "46889595699436",
        
          "iPhone 17-Pro Max": "46889595732204",
        
          "iPhone 16-E": "47189447442668"
        
      },
    
      "Hibiscus": {
        
          "iPhone 12-Base": "45953188888812",
        
          "iPhone 12-Pro": "45953188921580",
        
          "iPhone 12-Pro Max": "45953188954348",
        
          "iPhone 12-Mini": "46440763719916",
        
          "iPhone 13-Base": "45953188987116",
        
          "iPhone 13-Pro": "45953189019884",
        
          "iPhone 13-Pro Max": "45953189052652",
        
          "iPhone 13-Mini": "46440763752684",
        
          "iPhone 14-Base": "45953189085420",
        
          "iPhone 14-Pro": "45953189118188",
        
          "iPhone 14-Pro Max": "45953189150956",
        
          "iPhone 14-Plus": "45953189183724",
        
          "iPhone 15-Base": "45953189216492",
        
          "iPhone 15-Pro": "45953189249260",
        
          "iPhone 15-Pro Max": "45953189282028",
        
          "iPhone 15-Plus": "45953189314796",
        
          "iPhone 16-Base": "45953189347564",
        
          "iPhone 16-Pro": "45953189380332",
        
          "iPhone 16-Pro Max": "45953189413100",
        
          "iPhone 16-Plus": "45953189445868",
        
          "iPhone 17-Base": "46889596322028",
        
          "iPhone 17-Air": "46889596354796",
        
          "iPhone 17-Pro": "46889596387564",
        
          "iPhone 17-Pro Max": "46889596420332",
        
          "iPhone 16-E": "47189447409900"
        
      },
    
      "Bougainvillea": {
        
          "iPhone 12-Base": "45953191477484",
        
          "iPhone 12-Pro": "45953191510252",
        
          "iPhone 12-Pro Max": "45953191543020",
        
          "iPhone 12-Mini": "46440775155948",
        
          "iPhone 13-Base": "45953191575788",
        
          "iPhone 13-Pro": "45953191608556",
        
          "iPhone 13-Pro Max": "45953191641324",
        
          "iPhone 13-Mini": "46440775188716",
        
          "iPhone 14-Base": "45953191674092",
        
          "iPhone 14-Pro": "45953191706860",
        
          "iPhone 14-Pro Max": "45953191739628",
        
          "iPhone 14-Plus": "45953191772396",
        
          "iPhone 15-Base": "45953191805164",
        
          "iPhone 15-Pro": "45953191837932",
        
          "iPhone 15-Pro Max": "45953191870700",
        
          "iPhone 15-Plus": "45953191903468",
        
          "iPhone 16-Base": "45953191936236",
        
          "iPhone 16-Pro": "45953191969004",
        
          "iPhone 16-Pro Max": "45953192001772",
        
          "iPhone 16-Plus": "45953192034540",
        
          "iPhone 17-Base": "46889596453100",
        
          "iPhone 17-Air": "46889596485868",
        
          "iPhone 17-Pro": "46889596518636",
        
          "iPhone 17-Pro Max": "46889596551404",
        
          "iPhone 16-E": "47189447377132"
        
      },
    
      "Mughal court black": {
        
          "iPhone 12-Base": "45953192067308",
        
          "iPhone 12-Pro": "45953192100076",
        
          "iPhone 12-Pro Max": "45953192132844",
        
          "iPhone 12-Mini": "46440778072300",
        
          "iPhone 13-Base": "45953192165612",
        
          "iPhone 13-Pro": "45953192198380",
        
          "iPhone 13-Pro Max": "45953192231148",
        
          "iPhone 13-Mini": "46440778105068",
        
          "iPhone 14-Base": "45953192263916",
        
          "iPhone 14-Pro": "45953192296684",
        
          "iPhone 14-Pro Max": "45953192329452",
        
          "iPhone 14-Plus": "45953192362220",
        
          "iPhone 15-Base": "45953192394988",
        
          "iPhone 15-Pro": "45953192427756",
        
          "iPhone 15-Pro Max": "45953192460524",
        
          "iPhone 15-Plus": "45953192493292",
        
          "iPhone 16-Base": "45953192526060",
        
          "iPhone 16-Pro": "45953192558828",
        
          "iPhone 16-Pro Max": "45953192591596",
        
          "iPhone 16-Plus": "45953192624364",
        
          "iPhone 17-Base": "46889596715244",
        
          "iPhone 17-Air": "46889596748012",
        
          "iPhone 17-Pro": "46889596780780",
        
          "iPhone 17-Pro Max": "46889596813548",
        
          "iPhone 16-E": "47189447344364"
        
      },
    
      "Flowers from a book - 8": {
        
          "iPhone 12-Base": "45953196589292",
        
          "iPhone 12-Pro": "45953196622060",
        
          "iPhone 12-Pro Max": "45953196654828",
        
          "iPhone 12-Mini": "46440794423532",
        
          "iPhone 13-Base": "45953196687596",
        
          "iPhone 13-Pro": "45953196720364",
        
          "iPhone 13-Pro Max": "45953196753132",
        
          "iPhone 13-Mini": "46440794456300",
        
          "iPhone 14-Base": "45953196785900",
        
          "iPhone 14-Pro": "45953196818668",
        
          "iPhone 14-Pro Max": "45953196851436",
        
          "iPhone 14-Plus": "45953196884204",
        
          "iPhone 15-Base": "45953196916972",
        
          "iPhone 15-Pro": "45953196949740",
        
          "iPhone 15-Pro Max": "45953196982508",
        
          "iPhone 15-Plus": "45953197015276",
        
          "iPhone 16-Base": "45953197048044",
        
          "iPhone 16-Pro": "45953197080812",
        
          "iPhone 16-Pro Max": "45953197113580",
        
          "iPhone 16-Plus": "45953197146348",
        
          "iPhone 17-Base": "46889596977388",
        
          "iPhone 17-Air": "46889597010156",
        
          "iPhone 17-Pro": "46889597042924",
        
          "iPhone 17-Pro Max": "46889597075692",
        
          "iPhone 16-E": "47189447278828"
        
      },
    
      "Flowers from a book - 5": {
        
          "iPhone 12-Base": "45953198424300",
        
          "iPhone 12-Pro": "45953198457068",
        
          "iPhone 12-Pro Max": "45953198489836",
        
          "iPhone 12-Mini": "46440800256236",
        
          "iPhone 13-Base": "45953198522604",
        
          "iPhone 13-Pro": "45953198555372",
        
          "iPhone 13-Pro Max": "45953198588140",
        
          "iPhone 13-Mini": "46440800289004",
        
          "iPhone 14-Base": "45953198620908",
        
          "iPhone 14-Pro": "45953198653676",
        
          "iPhone 14-Pro Max": "45953198686444",
        
          "iPhone 14-Plus": "45953198719212",
        
          "iPhone 15-Base": "45953198751980",
        
          "iPhone 15-Pro": "45953198784748",
        
          "iPhone 15-Pro Max": "45953198817516",
        
          "iPhone 15-Plus": "45953198850284",
        
          "iPhone 16-Base": "45953198883052",
        
          "iPhone 16-Pro": "45953198915820",
        
          "iPhone 16-Pro Max": "45953198948588",
        
          "iPhone 16-Plus": "45953198981356",
        
          "iPhone 17-Base": "46889597108460",
        
          "iPhone 17-Air": "46889597141228",
        
          "iPhone 17-Pro": "46889597173996",
        
          "iPhone 17-Pro Max": "46889597206764",
        
          "iPhone 16-E": "47189447213292"
        
      },
    
      "Flowers from a book - 4": {
        
          "iPhone 12-Base": "45953199014124",
        
          "iPhone 12-Pro": "45953199046892",
        
          "iPhone 12-Pro Max": "45953199079660",
        
          "iPhone 12-Mini": "46440801992940",
        
          "iPhone 13-Base": "45953199112428",
        
          "iPhone 13-Pro": "45953199145196",
        
          "iPhone 13-Pro Max": "45953199177964",
        
          "iPhone 13-Mini": "46440802025708",
        
          "iPhone 14-Base": "45953199210732",
        
          "iPhone 14-Pro": "45953199243500",
        
          "iPhone 14-Pro Max": "45953199276268",
        
          "iPhone 14-Plus": "45953199309036",
        
          "iPhone 15-Base": "45953199341804",
        
          "iPhone 15-Pro": "45953199374572",
        
          "iPhone 15-Pro Max": "45953199407340",
        
          "iPhone 15-Plus": "45953199440108",
        
          "iPhone 16-Base": "45953199472876",
        
          "iPhone 16-Pro": "45953199505644",
        
          "iPhone 16-Pro Max": "45953199538412",
        
          "iPhone 16-Plus": "45953199571180",
        
          "iPhone 17-Base": "46889597239532",
        
          "iPhone 17-Air": "46889597272300",
        
          "iPhone 17-Pro": "46889597305068",
        
          "iPhone 17-Pro Max": "46889597337836",
        
          "iPhone 16-E": "47189446492396"
        
      },
    
      "Flowers from a book - 3": {
        
          "iPhone 12-Base": "45953199636716",
        
          "iPhone 12-Pro": "45953199669484",
        
          "iPhone 12-Pro Max": "45953199702252",
        
          "iPhone 12-Mini": "46440803631340",
        
          "iPhone 13-Base": "45953199735020",
        
          "iPhone 13-Pro": "45953199767788",
        
          "iPhone 13-Pro Max": "45953199800556",
        
          "iPhone 13-Mini": "46440803664108",
        
          "iPhone 14-Base": "45953199833324",
        
          "iPhone 14-Pro": "45953199866092",
        
          "iPhone 14-Pro Max": "45953199898860",
        
          "iPhone 14-Plus": "45953199931628",
        
          "iPhone 15-Base": "45953199964396",
        
          "iPhone 15-Pro": "45953199997164",
        
          "iPhone 15-Pro Max": "45953200029932",
        
          "iPhone 15-Plus": "45953200062700",
        
          "iPhone 16-Base": "45953200095468",
        
          "iPhone 16-Pro": "45953200128236",
        
          "iPhone 16-Pro Max": "45953200161004",
        
          "iPhone 16-Plus": "45953200193772",
        
          "iPhone 17-Base": "46889597698284",
        
          "iPhone 17-Air": "46889597731052",
        
          "iPhone 17-Pro": "46889597763820",
        
          "iPhone 17-Pro Max": "46889597796588",
        
          "iPhone 16-E": "47189420736748"
        
      },
    
      "Flowers from a book - 1": {
        
          "iPhone 15-Base": "45953200914668",
        
          "iPhone 15-Pro": "45953200947436",
        
          "iPhone 15-Pro Max": "45953200980204",
        
          "iPhone 15-Plus": "45953201012972",
        
          "iPhone 14-Base": "45953201045740",
        
          "iPhone 14-Pro": "45953201078508",
        
          "iPhone 14-Pro Max": "45953201111276",
        
          "iPhone 14-Plus": "45953201144044",
        
          "iPhone 16-Base": "45953201373420",
        
          "iPhone 16-Pro": "45953201406188",
        
          "iPhone 16-Pro Max": "45953201438956",
        
          "iPhone 16-Plus": "45953201471724",
        
          "iPhone 16-E": "47189278753004",
        
          "iPhone 17-Base": "46889597829356",
        
          "iPhone 17-Pro": "46889597894892",
        
          "iPhone 17-Pro Max": "46889597927660",
        
          "iPhone 17-Air": "46889597862124",
        
          "iPhone 12-Base": "47189414215916",
        
          "iPhone 12-Pro": "47189414248684",
        
          "iPhone 12-Pro Max": "47189414281452",
        
          "iPhone 12-Mini": "47189414314220",
        
          "iPhone 13-Base": "47189415624940",
        
          "iPhone 13-Pro": "47189415657708",
        
          "iPhone 13-Pro Max": "47189415690476",
        
          "iPhone 13-Mini": "47189415723244"
        
      }
    
  
};
  